import Const from "../constants/Constants";
import ParticipantCollection from "./ParticipantCollection";
import ParticipantModel from "./model/ParticipantModel";
import ParticipantView from "./view/ParticipantView"; 
//import HostParticipantView from "./view/HostParticipantView";
import Util from "./Util";
import SessionDataStore from "./SessionDataStoreController";
import RTM from "./RTM";
import axios from "axios";
import {browserName as browName,  isSafari as safari, isChrome as chrome, osName as osname, isTablet as tablete, isFirefox as is_ffox, isAndroid as android } from "react-device-detect";
import RTMConst from "../constants/Rtmconstants";
import hostlanguage from '../services/contentData';

import recordingSession from "../utils/recordingSession";
import audioPlay from "../utils/audioPlay";

import { loadWhiteboard } from '../utils/whiteboard';
import { storeRTM } from '../utils/storeRTM';
import coneDrawing from "../utils/coneDrawing";
import store from "../store"

import whiteboard from "../utils/whiteboardNew";
import { updatesse } from "../utils/updatesse";
import secondaryWindow from "../utils/secondaryWindow";
const dispatch = store.dispatch;

function startHostStreaming(){
  var $ = window.$ || {};

  var $Any = window.$Any || {};

  var AgoraRTM = window.AgoraRTM;
  var AgoraRTC = window.AgoraElectron ? window.AgoraElectron : window.AgoraRTC;
  var collection = new ParticipantCollection();
  var sessionDataStore = SessionDataStore.getInstance();
  var newclient = window.newclient; 
  var channel = window.channel;
  var recordingmime = 'mp4';
  var rtm = RTM.getInstance();
  var myLocaltream;
  var main_mic_id;
  var soundPlay = window.soundPlay ? window.soundPlay : new audioPlay();
  var coneDraw = new coneDrawing();
  var drawSplitArray = {};
  var allParticipantsRoomSetup = {};
  var secondaryWindowCall = new secondaryWindow();

  window['main_mic_id'] = null;
  window['videoDuration'] = null;
  window['canvasOn'] = false;
  window['participantElectron'] = false;
  window['collection'] = collection;
  window['primaryWindow'] = true;
  window['clickedOnLeave'] = false;
  
  var recordSession = new recordingSession();
  window['recordSessionGlobal'] = recordSession;

  if(!AgoraRTC.checkSystemRequirements()) {
      alert(hostlanguage.browserNotSupport);
  }
  
  if ( !window['userWhiteboard'] ) { window['userWhiteboard'] = {}; }

  var client, localStream, microphone;
  
  var sep = '~@$';
  var allowParticipantHighlight = false;
  var saveParId;
  var retryCounter = 0;
  var rtmRetryCounter = 0;
  var localStats = [];
  var streamPublished = false,
      currentUserData = JSON.parse(localStorage.getItem("userData")),
      streamArray = [],
  	  remoteInjectStreamId = 0,
      userArray   = [],
      unmuteAllEnabled = false,             // flat to check whether unmute all is enabled or not
      calcOnscreenTime = true,              // flag for whether or not to check onscreen time of Participant.
      scriptSynced     = false,
      localAudioMuted = false,
      remoteEvent = null,
      userLogout = false,
      alreadyLeftAll = false,
      networkQualityArray = [],
      dualStreamEnabled = false,
      recordingStartedTime = null,
      scriptIndexCounter = -1,
      streamSelectedArray = [],            // array to tore all selected streams
      showEmojis = false,
      publishStreamError = false,
      rtcInterval = null,
      isOnline = true,
      rtmMethodTriggered = false,
      previousDeviceVolume = 255,
      streamInitialized = false,
	  lastBagHitTime = 0,
	  cameraIndex = -1;
	var hostStartedFitnessScript = false;
	var instructorMuteAll = false;
	var mutedParticipantsByHost = [];
	var localStreamArray2 = [];

	
	var rtmAppId = currentUserData.rtmAppId,
      rtmChannelId = currentUserData.sessionData.rtmChannelId,
      token = null,
      peer = currentUserData.email,
      maxOnscreenLimit = currentUserData.default.maxUserLimit,
      selectedLimit = null,
      groupId = currentUserData.sessionData.groupId;

	var localStatsTimer = 5000,               // timer every 5 sec to get local stats
      streamSetToLow = false,               // flag to check remote streams has been set to low or not
      previousNetworkQuality = 6;           // Previous Network Test Quality, allows to reduce processing by only performing functions if it changes
	
	var notification = new Audio('./audio/notify.mp3');
	var emojiNotification = new Audio('./audio/emoji_notify.wav');

	window['currentUserData'] = currentUserData;
	window['userArray'] = userArray;
	window['tablete'] = tablete;
	window['android'] = android;
	window.allparti = streamArray;
	var usersOnScreen = [];
	var usersOnScreenCurrent = [];
	var currentStreamingDiv = 'host_video';
	var participantsSelfMuted = [];
	var streamZoomedOpen = false;
	var rejoinBtnPressed = false;
	window.leaveBtnPressed = false;
	var completedBtnPressed = false;
	var usersOnline = {};
	var rtmStoreMessages = {};
	
	if ( window['electron'] )
		{
			window['deviceNotSupported'+currentUserData.id] = false;
		}
	else
		{	
			window['deviceNotSupported'+currentUserData.id] = true;
		}
	

	if ( window['switchMembersInterval'] ) { clearInterval(window['switchMembersInterval']); window['switchMembersInterval'] = null; }


	function rtmJoin() {
		if ( newclient == undefined || channel == undefined )
			{
				newclient = AgoraRTM.createInstance(rtmAppId, { enableLogUpload: false, logFilter: AgoraRTM.LOG_FILTER_OFF });
				
				newclient.on('MessageFromPeer', (message, peerId) => { 
					console.log('MessageFromPeer - ', message.text, peerId);
					signalHandler(peerId, message.text, currentUserData.userType);
				});
				
				newclient.on('ConnectionStateChanged', (newState, reason) => {
					console.log('connectionstate changed to: ' + newState + ' reason: ' + reason);
					if ( reason == hostlanguage.remoteLogin ) 
						{
							newclient.logout();
							logoutRemoteUser();
							$Any('#multi-device-login-alert').modal('show');

							let addObject = {"sessionId": currentUserData.sessionData.id, "event": "status", "eventType": "logout", "userId": currentUserData.id, "details": JSON.stringify({"status":"success", "msg": "Remote Login"}), "timestamp": Util.getCurrentTimestamp()};
							sessionDataStore.addSessionData(addObject);
						}
					else
						{
							if ((newState == hostlanguage.aborted || newState == hostlanguage.disconnected) && (reason == hostlanguage.loginTimeout || reason == hostlanguage.intrupted || reason == hostlanguage.remoteLogin || reason ==  hostlanguage.loginFailure || reason ==  hostlanguage.bannedByServer)) {							
								newclient.logout();
								setTimeout(doClientLogin, 500);
							}
						}
				});
				doClientLogin();
				
				if ( window['sendSyncToRemote'] )
					{
						window['sendSyncToRemote']();
					}
			}
	}
	
	function doClientLogin(){
		console.log('doClientLogin ********************************');
		newclient.login({ token: token, uid: peer }).then(() => {
			channel = newclient.createChannel(rtmChannelId);
			console.log('channel1*************************************', channel);
			
			console.log('channel2*************************************', channel); 
			channel.join().then(() => {
				console.log('channel.join*************************************');
				window['nowCanStartSession']();
				$Any('#mic_control').trigger('click');
				if ( window.muteAllHandler ) { window.muteAllHandler(); }
				
				if ( window['electron'] )
					{
						localStream.muteVideo();
					}
				
				
				window['rtmChannelJoined'] = true;
				
				channel.on('MemberJoined', memberId => { 
					console.log('Member joined - ' + memberId);
					
					let remoteUser = memberId.includes("RM-");
					let userExists = true;
					if (remoteUser === false && window['sendSyncToRemote']) {
						userExists = checkSessionUser(memberId);
					}else if ( window['sendSyncToRemote'] ) {
						window['sendSyncToRemote']();
						window.updateFmMessage();
					}
					
					if ( memberId.includes("RM-") === false && userExists === true ) 
						{
							let userDetails = collection.getDetailsByEmail(memberId);
							let updateObject = {"isAvailableAtRTM": true};
							collection.updateModel(userDetails.id, JSON.stringify(updateObject));
							addUserAttribute(userDetails.id, 'isOnline', true);
							getParticipantInfo(userDetails.id);
							var userData = { email: memberId }
							$.ajax({
							  headers: { 
								  "Content-Type": "application/json; charset=utf-8"
							  },
							  url: Const.BASE_API_PATH+'/api/v1/user/checkUserExist',       
							  dataType: 'json',
							  type: 'post',
							  data: JSON.stringify(userData),
							success: function( data, textStatus, jQxhr ){
								let newName = data.responseData.firstName;
								let lastName = data.responseData.lastName;
								let newImage = data.responseData.image;
								if ( !data.responseData.image || data.responseData.image == 'null' || ( data.responseData.image !== '' && data.responseData.image.indexOf('.s3') == -1 ) )
									{
										newImage = './images/user_avatar.svg';
									}
								
								let updateObjectName = {"firstName" : newName, "lastName" : lastName, "image" : newImage};
								collection.updateModel(userDetails.id, JSON.stringify(updateObjectName));
								
								let currentTempUsers = JSON.parse(localStorage.getItem('tempUsers'));
								for ( var l = 0; l<currentTempUsers.length; l++ )
									{
										if ( currentTempUsers[l]['id'] == userDetails.id )
											{	
												currentTempUsers[l]['firstName'] = newName;
												currentTempUsers[l]['lastName'] = lastName;
												currentTempUsers[l]['image'] = newImage;
											}
									}
								localStorage.setItem("tempUsers", JSON.stringify(currentTempUsers));
								if ( window['updateSessionUsersList'] )
									{
										window['updateSessionUsersList']();
										window.displayParticipants();
									}
							}});
						}
					
					if ( userExists === false ) 
						{
							var userData = { email: memberId }
							$.ajax({
							  headers: { 
								  "Content-Type": "application/json; charset=utf-8"
							  },
							  url: Const.BASE_API_PATH+'/api/v1/user/checkUserExist',       
							  dataType: 'json',
							  type: 'post',
							  data: JSON.stringify(userData),
							  success: function( data, textStatus, jQxhr ){                         
								  data.responseData.userType = 2;
								  data.responseData.sessionStatus = 0;
								  data.responseData.isOnline = true;

								  if ( !data.responseData.image || data.responseData.image == 'null' || ( data.responseData.image !== '' && data.responseData.image.indexOf('.s3') == -1 ) )
								  {
									  data.responseData.image = './images/user_avatar.svg';
								  }
								  
								  addToSessionUsers(data.responseData);						  
								  getParticipantInfo(data.responseData.id);

								  if (window.pendingUsers && window.pendingUsers.length > 0) {
									  let userLength = window.pendingUsers.length;

									  for (let i = 0; i < userLength; i++) {

										  if (window.pendingUsers[i].senderId == memberId) {
											  channelMsgHandler(window.pendingUsers[i].message.text, memberId, currentUserData.userType);
											  window.pendingUsers.splice(i, 1);
										  }
									  }
								  }

								  let updateObject = {"isAvailableAtRTM": true};
								  collection.updateModel(data.responseData.id, JSON.stringify(updateObject));
								  let userDetails = data.responseData;
								  
							  },
							  error: function( jqXhr, textStatus, errorThrown ){
								  console.log( errorThrown );
							  }
						  });
						}
					
					$.ajax({
                      headers: { 
                          "Content-Type": "application/json; charset=utf-8"
                      },
                      url: Const.BASE_API_PATH+'/api/v1/user/checkUserExist',       
                      dataType: 'json',
                      type: 'post',
                      data: JSON.stringify(userData),
                      success: function( data, textStatus, jQxhr ){                         
                          data.responseData.userType = 2;
                          data.responseData.sessionStatus = 0;
                          data.responseData.isOnline = true;

                          if ( !data.responseData.image || data.responseData.image == 'null' || ( data.responseData.image !== '' && data.responseData.image.indexOf('.s3') == -1 ) )
                          {
                              data.responseData.image = './images/user_avatar.svg';
                          }
						  
                          addToSessionUsers(data.responseData);
						  console.log(data.responseData.id, 'addUserPallete 333');
						  getParticipantInfo(data.responseData.id);

                          if (window.pendingUsers && window.pendingUsers.length > 0) {
                              let userLength = window.pendingUsers.length;

                              for (let i = 0; i < userLength; i++) {

                                  if (window.pendingUsers[i].senderId == memberId) {
                                      channelMsgHandler(window.pendingUsers[i].message.text, memberId, currentUserData.userType);
                                      window.pendingUsers.splice(i, 1);
                                  }
                              }
                          }

                          let updateObject = {"isAvailableAtRTM": true};
                          collection.updateModel(data.responseData.id, JSON.stringify(updateObject));
						  let userDetails = data.responseData;
						  
                      },
                      error: function( jqXhr, textStatus, errorThrown ){
                          console.log( errorThrown );
                      }
                  });
				});
				
				channel.on('MemberLeft', memberId => {
					 let userData = collection.getDetailsByEmail(memberId);
					 console.log(userData);
					 deleteUserOnlineStatus(userData.id, true, true);
					 
					 if(memberId.includes("RM-") === false) {
						 
						setTimeout(function(){
							let text = hostlanguage.text1100 + sep;
							checkAvailableAtRTM(memberId, text);
						}, 10000);
					}
				});
				
				channel.on('ChannelMessage', window.onChannelMessage);

				channel.getMembers().then(async (members) => {
					const remoteIsOnline = typeof members.find((member) => {
						return member === `RM-${currentUserData.sessionData.hostEmail}`;
					}) !== "undefined";
					if (remoteIsOnline && window['sendSyncToRemote']) {
						console.log('Remote already online, sending autoSync');
						window['sendSyncToRemote']();
					}
				})
				
			}).catch(error => {     
              let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "type": "RTM Channel Join", "msg": error}), "timestamp": Util.getCurrentTimestamp()};
              sessionDataStore.addSessionData(addObject);
			});
		}).catch(err => {
			if( err.code == 9 )
				{
					doClientLogin();
				}
          
			let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "type": "RTM Login", "msg": err}), "timestamp": Util.getCurrentTimestamp()};
			sessionDataStore.addSessionData(addObject);
		});
	}
	window.checkUnreadMessages = () => {   
		var unreadMessagesNum = localStorage.getItem('unreadMessagesNum');
		if ( unreadMessagesNum )
			{
				unreadMessagesNum = parseInt(unreadMessagesNum);
				if ( $Any('#chat_menu').css('display') == 'none' )
					{
						var messagesCounter = $Any('#chat_counter').text();
						messagesCounter = parseInt(messagesCounter);
						messagesCounter = unreadMessagesNum + messagesCounter;
						$Any('#chat_counter').text(messagesCounter);
						$Any('#chat_counter').removeClass('d-none');
						localStorage.setItem('unreadMessagesNum', messagesCounter);
						localStorage.setItem('unreadMessagesClassId', currentUserData.sessionData.id);
					}
			}
		
	}
	
	window.setUserProfile = (profileType) => {      
		var profile = Const.HOST_RESOLUTION[profileType];
		if( window['electron'] )
			{
				if ( window.changeCameraRes )
					{
						window.changeCameraRes(profileType);
					}
			}
		else
			{
				localStream.setVideoProfile(profile);
			}
		
		
		currentUserData = JSON.parse(localStorage.getItem("userData"));
	}
	
	function rtcJoin(forceRejoin = false) {
		let camera = microphone = null;
		let speaker = null;
		let mediaIds = localStorage.getItem(hostlanguage.mediaSetting);
		
		if(mediaIds != undefined) {
			mediaIds = JSON.parse(mediaIds);
			
			if(mediaIds.camera != null && mediaIds.microphone != null) {
				camera = mediaIds.camera;
				microphone = mediaIds.microphone;

				if( window['electron'] ) { speaker = mediaIds.speaker; }
			} 
			else {
				console.log('something went wrong')
				return false;
			}
		}
		
		var channel_key = currentUserData.sessionData.streamToken != undefined ? currentUserData.sessionData.streamToken : null;
		
		if ( !window['electron'] ) 
			{
				AgoraRTC.Logger.enableLogUpload();
				AgoraRTC.Logger.setLogLevel(AgoraRTC.Logger.INFO);
			}
			
		// create client first
		client = AgoraRTC.createClient({mode: 'live', codec:'vp8'});

		
		if ( !window['electron'] && parseInt(currentUserData.default.setCloudProxy) === 1 )
			{
				client.startProxyServer(3);
			}
			
		client.init(currentUserData.sessionData.appId, function () {
			console.log('CLIENT INIT!!!');
			
			var channelName = currentUserData.sessionData.channelId;
			
			if ( window['electron'] )
				{
					client.setClientRole(1); // Host role
				}
				
			client.setEncryptionMode(process.env.REACT_APP_ENC_MODE);
			client.setEncryptionSecret(process.env.REACT_APP_ENC_SECRET);
			
			if (window['electron']){
				client.setAudioProfile();
			}
			
			client.join(channel_key, channelName.toString(), currentUserData.id, function(uid) {
				if ( !rtmMethodTriggered )
					{
						rtmMethodTriggered = true;
						rtmJoin();
					}
					
				if ( window['electron'] ) 
					{
						localStream = AgoraRTC.createStream({streamID: uid, audio: true, cameraId: camera, microphoneId: microphone, speakerId: speaker, video: true, screen: false, audioProcessing: {AEC: true, AGC: true, ANS: true} });
					}
				else
					{
						localStream = AgoraRTC.createStream({streamID: uid, audio: true, cameraId: camera, microphoneId: microphone, video: true, screen: false, audioProcessing: {AEC: true, AGC: true, ANS: true} });
					}
				
				myLocaltream = localStream;
				window.lstream = localStream;
				
				if ( window.setUserProfile )
					{
						window.setUserProfile(localStorage.getItem(hostlanguage.videoResolution));
					}
				
				if ( !window['electron'] )
					{
						if ( safari )
							{
								localStream.setAudioProfile(currentUserData.default.setAudioProfileWebSafari);
							}
						else
							{
								localStream.setAudioProfile(currentUserData.default.setAudioProfileWeb);
							}
					}
					
				enableDualStream();
				
				localStream.on("player-status-change", function(evt){
					if (evt.isErrorState && evt.status === "paused"){
						localStream.resume();
					}
				});
				
				
				localStream.init(function() {
					streamInitialized = true;
					setTimeout(()=>{
						localStream.play('host_video');
					}, 1000);
					
					window['mainLocalStream'] = localStream;
					 
					if ( window['electron'] )
						{
							window['mainLocalStream'].on("audioDeviceStateChanged", function(deviceId, deviceType, deviceState) {
								if ( deviceType == 1 )
									{
										let mediaIds = localStorage.getItem(hostlanguage.mediaSetting);
										mediaIds = JSON.parse(mediaIds); 
										
										if ( deviceState == 1 )
											{
												mediaIds['microphone'] = deviceId;
												mediaIds['speaker'] = '';
												localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));
												
												setTimeout(() => {
													getDevices( () => {                             
													  swithMicAndSpeaker(true);
													});
												}, 1000);
											}	
										else if ( ( deviceState == 4 || deviceState == 8 ) && deviceId == mediaIds['microphone'] )
											{
												mediaIds['microphone'] = '';
												mediaIds['speaker'] = '';
												localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds)); 
												
												setTimeout(() => {
													getDevices( () => {                             
													  swithMicAndSpeaker(true, deviceId);
													});
												}, 1000);
											}
										else if ( deviceType == 0 && deviceState == 16 )
											{
												let errMsg = 'You have an issue with your speaker - '+ deviceId +'. Kindly switch your speaker';
												let addObject = {"sessionId": currentUserData.sessionData.id, "event": "error", "eventType": "speaker", "userId": currentUserData.id, "details": JSON.stringify({"msg": errMsg}), "timestamp": Util.getCurrentTimestamp()};
												sessionDataStore.addSessionData(addObject);
											}
									}	
							});
							
							window['mainLocalStream'].on("videoDeviceStateChanged", function(deviceId, deviceType, deviceState) {
								if ( deviceState == 8 )
									{
										let mediaIds = localStorage.getItem(hostlanguage.mediaSetting);
										mediaIds = JSON.parse(mediaIds);
										
										if ( deviceId == mediaIds['camera'] ) 
											{
												mediaIds['camera'] = '';
												localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));
												
												getDevices( () => {
													
												});
											}
									}
							});
							
							
							window['mainLocalStream'].on("audioDeviceVolumeChanged", function(deviceType, volume, muted) {
								if ( deviceType == 1 )
									{
										if ( volume == 165 || volume == 191 )
											{
												window['globalAgora'].agora.setAudioRecordingVolume(previousDeviceVolume);
											}
										else
											{
												//window['globalAgora'].agora.setAudioRecordingVolume(volume);
												previousDeviceVolume = volume;
											}
									}
							});
							
						}
						
					if ( forceRejoin )
						{
							publish();
						}

					getLocalStats();
				}, function (err) {
					console.log("getUserMedia failed", err);
					let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.DEVICE, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "type": "streamInitialization", "msg": err.msg + ' | ' + err.info}), "timestamp": Util.getCurrentTimestamp()};
					sessionDataStore.addSessionData(addObject);
				});
			}, function(err) {
				console.log("Join channel failed", err);
				let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "type": "rtcJoin", "msg": err}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);
			});
			
		}, function (err) {
			console.log("AgoraRTC client init failed", err);
			let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "type": "rtc - client initialization", "msg": err}), "timestamp": Util.getCurrentTimestamp()};
			sessionDataStore.addSessionData(addObject);
		});
	

		var channelKey = "";
		client.on('error', function(err) {
		  console.log("Got error msg:", err.reason);
		  if (err.reason ===  hostlanguage.dynamicKeyTime) {
			client.renewChannelKey(channelKey, function(){
			  console.log("Renew channel key successfully");
			}, function(err){
			  console.log("Renew channel key failed: ", err);
			});
		  }

		  if ( err.reason === 'REQUEST_ABORT' && isOnline === true )
		  {
			  leave();
			  rtcJoin(true);
		  }
		});	
		
		rtcCallbacks();
	
		client.on("streamInjectedStatus", function(evt) {
			console.log('###streamInjectedStatus - ', evt);

			let addObject = {"sessionId": currentUserData.sessionData.id, "event": "injectStream", "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"reason": evt.reason, 'status': evt.status, "uid": evt.uid, "url": evt.url}), "timestamp": Util.getCurrentTimestamp()};
			sessionDataStore.addSessionData(addObject);

			if (evt.status == 1 && evt.uid == Const.STREAM_INJECT_UID)
				{
					window.removeInjectVideo(evt.url, true);
				} 
			else if (evt.status == 3 || evt.status == 4 || evt.status == 10) 
				{
					//$Any('#agora_local_inject').addClass('d-none');
					//$Any('#agora_local').removeClass('d-none');

					if (evt.url != undefined) {
						window.addInjectVideo(evt.url);
					} else {
						let injectedUrl = localStorage.getItem("injectedUrl");
						if (injectedUrl !== null) {
							window.addInjectVideo(injectedUrl);
						}
					}
				}		
		});
	
	client.on("connection-state-change", function(evt) {
        console.log('###connection-state-change - ', evt.prevState, evt.curState, evt);
        client.on("connection-state-change", function(evt) {
            console.log('###connection-state-change===', evt.prevState, evt.curState, evt);

            if ( evt.curState == 'DISCONNECTED' || evt.curState == 'DISCONNECTING' || evt.curState == 1 || evt.curState == 4 )
            {
                $Any('#poorNetwork').text('Network Disconnected');
                $Any('#poorNetwork').removeClass('d-none');
            }
            else if ( evt.curState == 'CONNECTING' || evt.curState == 2 )
            {
                $Any('#poorNetwork').text('Reconnecting...');
                $Any('#poorNetwork').removeClass('d-none');
            }
            else
            {
                $Any('#poorNetwork').text('');
                $Any('#poorNetwork').addClass('d-none');
            }
        });
    });
	
	client.on("crypt-error", function (evt) {
      console.log('crypt-error - ', evt.cryptType, evt);
    });

    client.on("recording-device-changed", function(evt) {
      console.log("Recording Device Changed - ", evt.state, evt.device, evt);
    });

    client.on("playout-device-changed", function(evt) {
      console.log("Playout Device Changed - ", evt.state, evt.device, evt);
    });

    client.on("rejoin", function(err) {
      console.log("rejoin");
      publishStreamError = false;
      publish();
    });
	
	client.on("camera-changed", function(evt) {
      console.log("Camera Changed - ", evt);

        if ( evt.state == "INACTIVE" ) // device is removed
        {
            let mediaIds = localStorage.getItem(hostlanguage.mediaSetting);
            mediaIds = JSON.parse(mediaIds);

            if ( evt.device.deviceId == mediaIds['camera'] )
            {
                mediaIds['camera'] = '';
                localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));

                getDevices( () => {
                 
                });
            }
        }
    });
	}
	
	function getLocalStats() {
		var checkStarted = false;
      setInterval(function(){
		if ( alreadyLeftAll ) { return false; }
		if ( checkStarted && window['electron'] ) { return false }
		checkStarted = true;
		
		localStream.getStats((stats) => {
		let statValue = Util.getLocalStatsValue(stats.accessDelay);
		localStats.push(statValue);

		if (localStats.length == 5) 
			{
				var statsMean = Util.calculateAccessDelayMean(localStats);

				  if (previousNetworkQuality != statsMean) {
					
					  setVideoConfiguration(statsMean);

					  networkQualityArray.push(statsMean);

					  if (networkQualityArray.length == 10) {
						  let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "network", "userId": currentUserData.id, "details": JSON.stringify({"action":"networkQuality", "value": networkQualityArray}), "timestamp": Util.getCurrentTimestamp()};
						  sessionDataStore.addSessionData(addObject);

						  networkQualityArray = [];
					  }
				  }

				  previousNetworkQuality = statsMean;

                  localStats.splice(0, 1);
			}
          });
      }, localStatsTimer);
  }
  
	function iterateParticipants() 
		{
			console.log('iterateParticipants**************');
			let userList = getTempUsers();
			for (var i = 0; i < userList.length; i++) 
				{
					userArray[userList[i].id] = userList[i].firstName;
					var  participantModelObj = new ParticipantModel();

					participantModelObj.id = userList[i].id;
					participantModelObj.sessionStatus = userList[i].sessionStatus;
					participantModelObj.firstName = userList[i].firstName;
					participantModelObj.lastName = userList[i].lastName;
					participantModelObj.email = userList[i].email;
					participantModelObj.image = userList[i].image;
					participantModelObj.userType = userList[i].userType;
					participantModelObj.currentStatus = userList[i].currentStatus !== undefined ? userList[i].currentStatus : null;
					participantModelObj.isVisible = userList[i].isSubscribe !== undefined ? (userList[i].isSubscribe === 1 ? true : false) : null;
					participantModelObj.subscribeTime = userList[i].subscribeTime !== undefined ? userList[i].subscribeTime : null;
					participantModelObj.loggedIn = userList[i].loggedIn !== undefined ? (userList[i].loggedIn === 1 ? true : false) : null;
					participantModelObj.cameraAccess = userList[i].cameraAccess !== undefined ? (userList[i].cameraAccess == 1 ? 'Granted' : 'Denied') : null;
					participantModelObj.micAccess = userList[i].micAccess !== undefined ? (userList[i].micAccess == 1 ? 'Granted' : 'Denied') : null;
					participantModelObj.broadcastVideo = userList[i].broadcastVideo !== undefined ? userList[i].broadcastVideo : null;
					participantModelObj.attendedClasses = userList[i].attendedClasses !== undefined ? userList[i].attendedClasses : null;
					collection.addModel(participantModelObj);
				}
		}
  
	window.logoutRemoteUser = logoutRemoteUser;
	function logoutRemoteUser() {
		leave();
	}
  
	function setVideoConfiguration(networkQuality) {
      if (networkQuality < 3) {
          setAllParticipantResolutionToLow();
      } else {
          setAllParticipantResolutionToHigh();
      }
  }
  
  function setAllParticipantResolutionToLow() {
      if (!streamSetToLow) {
          iterateAllStream(setParticipantResolutionToLow);
          streamSetToLow = true;
          showNetworkInfoHost('Poor Network');
      }
  }
  
  function showNetworkInfoHost(message) {
	  $Any('#poorNetwork').text(message);
	  $Any('#poorNetwork').removeClass('d-none');
  }
  
  function iterateAllStream(callback)
  {
    streamArray.forEach((stream)=>{
      if (stream.getId() != undefined) {
          callback(stream);
      }
    })
  }
  
  function setAllParticipantResolutionToHigh() {
      if (streamSetToLow) {
          iterateAllStream(setParticipantResolutionToHigh);
          streamSetToLow = false;
          $Any('#poorNetwork').text('');
          $Any('#poorNetwork').addClass('d-none');
      }
  }
	
	window.signalHandler = signalHandler;
	function signalHandler(uid, signalData, userType) {
		let resultant = signalData.split(sep);
		let userDetails = collection.getDetailsByEmail(uid);
		console.log('Function - signalHandler - ' + signalData + ' - email: ' + uid);
		console.log('---resultant---------', resultant);
		var channel_key = currentUserData.sessionData.streamToken != undefined ? currentUserData.sessionData.streamToken : null;
		var channelName = currentUserData.sessionData.channelId;

		if (resultant[0] === 'updateSettings') {
			const payload = JSON.parse(resultant[1]);
			if (payload.type === 'camera') {
				window.switchCameraStream.call(document.querySelector(`[data-value='${payload.id}']`))
			} else {
				window.switchMicStream.call(document.querySelector(`[data-value='${payload.id}']`))
			}
			window['selectDeviceById'](payload.id, payload.type)
		}
		if (resultant[0] === 'feedFm') {
			const payload = JSON.parse(resultant[1]);
			if (payload.hasOwnProperty('isMute')) {
				window['changeFmMuteStatus'](payload.isMute)
			}

			if (payload.hasOwnProperty('volume')) {
				window['changeFmMuteStatus'](false);
				if ( window['changeVolumeFm'] )
					{
						window['changeVolumeFm'](true, payload.volume);
					}
				if ( window['changeHostVolumeFm'] )
					{
						window['changeHostVolumeFm'](true, payload.volume);
					}
			}
		}
		
		if ( resultant[0] == RTMConst.CHAT )
			{
				if ( uid.includes("RM-") ) 
					{
						uid = uid.split('RM-')[1];
						userDetails = collection.getDetailsByEmail(uid);
					}
					
				let peerName = '';
				if ( resultant[3] != undefined ) 
					{
						let peerDetails = collection.getDetailsByEmail(resultant[3]);
						peerName = peerDetails.firstName;
					}
					
				window.onReceiveMessage(userDetails, resultant[1], "p2p", resultant[2], peerName);
				
				if ( $Any('#chat_menu').css('display') == 'none' )
					{
						var messagesCounter = $Any('#chat_counter').text();
						messagesCounter++;
						$Any('#chat_counter').text(messagesCounter);
						$Any('#chat_counter').removeClass('d-none');
						localStorage.setItem('unreadMessagesNum', messagesCounter);
						localStorage.setItem('unreadMessagesClassId', currentUserData.sessionData.id);
					}		
			}
		
		if ( resultant[0] == RTMConst.CHAT_SYNC )
			{
				let sessionChats = JSON.parse(localStorage.getItem('chats'));
				let chatArray = [];
				sessionChats.messages.forEach((chatData) => {
					if ( chatData.conversation == 'channel' && chatData.type == 'send' ) 
						{
							chatArray.push(chatData);
						}
				});
				
				let text = RTMConst.CHAT_SYNC + sep + JSON.stringify(chatArray);
				sendMessage(uid, text);
			}
			
		 if(resultant[0] == RTMConst.CAMERA_MIC_PERMISSION)
			{          
		
				let camAccess = resultant[1] == 1 ? hostlanguage.granted : hostlanguage.denied;
				let micAccess = resultant[2] == 1 ? hostlanguage.granted : hostlanguage.denied;

				let updateObject = {"cameraAccess": camAccess, "micAccess": micAccess};
				collection.updateModel(userDetails.id, JSON.stringify(updateObject));

				addUserAttribute(userDetails.id, 'cameraAccess', resultant[1]);
				addUserAttribute(userDetails.id, 'micAccess', resultant[2]);
				
				window.displayParticipants();
				
			}
		if(resultant[0] == RTMConst.SYNC_SCRIPT)
			{
				let currentActNum = window['currentActNum'];
				let currentActivity = window['currentActivity'];
				let currentActivityDuration = 0;
				
				if (!window['repsScriptActive'])
					{
						currentActivityDuration = parseInt(currentActivity['attribute'][2]['attrValue']);
					}
				else 
					{
						currentActivityDuration = parseInt(currentActivity.attribute[3].attrValue) * parseInt(currentActivity.attribute[9].attrValue);
					}
					
				let timeLeft = window['timeLefSec'];
				let timeSpent = currentActivityDuration - timeLeft;
				let hostState = 1;	
				
				if ( window['scriptPaused'] )
					{
						hostState = 2;
					}
					
				 if (resultant[1] == '')
					{
						let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "receive", "userId": currentUserData.id, "toFromId": userDetails.id, "message": RTMConst.SYNC_SCRIPT, "details": JSON.stringify({"action":"sync","type":"script"}), "timestamp": Util.getCurrentTimestamp()};
						sessionDataStore.addSessionData(addObject);
					}					 
			}
				
		if( resultant[0] == RTMConst.SWITCH_VIDEO_BROADCAST )
			{
				let status = false;
				if (resultant[1] == 1) 
					{
						status = true;
					}
					
				if ( status )
					{
						$Any('#zoomMember'+userDetails.id).removeClass('d-none');
					}					
				else 
					{
						$Any('#zoomMember'+userDetails.id).addClass('d-none');
					}					
					
				let updateObject = {"broadcastVideo": status};
				collection.updateModel(userDetails.id, JSON.stringify(updateObject));
				addUserAttribute(userDetails.id, 'broadcastVideo', status);	
				$Any('#networkmsg-'+userDetails.id).text('').addClass('d-none');				
				if ( usersOnScreenCurrent && usersOnScreenCurrent.length > 0 )
					{
						if ( usersOnScreenCurrent.indexOf(userDetails.id) > -1 )
							{
								if (resultant[1] == 0)
									{
										
										subscribeToAudioOnlyStream(userDetails.id);
									}
									
								else if (resultant[1] == 1)
									{
										changeNetworkmsg(userDetails);
										subscribeToVideoStream(userDetails.id);
									}
							}
					}
				
				if ( !$Any('#memebrsList').hasClass('d-none') )
					{
						window.displayParticipants();
					}
					
				if ( resultant[2] && resultant[2] == 1)
					{
						if ( currentUserData.sessionData.recordingInSessionStarted )
							{
								let text = RTMConst.SYNC_SESSION_RECORDING + sep + 1;
								sendMessage(uid, text);
							}
					}
			}
			
		if(resultant[0] == RTMConst.SEND_HANDRAISE)
			{
				if (!unmuteAllEnabled) 
					{

						let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "receive", "userId": currentUserData.id, "toFromId": userDetails.id, "message": RTMConst.SEND_HANDRAISE, "details": JSON.stringify({"action":"handRaise","msg":"Hand Raised"}), "timestamp": Util.getCurrentTimestamp()};
						sessionDataStore.addSessionData(addObject);
						
						/* if (userDetails.isVisible === false) */
						if ( usersOnScreenCurrent.indexOf(userDetails.id) == -1 )	
							{
								addAudienceInList(userDetails.id);
							} 
						else 
							{
								let updateObject = {"raisedHand": true, "raisedHandTime": Util.getCurrentTimestamp()};
								collection.updateModel(userDetails.id, JSON.stringify(updateObject));
								$Any('#raiseHandPart'+userDetails.id).removeClass('d-none');
							}	
					}
			}
		if(resultant[0] == RTMConst.PARTICIPANT_LIST)
			{
				window.displayParticipants();
			}
		if ( resultant[0] == 'heightListener' ) 
			{
				if ( resultant[1] == 1 && window['userWhiteboard'][userDetails.id] )
					{
						if ( window['retakeSetup'+userDetails.id] ) { return false; }
						console.log('checking_innit 000');
						if ( resultant[2] == 'roomCapture' )
							{
								console.log(resultant[2], resultant[3], 'capture_info');
								window['userWhiteboard'][userDetails.id].roomSetup.roomSetupInProgress = true;
								if ( resultant[3] > 0 && resultant[3] < 100 ) { $Any('#progressHostRoom'+userDetails.id).removeClass('d-none'); $Any("#progressHostRoom"+userDetails.id).css("width", resultant[3]+'%');}
								
								else { $Any('#progressHostRoom'+userDetails.id).addClass('d-none'); }
							}
							
						else
							{
								$Any('#progressHostRoom'+userDetails.id).addClass('d-none');
							}
						
						if ( resultant[2] == 'Room capture successful.' )
							{
								window['boxingTypeHost'+userDetails.id] = resultant[3];
								/* $Any('#bagToolTip'+userDetails.id).addClass('d-none');
								$Any('#progressHostRoom'+userDetails.id).addClass('d-none');
								$Any('#innerPartText'+userDetails.id).addClass('d-none');
								$Any('#roomCaptureStatus'+userDetails.id).removeClass('d-none');
								$Any('#newToolTip'+userDetails.id).find('.tooltipImage').addClass('d-none');
								$Any('#newToolTip'+userDetails.id).find('.tooltipSuccess').removeClass('d-none');
								$Any('#newToolTip'+userDetails.id).find('.tooltipText').html('Room capture successful').removeClass('d-none').addClass('tool_tip_checkmark');
								$Any('#newToolTip'+userDetails.id).removeClass('d-none'); */
								
								//$Any('#bagToolTip'+userDetails.id).html('<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>Room capture successful.');
							}
						else
							{
								if ( resultant[2] !== 'roomCapture' )
									{
										console.log('checking_innit 01');
										if ( resultant[2] == 'Please wait for room capturing to finish.' || resultant[3] == 'roomSetup' )
											{
												console.log('checking_innit 111');
												console.log('checking_innit 222');
												console.log('checking_innit 333');
												window['startDrawing'](false, userDetails.id);
												console.log('checking_innit 444');
												
												$Any('#newToolTip'+userDetails.id).find('.tooltipImage').css('background-image', 'url(images/maximise.png)').removeClass('d-none');
													
												window['userWhiteboard'][userDetails.id].roomSetup.roomSetupStarted = true;
											}
										$Any('#innerPartText'+userDetails.id).html(resultant[2]).removeClass('d-none');
										$Any('#newToolTip'+userDetails.id).find('.tooltipSuccess').addClass('d-none');
										$Any('#newToolTip'+userDetails.id).find('.tooltipText').addClass('d-none');
										$Any('#newToolTip'+userDetails.id).find('.upNext').addClass('d-none');
										$Any('#newToolTip'+userDetails.id).removeClass('d-none');
										
										window['userWhiteboard'][userDetails.id].showMessageInstruction('', false, resultant[2], userDetails.id);
									}
								
								//$Any('#bagToolTip'+userDetails.id).html(resultant[2]);
							}
						
						//$Any('#bagToolTip'+userDetails.id).removeClass('d-none');
					}
				else if ( resultant[1] == 2 )
					{
						$Any('#bagToolTip'+userDetails.id).addClass('d-none');
						$Any('#newToolTip'+userDetails.id).addClass('d-none');
					}
			}
		if ( resultant[0] == 'finishWorkoutSetup' ) 
			{
				console.log('finishWorkoutSetup roomSetupInProgress');
				
				
				if ( window['userWhiteboard'][userDetails.id] )
					{
						console.log(window['userWhiteboard'][userDetails.id].roomSetup.roomSetupInProgress);
						
						$Any('#innerPartText'+userDetails.id).addClass('d-none');
						$Any('#newToolTip'+userDetails.id).find('.tooltipSuccess').removeClass('d-none');
						$Any('#newToolTip'+userDetails.id).find('.tooltipText').html('Workout Area Setup Completed!').removeClass('d-none').addClass('tool_tip_checkmark');
						$Any('#newToolTip'+userDetails.id).removeClass('d-none');
						let timeoutTime = resultant[2];
						console.log('finishWorkoutSetup timeoutTime', timeoutTime);
						
						setTimeout(function() {
							$Any('#newToolTip'+userDetails.id).addClass('d-none');
						}, 2000);
						
						setTimeout(function() {
							window['userWhiteboard'][userDetails.id].roomSetup.finishWorkoutSetupHost(JSON.parse(resultant[1]));
							
							let act_type = window['checkActivityType'](window['currentActNum']-1);
							var countDown = window['timeLefSec'];
							console.log(parseInt(window['timeLefSec']), 'countDownHost');
							if ( act_type == 'Virtual Equipment' && window['currentActivity'] )
								{
									let script_name = window['currentActivity']['name'];
									
									window['userWhiteboard'][userDetails.id].soundPlay.stopAudio();
									window['userWhiteboard'][userDetails.id].activityStarted(script_name);
									window['userWhiteboard'][userDetails.id].currentActivityName = script_name;
									
									setTimeout(function() {
										if ( parseInt(countDown) !== 0 ) { window['globalRTM'](window['allPartDetails'][userDetails.id]['email'], 'hostStartedEquipment'+sep); }
									}, 1000);
										
									//$Any('#movedEquipment'+userDetails.id).removeClass('smallerButton, d-none').html('Set up equipment');
									$Any('#movedEquipment'+userDetails.id).removeClass('d-none');
									$Any('#inZoneStatus'+userDetails.id).addClass('d-none');
									//$Any('#setupEquipmentHold'+userDetails.id).removeClass('d-none');
									
									$Any('#successMarkPar'+userDetails.id).addClass('d-none');
									window['equipmentIsReady'] = true;
									
									if ( !window['retakeStatus'+userDetails.id] && parseInt(countDown) !== 0 )
										{
											$Any('#actStart').removeClass('d-none');
											$Any('.movedEqButtonHold').addClass('whiteBkg');
											$Any('.equipmentTagsHolder').addClass('smallerButton').html('Edit');
											$Any('.equipmentSetupText').removeClass('d-none');
											
										}
									
									let removeEqPop = 'hostStartedEquipment';
									//window['sendMessageToChannel'](removeEqPop);
									window['hostStartedEquipment'+userDetails.id] = true;
									window['openedEditEquipment'+userDetails.id] = false;
									

									window['globalRTM'](window['allPartDetails'][userDetails.id]['email'], 'hostWorkoutFinished'+sep);
									
									/* if ( script_name == 'Lateral Cone Touch' && !window['alreadyDrawnCone'+userDetails.id] )
										{
											$Any('#canvasCone'+userDetails.id).trigger('click');
											//coneDraw.placeConesInZone(userDetails.id);
											window['mouseUp'+userDetails.id](false);
											window['coneZoneSet'] = false;
											window['globalRTM'](window['allPartDetails'][userDetails.id]['email'], 'resetConeZone'+sep);
										}						
									else if ( script_name == 'Diagonal Cone Touch' && !window['alreadyDrawnConeDiagonal'+userDetails.id] )
										{
											$Any('#canvasCone'+userDetails.id).trigger('click');
											//coneDraw.placeDiagConesInZone(userDetails.id);
											window['mouseUp'+userDetails.id](false);
											window['coneZoneSetDiag'] = false;
											window['globalRTM'](window['allPartDetails'][userDetails.id]['email'], 'resetConeZone'+sep);
										}				
									else if ( script_name == 'Agility Ladder' && !window['alreadyDrawnLadder'+userDetails.id] )
										{
											window['canvasLines'+userDetails.id] = [];
											window.ladderDraw.addLadder(userDetails.id);
											window['mouseUp'+userDetails.id](false);
											window['ladderZoneSet'] = false;
											window['globalRTM'](window['allPartDetails'][userDetails.id]['email'], 'resetLadderZone'+sep+'notMoved');
										} */
									window['retakeStatus'+userDetails.id] = false;
								}
								
							else
								{
									window['closeDrawing']('', userDetails.id);
									if ( !resultant[3] || (resultant[3] && resultant[3] != 'preStreaming') ) { $Any('#activityStart').removeClass('d-none'); console.log('show activityStart', resultant[3]); }
								}
						}, timeoutTime);
					}
			}
		if ( resultant[0] == 'drawSplit' ) 
			{
				if ( resultant.length == 5 )
					{
						if ( !drawSplitArray[resultant[1]] ) { drawSplitArray[resultant[1]] = new Array(parseInt(resultant[2])+1); drawSplitArray[resultant[1]][0] = parseInt(resultant[2]); }
						drawSplitArray[resultant[1]][parseInt(resultant[3])+1] = resultant[4];
						drawSplitArray[resultant[1]][0]--;
						
						if ( drawSplitArray[resultant[1]][0] == 0 )
							{
								var oldid = resultant[1];
								drawSplitArray[oldid].shift();
								
								var newrtm = atob(drawSplitArray[oldid].join(''));
								resultant = newrtm.split(sep);
								drawSplitArray[oldid]=false;
							}
					}
			}
		if ( resultant[0] == 'draw' ) 
			{
				var linesPt = JSON.parse(resultant[1]);
				console.log(linesPt);
				if ( window['userWhiteboard'][userDetails.id] )
					{
						window['userWhiteboard'][userDetails.id].updateLines(linesPt); 
						window['userWhiteboard'][userDetails.id].drawLines();
					}
			}
		if ( resultant[0] == 'participantZoom' ) 
			{
				console.log('REFRESH PARTICIPANT');
				window['participantRefresh'+userDetails.id]('zoom');
			}
		if ( resultant[0] == 'participantElectron' ) 
			{
				console.log('PARTICIPANT ELECTRON');
				window['participantElectron'] = true;
			} 
		if ( resultant[0] == 'repCount' ) 
			{
				console.log('REPS', resultant[1]);
				if ( $Any('#repCount'+userDetails.id).hasClass('d-none') ) { window['showCounter'] = true; $Any('#repCount'+userDetails.id).removeClass('d-none'); }
				$Any('#repCount'+userDetails.id).html(resultant[1]);
			} 
		if ( resultant[0] == 'repCountMiss' ) 
			{
				console.log('REPS MISS', resultant[1]);
				$Any('#ppmCount'+userDetails.id).removeClass('d-none');
				$Any('#ppmCount'+userDetails.id+' .counter-number').html(resultant[1]);
			}
		if ( resultant[0] == 'switchBoxCircle' )
			{
				window['showTargetCircle'+userDetails.id] = JSON.parse(resultant[1]);
				window['showTargetCircleRight'+userDetails.id] = JSON.parse(resultant[2]);
				window['firstCircleShown'+userDetails.id] = true;
				window['stoodInBox'+userDetails.id] = false;
				window['boxCircleColor'+userDetails.id] = resultant[3];
				window['showGreenCircle'+userDetails.id] = true;
				window['showHitAnimation'+userDetails.id] = false;
				setTimeout(function() {
					window['showGreenCircle'+userDetails.id] = false;
				}, 1000);
				
				if ( window['showTargetCircle'+userDetails.id] ) { window['showInsideRight'+userDetails.id] = true; window['showInside'+userDetails.id] = false; }
				if ( window['showTargetCircleRight'+userDetails.id] ) { window['showInside'+userDetails.id] = true; window['showInsideRight'+userDetails.id] = false; }
			}
		if ( resultant[0] == 'showPlankLine' )
			{
				window['sentLineRTM'+userDetails.id] = true;
			}
		if ( resultant[0] == 'switchDrillCircle' ) 
			{
				window['showTargetCircle'+userDetails.id] = JSON.parse(resultant[1]);
				window['showTargetCircleRight'+userDetails.id] = JSON.parse(resultant[2]);
				window['firstCircleShown'+userDetails.id] = true;
				window['boxCircleColor'+userDetails.id] = resultant[3];
				window['currentReaction'+userDetails.id] = resultant[4];
				window['drillArrowSide'+userDetails.id] = resultant[5];
				window['boxCircleColorDrill'+userDetails.id] = resultant[6];
				if ( window['showTargetCircle'+userDetails.id] )
					{
						window['boxCircleColor'+userDetails.id] = 'rgba(42, 163, 46)';
						window['boxCircleColorDrill'+userDetails.id] = 'rgb(155, 81, 224)';
					}
				else
					{
						window['boxCircleColorDrill'+userDetails.id] = 'rgba(42, 163, 46)';
						window['boxCircleColor'+userDetails.id] = 'rgb(155, 81, 224)';
					}
				window['showGreenCircle'+userDetails.id] = true;
				setTimeout(function() {
					window['showGreenCircle'+userDetails.id] = false;
				}, 1000);
				
				if ( window['showTargetCircle'+userDetails.id] ) { window['showInsideRight'+userDetails.id] = true; window['showInside'+userDetails.id] = false; }
				if ( window['showTargetCircleRight'+userDetails.id] ) { window['showInside'+userDetails.id] = true; window['showInsideRight'+userDetails.id] = false; }
			}
		if ( resultant[0] == 'coneCircleRemove' ) 
			{
				if ( resultant[1] == 'cone' ) { window['showConeRectangle'+userDetails.id] = true; }
				else if ( resultant[1] == 'coneDiagonal' ) { window['showConeRectangleDiagonal'+userDetails.id] = true; }
			}
		if ( resultant[0] == 'getZeroSuccess' ) 
			{
				window['captureRoom'+userDetails.id]();
			}
		if ( resultant[0] == 'getZeroFail' ) 
			{
				window['resetCapture'+userDetails.id]('r');
			} 
		if ( resultant[0] == 'getHeightSuccess' )
			{
				window['captureHeightHost'+userDetails.id](resultant[1]);
				//$Any('#bagToolTip'+userDetails.id).html('<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>Height Captured.');
				//$Any('#bagToolTip'+userDetails.id).removeClass('d-none');
				
				$Any('#innerPartText'+userDetails.id).addClass('d-none');
				$Any('#newToolTip'+userDetails.id).find('.tooltipSuccess').removeClass('d-none');
				$Any('#newToolTip'+userDetails.id).find('.tooltipText').html('Height Captured!').removeClass('d-none').addClass('tool_tip_checkmark');
				$Any('#newToolTip'+userDetails.id).removeClass('d-none');
				
				if ( window['coneScriptActive'] )
					{
						$Any('.equipment_stats_hold').removeClass('d-none');
						
					}
			} 
		if ( resultant[0] == 'getHeightFail' ) 
			{
				window['resetCapture'+userDetails.id]('h');
			}
		if ( resultant[0] == 'participantDidRejoin' ) 
			{
				window['hostRejoin'] = false;
				window['resetWhiteDraw'+userDetails.id](userDetails.id);
			}
		if ( resultant[0] == 'finalPosition' )
			{
				window['inFinalPosition'+userDetails.id] = true;
			}
		if ( resultant[0] == 'finalPositionPar' ) 
			{
				$Any('#successMarkPar'+userDetails.id).removeClass('d-none');
			}
		if ( resultant[0] == 'showVirtualError' ) 
			{
				window['deviceNotSupported'+userDetails.id] = true;
				let parId = userDetails.id;
				let act_type = window['checkActivityType'](window['currentActNum']-1);
				  
				if ( act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant' )
					{
						if ( window['deviceNotSupported'+parId] )
						{
							$Any('#virtualmsg-'+parId).text('Device Not Supported').removeClass('d-none');
							
							if ( $Any('.participantStreamPart').length == 1 )
								{
									window.stopCircleAnimation = false;
								}
						}
					}
			} 
		if ( resultant[0] == 'hideVirtualError' ) 
			{
				$Any('#virtualmsg-'+userDetails.id).addClass('d-none');
			}
		if ( resultant[0] == 'changeBoxingPosition' ) 
			{
				window['boxingTypeHost'+userDetails.id] = resultant[1];
				window['boxingPositionHost'+userDetails.id] = resultant[2];
				
				if ( window['userWhiteboard'][userDetails.id] && window.updateBagPosition ) { window.updateBagPosition(parseInt(userDetails.id), resultant[2]); }
			} 
		if ( resultant[0] == 'sendBoxInfo' ) 
			{
				if ( resultant[1] == '7x7' ) { window['boxJumpWidth'+userDetails.id] = 49; window['boxJumpHeight'+userDetails.id] = 49; }
				if ( resultant[1] == '10x10' ) { window['boxJumpWidth'+userDetails.id] = 70; window['boxJumpHeight'+userDetails.id] = 70; }
				if ( resultant[1] == '12x12' ) { window['boxJumpWidth'+userDetails.id] = 84; window['boxJumpHeight'+userDetails.id] = 84; }
				if ( resultant[1] == '14x14' ) { window['boxJumpWidth'+userDetails.id] = 98; window['boxJumpHeight'+userDetails.id] = 98; }
				if ( resultant[1] == '16x16' ) { window['boxJumpWidth'+userDetails.id] = 112; window['boxJumpHeight'+userDetails.id] = 112; }
				
				let useEquipmentLocation = JSON.parse(resultant[2]);
				if ( !useEquipmentLocation )
					{
						console.log(useEquipmentLocation, 'useEquipmentLocation dontUse');
						window['alreadyDrawnBag'+userDetails.id] = false;
						window['alreadyDrawnCone'+userDetails.id] = false;
						window['alreadyDrawnConeDiagonal'+userDetails.id] = false;
						window['alreadyDrawnLadder'+userDetails.id] = false;
						window['alreadyDrawnPlank'+userDetails.id] = false;
						window['alreadyDrawnPlankReach'+userDetails.id] = false;
						window['doNotUseLocation'+userDetails.id] = true;
						window['bagAttributes'+userDetails.id] = {
							'bagStartY': 0,
							'bagStartX': 0,
							'bagWidth': 0,
							'bagHeight': 0,
							'bagDistance': 0,
						};
						window['coneAttributes'+userDetails.id] = {
							'leftConeStartX': 0,
							'leftConeStartY': 0,
							'leftConeWidth': 0,
							'leftConeHeight': 0,
							'rightConeStartX': 0,
							'rightConeStartY': 0,
							'rightConeWidth': 0,
							'rightConeHeight': 0
						};
						window['ladderAttributes'+userDetails.id] = {
							'ladderStartX': 0,
							'ladderStartY': 0,
							'ladderWidth': 0,
							'ladderHeight': 0,
							'ladderDistance': 0,
							'fieldW': 0,
							'fieldStartX': 0,
							'fieldEndX': 0,
							'fieldDiff': 0
						};
						window['ladderAttributes'+userDetails.id] = {
							'ladderStartX': 0,
							'ladderStartY': 0,
							'ladderWidth': 0,
							'ladderHeight': 0,
							'ladderDistance': 0,
							'fieldW': 0,
							'fieldStartX': 0,
							'fieldEndX': 0,
							'fieldDiff': 0
						};
					}
				else
					{
						if ( window['alreadyDrawnBag'+userDetails.id] ) { window['globalRTM'](window['allPartDetails'][userDetails.id]['email'], 'bagAttributes'+sep+JSON.stringify(window['bagAttributes'+userDetails.id])); }
					}
			}
		if ( resultant[0] == 'leftPosition' && window['successMarkShown'+userDetails.id] == false ) 
			{
				window['inFinalPosition'+userDetails.id] = false;
				window['allInPos'] = false;
				$Any('#inZoneStatus'+userDetails.id).addClass('d-none');
				//$Any('#actStart').addClass('d-none');
				if ( window.isPaused && !window['activityEnded'] )
					{
						$Any('#script_msg').addClass('d-none');
						window['successMarkShown'+userDetails.id] = false;
					}
			}
		if ( resultant[0] == 'hitEquipment' ) 
			{
				if ( resultant[1] == 'yes' )
					{
						window['hitEquipmentHost'+userDetails.id] = true;
						window['moveBagHost'+userDetails.id] = true;
						window['hitEquipmentHostPosition'+userDetails.id] = resultant[2];
						window['detectorColorHost'+userDetails.id] = 'red';
						window['animationPosition'+userDetails.id].push({'posY':window['hitEquipmentHostPosition'+userDetails.id], 'step': 1});
						lastBagHitTime = new Date().getTime();
					}
				else
					{
						var bagHitTimeout = 0;
						
						if ( lastBagHitTime < ((new Date()).getTime()-1000) )
							{
								bagHitTimeout = 1000;
							}
						
						setTimeout(function() {
							window['hitEquipmentHost'+userDetails.id] = false;
							window['detectorColorHost'+userDetails.id] = 'green';
						}, bagHitTimeout);
					}
			} 
		if ( resultant[0] == 'moveBagEquipment' ) 
			{
				console.log('moveBagInfo');
				if ( resultant[1] == 'yes' )
					{
						window['moveBagHost'+userDetails.id] = true;
						window['rotateValue'+userDetails.id] = resultant[2];
						console.log('moveBagInfo true');
					}
				else
					{
						window['moveBagHost'+userDetails.id] = false;
						console.log('moveBagInfo false');
					}
			}
		if ( resultant[0] == 'hostSetupProgress' ) 
			{
				if ( resultant[1] == 'inCircle' && window['measuringProcess'+userDetails.id] )
					{
						$Any('#progressBarHost'+userDetails.id).removeClass('d-none');
						$Any("#progressHost"+userDetails.id).css("height", resultant[2]+'%');
						
						//$Any('#bagToolTip'+userDetails.id).html('In the Active Zone');
						
						$Any('#innerPartText'+userDetails.id).html('In the Active Zone').removeClass('d-none');
						$Any('#newToolTip'+userDetails.id).find('.tooltipSuccess').addClass('d-none');
						$Any('#newToolTip'+userDetails.id).removeClass('d-none');
					}
				else
					{
						$Any('#progressBarHost'+userDetails.id).addClass('d-none');
						$Any("#progressHost"+userDetails.id).css("height", resultant[2]+'%');
						
						//$Any('#bagToolTip'+userDetails.id).html('Waiting for Member');
						
						$Any('#innerPartText'+userDetails.id).html('Waiting for Member').removeClass('d-none');
						$Any('#newToolTip'+userDetails.id).find('.tooltipSuccess').addClass('d-none');
						$Any('#newToolTip'+userDetails.id).find('.tooltipText').addClass('d-none');
						$Any('#newToolTip'+userDetails.id).removeClass('d-none');
					}
			}
		if ( resultant[0] == 'hostWorkoutProgress' ) 
			{
				window['userWhiteboard'][userDetails.id].roomSetup.workoutAreaProcess = true;
				window['userWhiteboard'][userDetails.id].globalActType = 'workoutAreaSetup';
				$Any('#innerPartText'+userDetails.id).removeClass('d-none');
				window['userWhiteboard'][userDetails.id].showMessageInstruction('', false, resultant[1], userDetails.id);
				$Any('#newToolTip'+userDetails.id).find('.tooltipSuccess').addClass('d-none');
				$Any('#newToolTip'+userDetails.id).find('.tooltipText').addClass('d-none');
				$Any('#newToolTip'+userDetails.id).find('.tooltipImage').addClass('d-none');
				$Any('#newToolTip'+userDetails.id).removeClass('d-none');
			} 
		if ( resultant[0] == 'coneTouched' ) 
			{
				if ( resultant[1] == 'right' )
					{
						window['trackerTouchedHost'+userDetails.id] = true;
						window['trackerTouched2Host'+userDetails.id] = false;
						window['detectorColorHost'+userDetails.id] = 'red';
						window['detectorColor2Host'+userDetails.id] = 'green';
					}
				else if ( resultant[1] == 'left' )
					{
						window['trackerTouchedHost'+userDetails.id] = false;
						window['trackerTouched2Host'+userDetails.id] = true;
						window['detectorColorHost'+userDetails.id] = 'green';
						window['detectorColor2Host'+userDetails.id] = 'red';
					}
				else
					{
						window['trackerTouchedHost'+userDetails.id] = false;
						window['trackerTouched2Host'+userDetails.id] = false;
						window['detectorColorHost'+userDetails.id] = 'green';
						window['detectorColor2Host'+userDetails.id] = 'green';
					}
			}
		if ( resultant[0] == 'boxTouched' )
			{
				if ( !window.isPaused )
					{
						window['showHitAnimation'+userDetails.id] = true;
					}
				if ( resultant[1] == 'right' )
					{
						window['trackerTouchedHost'+userDetails.id] = true;
						window['trackerTouched2Host'+userDetails.id] = false;
						window['detectorColorHost'+userDetails.id] = 'red';
						window['detectorColor2Host'+userDetails.id] = 'green';
					}
				else if ( resultant[1] == 'left' )
					{
						window['trackerTouchedHost'+userDetails.id] = false;
						window['trackerTouched2Host'+userDetails.id] = true;
						window['detectorColorHost'+userDetails.id] = 'green';
						window['detectorColor2Host'+userDetails.id] = 'red';
					}
				else
					{
						window['trackerTouchedHost'+userDetails.id] = false;
						window['trackerTouched2Host'+userDetails.id] = false;
						window['detectorColorHost'+userDetails.id] = 'green';
						window['detectorColor2Host'+userDetails.id] = 'green';
					}
			} 
		if ( resultant[0] == 'audioPlaying' ) 
			{
				if ( !currentUserData.isMarketplaceChannel || currentUserData.isMarketplaceChannel===0 )
					{
						$Any('#audioPlaying'+userDetails.id).removeClass('d-none');
						window['audioStartedTime'] = new Date().getTime();
					}
			}
		if ( resultant[0] == 'audioStopped' ) 
			{
				if ( window['audioStartedTime'] < ((new Date()).getTime()-1000) )
					{
						$Any('#audioPlaying'+userDetails.id).addClass('d-none');
					}
			}
		if ( resultant[0] == 'retakeRoomSetup' ) 
			{
				window['userWhiteboard'][userDetails.id].roomSetup.roomSetupDone = false;
				window['userWhiteboard'][userDetails.id].roomSetup.retakeSetup = true;
				window['userWhiteboard'][userDetails.id].roomSetup.allowRoomPicture = true;
				window['userWhiteboard'][userDetails.id].roomSetup.viewCaptured = false;
				window['userWhiteboard'][userDetails.id].roomSetup.workoutAreaSetupDone = false;
				window['resetZero'+userDetails.id]();
				
				
				
				let act_type = window['checkActivityType'](window['currentActNum']-1);
				let act_type_next = window['checkActivityType'](window['currentActNum']);
				
				if ( act_type == 'Virtual Equipment' || act_type_next == 'Virtual Equipment' )
					{
						window['retakeStatus'+userDetails.id] = true;
					}
				
				window['participantDetails'] = userDetails;
				if ( !window['load'+userDetails.id] )
					{
						window['startDrawing'](false, userDetails.id);
					}
					
				$Any('#canvasWrap'+userDetails.id).removeClass('d-none');
			} 
		if ( resultant[0] == 'sendDrawSetup' ) 
			{
				
				var canvas = $Any("#sessionCanvas"+userDetails.id);
				var canvasSize = {};
				canvasSize['w'] = canvas.width;
				canvasSize['h'] = canvas.height;
				
				if ( !window['canvasLines'+userDetails.id] ) { window['canvasLines'+userDetails.id] = []; }
				let text = 'draw'+sep+JSON.stringify(window['canvasLines'+userDetails.id])+'cSize'+JSON.stringify(canvasSize);
				
				window['globalRTM'](uid, text);
				
			} 
		if ( resultant[0] == 'roomSetupDone' ) 
			{
				window['roomSetupDone'+userDetails.id] = true;
				window['pxPerMm'+userDetails.id] = resultant[1]; 
				
				if ( !$Any('#newToolTip'+userDetails.id).hasClass('d-none') )
					{
						$Any('#innerPartText'+userDetails.id).addClass('d-none');
						$Any('#newToolTip'+userDetails.id).find('.tooltipSuccess').removeClass('d-none');
						$Any('#newToolTip'+userDetails.id).find('.tooltipText').html('Height Captured!').removeClass('d-none').addClass('tool_tip_checkmark');
						$Any('#newToolTip'+userDetails.id).removeClass('d-none');
						
						setTimeout(function(){
							$Any('#newToolTip'+userDetails.id).addClass('d-none');
						}, 2000);
					}
				
				if ( window['load'+userDetails.id] )
					{
						window['roomAndHeightSetup'+userDetails.id]();
					}
			} 
		if ( resultant[0] == 'startRoomSetup' ) 
			{
				$Any('.walk_tool_hold').trigger('click');
			} 
		if ( resultant[0] == 'roomSetupButton' ) 
			{
				window['roomSetupButton'+userDetails.id] = true; 
				window['participantDetails'] = userDetails;
				window['startDrawing'](false, userDetails.id);
			} 
		if ( resultant[0] == 'roomSetupCompleted' ) 
			{
				allParticipantsRoomSetup[userDetails.id] = resultant[1] == 'true' ? true : false;
				var allPartSetup = true;
				var stopAct = false;
				 $Any('.participantStreamPart').each(function(item, index){
					let parIdMain = $Any(this).attr('id').split('participant_agora');
					let userId = parseInt(parIdMain[1]);
					
					if ( !allParticipantsRoomSetup[userId] )
						{
							allPartSetup = false;
						}
						
					 if ( userId != currentUserData.id )
						{
							if ( ( window['canvasLines'+userId] && window['canvasLines'+userId].length > 0 ) || window['gridOn'+userId] )
								{
									stopAct = true;
								}
						}	
				});
				
				let act_type = window['checkActivityType'](window['currentActNum']-1);
				let act_type_next = window['checkActivityType'](window['currentActNum']);
				
				let currentHostSettings = JSON.parse(localStorage.getItem("hostSettings"));
				
				if ( allPartSetup && act_type !== 'Virtual Equipment' && act_type !== 'Virtual Assistant' )
					{
						if ( !$Any('.actStartHost').hasClass('d-none') )
							{
								window['playCountdown'] = true;
							}
						 var stopAct = false;
						  $Any('.participantStreamPart').each(function(item, index){
							let parIdMain = $Any(this).attr('id').split('participant_agora');
							let parId = parseInt(parIdMain[1]);
							  if ( parId != currentUserData.id )
								{
									if ( ( window['canvasLines'+parId] && window['canvasLines'+parId].length > 0 ) || window['gridOn'+parId] )
										{
											stopAct = true;
										}
								}
						 });
						 if ( !stopAct )
							{
								window.playSlider();
							}
						
					}
				else if ( !allPartSetup && ( act_type_next == 'Virtual Equipment' || act_type_next == 'Virtual Assistant' ) )
					{
						let script_name_next = window['checkActivityName']($Any('.swiper-slide-next .data-slide').attr('data-index'));
						
						 let _el = $Any('.swiper-slide.swiper-slide-next');
						let scriptLength = $Any('.swiper-slide .data-slide').length;
						let scriptIndex = parseInt(_el.find('.data-slide').attr('data-index'));
						
						if ( scriptIndex < scriptLength && ( resultant[1] == 'true' || !currentHostSettings['turnoffRoomSetup'] ) )
							{
								$Any('#activityStart').html('Next: '+script_name_next); 
								$Any('#activityStart').removeClass('d-none');
							}
						
					}
				 
				else if ( allPartSetup && ( act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant' ) )
					{
						setTimeout(function(){ 	
						let script_name = window['checkActivityName']($Any('.swiper-slide-next .data-slide').attr('data-index'));
						 let _el = $Any('.swiper-slide.swiper-slide-next');
						
						let scriptLength = $Any('.swiper-slide .data-slide').length;
						let scriptIndex = parseInt(_el.find('.data-slide').attr('data-index'));
						if ( scriptIndex < scriptLength && ( resultant[1] == 'true' || !currentHostSettings['turnoffRoomSetup'] ) && stopAct )
							{
								$Any('#activityStart').html('Next: '+script_name);
								$Any('#activityStart').removeClass('d-none');
							}
						
						}, 1000);
					}			
			} 
		if(resultant[0] == "firstRoomCircleDone") 
			{
				window['userWhiteboard'][userDetails.id].roomSetup.createRoomSetupCanvas();
				window['userWhiteboard'][userDetails.id].roomSetup.firstRoomCircleDone = true;
			}
		if(resultant[0] == "finishRoomSetup") 
			{
				window['userWhiteboard'][userDetails.id].roomSetup.finishRoomSetup();
			} 
		if(resultant[0] == "heightResult") 
			{
				let memberHeight = parseInt(resultant[2]);
				if ( !memberHeight || memberHeight < 100 ) { memberHeight = 500; }
				window['memberHeight'+userDetails.id] = memberHeight;
				window['finishHeightHost'+userDetails.id](JSON.parse(resultant[1]));
			} 
		if(resultant[0] == "heartRateUpdate") 
			{
				let heartRateStats = JSON.parse(resultant[1]);

				$Any('#heartStats'+userDetails.id).text(heartRateStats['heartRate']);
				$Any('#caloriesCount'+userDetails.id).text(heartRateStats['calories']);
				$Any('#vomaxCount'+userDetails.id).text(heartRateStats['vo2']);
			} 
		if(resultant[0] == "ladderTouched") 
			{
				window['showFieldTouch'+userDetails.id] = true;
				window['touchedField'+userDetails.id] = resultant[1];
				window['currentLadderField'+userDetails.id] = resultant[2];
				window['touchFieldValues'+userDetails.id] = JSON.parse(resultant[3]);
			}
		if(resultant[0] == "updateGridZone") 
			{
				let gridZoneObject = JSON.parse(resultant[1]);
				console.log('gridZoneObject', gridZoneObject);
				
				//if ( window['userWhiteboard'][userDetails.id] ) { window['userWhiteboard'][userDetails.id].gridActions.setGridZone(gridZoneObject['x1'], gridZoneObject['x2'], gridZoneObject['x3'], gridZoneObject['x4'], gridZoneObject['y1'], gridZoneObject['y2'], gridZoneObject['columns'], gridZoneObject['rows']); }
				if ( window.gridZoneUpdate ) { window.gridZoneUpdate(resultant[1], parseInt(userDetails.id)); }
			}
		if(resultant[0] == "showWorkoutCone") 
			{
				let workoutConeIndex = resultant[1];
				
				if ( workoutConeIndex == 'all' )
					{
						window['userWhiteboard'][userDetails.id].activityBuilderContent.activityBuilderObject['workoutAreaSetup'].drawingObjects.forEach(function(item){
							item[1]['isHidden'] = false;
						});
					}
				else
					{
						window['userWhiteboard'][userDetails.id].activityBuilderContent.activityBuilderObject['workoutAreaSetup'].drawingObjects[workoutConeIndex]['isHidden'] = false;
					}
			}
		if(resultant[0] == "modifyGlobalObject") 
			{
				let activityObject = resultant[1];
				let activityName = resultant[2];
				
				console.log('modifyGlobalObject id', userDetails.id);
				console.log(activityName, 'activityNameGetting');
				if ( window['userWhiteboard'][userDetails.id] ) 
					{
						var currentObject = window['userWhiteboard'][userDetails.id].activityBuilderContent.activityBuilderObject;
						window['getCurrentObjectInnit'] = activityObject;
						
						if ( activityName == 'reset' || activityName == '' ) { window['userWhiteboard'][userDetails.id].changeGlobalObject(JSON.stringify(currentObject[activityName]), activityName);  }
						else { window['userWhiteboard'][userDetails.id].changeGlobalObjectRTM(activityObject, activityName); }
					}
				
				
			}
		if(resultant[0] == "changeGlobalCounter") 
			{
				if ( window['userWhiteboard'][userDetails.id] ) { window['userWhiteboard'][userDetails.id].changeGlobalCounter(resultant[1], resultant[2]); }
			}
		if(resultant[0] == "modifyCustomVariable") 
			{
				let customObject = JSON.parse(resultant[1]);
				console.log('modifyCustomVariable RTM received', customObject);
				if ( window.setCustomObject ) { window.setCustomObject(customObject[0], customObject[1], customObject[2], userDetails.id);  console.log('modifyCustomVariable function called'); }
			}
		if(resultant[0] == "startWAS") 
			{
				if ( window['userWhiteboard'][userDetails.id] ) { window['userWhiteboard'][userDetails.id].activityStarted('Workout Area Setup'); }
			}
		if(resultant[0] == "preStreamingRoomSetup") 
			{
				window['preStreamingRoomSetup'+userDetails.id] = true;
				window['preStreamingWASLocation'+userDetails.id] = JSON.parse(resultant[1]);
				completeRoomSetup(userDetails.id);
			}
		if(resultant[0] == RTMConst.PARTICIPANT_MUTED_SELF)
			{
				let indexNum = participantsSelfMuted.indexOf(userDetails.id);
				if ( indexNum == -1 )
					{
						participantsSelfMuted.push(userDetails.id);
					}
				
				if ( !$Any('#partActiveMic'+userDetails.id).hasClass('d-none') )
					{
						$Any('#partActiveMic'+userDetails.id).addClass('d-none');
						$Any('#partInActiveMic'+userDetails.id).removeClass('d-none');
					}
			}
		if(resultant[0] == RTMConst.PARTICIPANT_UNMUTED_SELF)
			{
				let indexNum = participantsSelfMuted.indexOf(userDetails.id);
				if ( indexNum > -1 )
					{
						$Any('#partInActiveMic'+userDetails.id).addClass('d-none');
						participantsSelfMuted.splice(indexNum, 1);	
					}
				
				let selectedUsersArray = window['currentSelected'];
				if ( unmuteAllEnabled || selectedUsersArray.indexOf(userDetails.id) > -1 )
					{
						//this part will change when participant mute his mic, while unmute all
						$Any('#partActiveMic'+userDetails.id).removeClass('d-none');				
					}
										
			}
			
		if ( resultant[0] == "checkSessionStation" )
			{
				rtm.invoke({'code': 23});
			}
		
		if ( resultant[0] == RTMConst.SHOW_SESSION_SCRIPT )	
			{
				$Any('#view_all_activities').trigger('click');
			}
			
		if ( resultant[0] == RTMConst.PARTICIPANT_LIST )	
			{
				$Any('#view_all_participants').trigger('click');
			}
		
		if ( resultant[0] == RTMConst.MUTE_UNMUTE_LOCAL_STREAM )	
			{
				$Any('#microphone_control').trigger('click');
			}
			
		if ( resultant[0] == RTMConst.SESSION_RECORDING )	
			{
				if ( $Any("#record_session").is(":visible") ) 
					{
						$Any('#record_session').trigger('click');
					}
			}
			
		if ( resultant[0] == RTMConst.START_SESSION )	
			{
				if ( $Any("#startSession").is(":visible") ) 
					{
						$Any('#startSession').trigger('click');
					}
			}
			
		if ( resultant[0] == RTMConst.MUTE_UNMUTE_ALL )	
			{
				if ( $Any("#mute_control").is(":visible") ) 
					{
						$Any('#mute_control').trigger('click');
					}
			}
			
		if ( resultant[0] == RTMConst.ZOOM_LOCAL_STREAM )	
			{
				if ( $Any("#my_view").is(":visible") ) 
					{
						$Any('#my_view').trigger('click');
					}
			}
			
		if ( resultant[0] == RTMConst.REMOTE_ADD_ALERT )
		    {
				window.addNote({id: resultant[1], payload: resultant[2], type: 'alert'})
		    }	
		    		
		if ( resultant[0] == RTMConst.REMOTE_DISMISS_NOTE )
		    {
				window.removeNote(resultant[1])
		    }
		
		if ( resultant[0] == RTMConst.START_SESSION )
		    {
				$Any('#startClass').trigger('click');
			}
			
		if ( resultant[0] == RTMConst.START_SCRIPT )
		    {
				if ( window['script_is_started'] )
					{
						$('#resumeButtonClick').trigger('click');
					}
				else
					{
						$('#start_new_activity').trigger('click');
					}
			}
			
		if ( resultant[0] == RTMConst.STOP_SCRIPT )
			{
				window['stopFitnessScript']();
				
				if ( window['stopScriptD2C'] )
					{
						window['stopScriptD2C']();
					}
			}
			
		if ( resultant[0] == RTMConst.PAUSE_SCRIPT )
			{
				window['pauseFitnessScript']();
			}
			
		if ( resultant[0] == RTMConst.SESSION_COMPLETED )
			{
				let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "logout", "userId": currentUserData.id, "message": 306, "details": JSON.stringify({"status":"success", "action":"Completed"}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);
				sessionDataStore.dumpData();
				
				setTimeout(function () {
					let text = RTMConst.SESSION_COMPLETED+sep;
					sendMessageToChannel(text);
					
					$.ajax({
						  headers: { 
							  "Content-Type": "application/json; charset=utf-8",
							  "Authorization": currentUserData.token
						  },
						  url: Const.BASE_API_PATH +'/api/v1/session/'+currentUserData.sessionData.id+'/completed',
						  type: 'POST',
						   data: JSON.stringify({'duration_session': window['countTimeSession'] ? window['countTimeSession'] : 0}),
						  success: function( data, textStatus, jQxhr ){                  
							  window.logout();
						  },
						  error: function( jqXhr, textStatus, errorThrown ){
										console.log( errorThrown );
										window.logout();
									}
							});

							window['countTimeSession'] = 0;  
							
				}, 2000);
			}
			
		if ( resultant[0] == 'updateSettings' )
			{
				let messageText = JSON.parse(resultant[1]);
				
				if ( messageText && messageText['selectedCameraId'] )
					{
						window['selectDeviceById'](messageText['selectedCameraId'], 'camera');
					}
					
				if ( messageText && messageText['selectedaudioId'] )
					{
						window['selectDeviceById'](messageText['selectedaudioId'], 'mic');
					}

				let startRecording = false;
				let startMusic = false;
				if (messageText && messageText['startRecordingAtStartScript'])
					{
						startRecording = messageText['startRecordingAtStartScript'];
					}
				
				if (messageText && messageText['startMusicAtStartScript'])
					{
						startMusic = messageText['startMusicAtStartScript'];
					}	
					
				if ( window['handleUpdateRemote'] )
					{
						window['handleUpdateRemote'](startRecording, startMusic);
					}					
			}
		
		if ( resultant[0] == 'checkIsStarted' && window['sessionStarted'] )
			{
				var text = RTMConst.SESSION_STARTED+sep;
				sendMessageToChannel(text);
			}
		
		if ( resultant[0] == 'checkActivityRTM' )
			{
				if ( window.nextScriptMessage && uid ) { sendMessage(uid, window.nextScriptMessage); }
			}
		if ( resultant[0] == RTMConst.MEMBER_ONLINE )
			{
				checkUsersOnlineStatus(resultant[1], parseInt(resultant[2]));
				if ( resultant[1] == "joinSession" )
					{
						if ( window['sessionStarted'] )
							{
								let memberData = collection.getDetailsById(parseInt(resultant[2]));
								let memberEmail = memberData.email;
								sendMessage(memberEmail, 'hideMemberFitness');
							}
						
					}
			}
	}
	
	function checkUsersOnlineStatus(status, userId){
		console.log('checkUsersOnlineStatus status', status);
		deleteUserOnlineStatus(userId);
		
		let object = usersOnline;
		if ( !object[status] ) { object[status] = []; }
			
		object[status].push(userId);
		usersOnline = object;
		console.log('checkUsersOnlineStatus', usersOnline);
		showD2CmembersOnline();
	}
	
	function deleteUserOnlineStatus(userId, refreshData, informDatabase){
		let object = usersOnline;
		if ( object['joinWaitingLounge'] && object['joinWaitingLounge'].length > 0 && object['joinWaitingLounge'].indexOf(userId) > -1 )
			{ 
				let ind = object['joinWaitingLounge'].indexOf(userId);
				object['joinWaitingLounge'].splice(ind, 1);
			}
		if ( object['joinRoomSetup'] && object['joinRoomSetup'].length > 0 && object['joinRoomSetup'].indexOf(userId) > -1 )
			{ 
				let ind = object['joinRoomSetup'].indexOf(userId); 
				object['joinRoomSetup'].splice(ind, 1);
			}
		if ( object['joinSession'] && object['joinSession'].length > 0 && object['joinSession'].indexOf(userId) > -1 )
			{ 
				let ind = object['joinSession'].indexOf(userId);
				object['joinSession'].splice(ind, 1);
				
				if ( informDatabase )
					{
						let addObject = {"sessionId": currentUserData.sessionData.id, "event": "status", "eventType": "memberLeft", "userId": userId, "details": JSON.stringify({"msg": "Member left the class"}), "timestamp": Util.getCurrentTimestamp()};
						sessionDataStore.addSessionData(addObject);
					}
			}		
		usersOnline = object;
		console.log('deleteUserOnlineStatus', usersOnline);
		if ( refreshData )
			{
				showD2CmembersOnline();
			}
	}
	
	function showD2CmembersOnline(){
		let data = usersOnline;
		let sessionUsers = JSON.parse(localStorage.getItem('tempUsers'));
		let totalNum = 0;
		if ( sessionUsers && sessionUsers.length > 0 )
			{
				totalNum = sessionUsers.length - 1;
			}
			
		let waitingLoungCount = 0;
		let roomSetupCount = 0;
		let inSessionCount = 0;
		if ( data['joinWaitingLounge'] && data['joinWaitingLounge'].length > 0 ){ waitingLoungCount = data['joinWaitingLounge'].length; }
		if ( data['joinRoomSetup'] && data['joinRoomSetup'].length > 0 ){ roomSetupCount = data['joinRoomSetup'].length; }
		if ( data['joinSession'] && data['joinSession'].length > 0 ){ inSessionCount = data['joinSession'].length; }
	
		if ( window['multiWindow1'] && window['multiWindow1'].document )
			{
				let onlineD2C = window['multiWindow1'].document.getElementById('onlineD2C');
				let waitingD2C = window['multiWindow1'].document.getElementById('waitingD2C');
				let singedUpD2C = window['multiWindow1'].document.getElementById('singedUpD2C');
				let roomSetupD2C = window['multiWindow1'].document.getElementById('roomSetupD2C');
				
				$(onlineD2C).text(inSessionCount);
				$(waitingD2C).text(waitingLoungCount);
				$(singedUpD2C).text(totalNum);
				$(roomSetupD2C).text(roomSetupCount);
			}
			
		if ( window['multiWindow2'] && window['multiWindow2'].document )
			{
				let onlineD2C = window['multiWindow2'].document.getElementById('onlineD2C');
				let waitingD2C = window['multiWindow2'].document.getElementById('waitingD2C');
				let singedUpD2C = window['multiWindow2'].document.getElementById('singedUpD2C');
				let roomSetupD2C = window['multiWindow2'].document.getElementById('roomSetupD2C');
				
				$(onlineD2C).text(inSessionCount);
				$(waitingD2C).text(waitingLoungCount);
				$(singedUpD2C).text(totalNum);
				$(roomSetupD2C).text(roomSetupCount);
			}
	}
	
	window['showD2CmembersOnline'] = showD2CmembersOnline;
	
	window.checkSessionUser = checkSessionUser;
	function checkSessionUser(email) {
      let userDetails = collection.getDetailsByEmail(email);
		
      if(userDetails !== null) {
          return true;
      }

      return false;
	}

	function addUserAttribute(id, key, value){
		if (key === 'isOnline' && window.hasOwnProperty('build_callouts')) {
			window.build_callouts();
		}
      let tempUsers = getTempUsers();

      if(tempUsers != null)
		  {
				for(let i in tempUsers)
				{
					if(tempUsers[i].id == id)
					{
						tempUsers[i][key] = value;
					}
				}
		  }

      localStorage.setItem("tempUsers", JSON.stringify(tempUsers));
	}
	
	function subscribeToVideoStream(userId){
	//if (!currentUserData.isMarketplaceChannel || currentUserData.isMarketplaceChannel===0) {
		console.log('subscribeToVideoStream - ', userId);
		streamArray.forEach((stream) => {
			if ( stream.getId() != undefined && stream.getId() == userId ) 
			{
				if ( window['electron'] ) 
					{
						stream.unmuteVideo();
					} 
				else 
					{
						client.unsubscribe(stream, function(err) {
							//console.log('unsubscribe error - ', err);
						});
						stream.stop();
						client.subscribe(stream);
					}
				$Any('#partNoVideo'+userId).addClass('d-none');
				$Any('#noVideoInitials'+userId).addClass('d-none');
			}
      });
	//}
	}
	
	function subscribeToAudioOnlyStream(userId)
		{
			streamArray.forEach((stream) => {
				if ( stream.getId() != undefined && stream.getId() == userId ) 
					{
						if ( window['electron'] ) 
							{
								stream.muteVideo();
							} 
						else 
							{
								client.unsubscribe(stream, function(err) {
										//console.log('unsubscribe error - ', err);
									});

								stream.stop();
								client.subscribe(stream, {video: false, audio: true});
							}
						$Any('#partNoVideo'+userId).removeClass('d-none');
						$Any('#noVideoInitials'+userId).removeClass('d-none');
						if ( window['canvasOn'+userId] )
							{
								$Any('#closeBtn'+userId).trigger('click');
							}
					}
				});
		}
	
	
	function addToSessionUsers(data) {
      var  participantModelObj = new ParticipantModel();
	  let tempUserData = getTempUsers();
	  let tempUsersIds = [];
	  if ( tempUserData.length > 0 )
		{
			for ( var i = 0; i<tempUserData.length; i++ )
				{
					tempUsersIds.push(tempUserData[i].id);
				}
		}
		
		
      participantModelObj.id = data.id;
      participantModelObj.firstName = data.firstName;
      participantModelObj.lastName = data.lastName;
      participantModelObj.email = data.email;
      participantModelObj.image = data.image;
      participantModelObj.userType = data.userType;
      participantModelObj.isVisible = data.isSubscribe !== undefined ? (data.isSubscribe === 1 ? true : false) : null;
      participantModelObj.sessionStatus = data.sessionStatus;
      participantModelObj.attendedClasses = data.attendedClasses;
	  
	 if ( tempUsersIds.indexOf(data.id) == -1 )
		{
			collection.addModel(participantModelObj);
			tempUserData.push(data);
		}
	  
      
	  localStorage.setItem('tempUsers', JSON.stringify(tempUserData));

	  userArray[data.id] = data.firstName;
	  if ( window['updateSessionUsersList'] )
		{
			window['updateSessionUsersList']();
			window.displayParticipants();
		}
	  
	}
	window['addToSessionUsers'] = addToSessionUsers;
	
	
	function muteDuringMicTest(mod){
		let addObject = {};
		if ( mod == 'mute' )
			{
				localStream.muteAudio();
				addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.INTERACTION, "eventType": "unmute", "userId": currentUserData.id, "details": JSON.stringify({"action": "micOn", "msg": "Local mic turned on"}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);
			}
		else 
			{
				localStream.unmuteAudio();
				addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.INTERACTION, "eventType": "mute", "userId": currentUserData.id, "details": JSON.stringify({"action": "micOff", "msg": "Local mic turned off"}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);
			}			
	}
	
	window['muteDuringMicTest'] = muteDuringMicTest;
	
	window.channelMsgHandler = channelMsgHandler;
    function channelMsgHandler(msg, senderId, userType){
		console.log('channelMsgHandler - ', msg, senderId);
		let res1 = msg.split(sep);

	  
		if ( res1[0] == RTMConst.CHAT )
			{
				if ( senderId.includes("RM-") )
					{
						senderId = senderId.split('RM-')[1];
					}
					
				let userDetails = collection.getDetailsByEmail(senderId);
				window.onReceiveMessage(userDetails, res1[1], "channel", res1[2]);
				
				if ( $Any('#chat_menu').css('display') == 'none' )
					{	
						var messagesCounter = $Any('#chat_counter').text();
						messagesCounter++;
						$Any('#chat_counter').text(messagesCounter);
						$Any('#chat_counter').removeClass('d-none');
						localStorage.setItem('unreadMessagesNum', messagesCounter);
						localStorage.setItem('unreadMessagesClassId', currentUserData.sessionData.id);
					}
			}
		
		
		if( res1[0] == RTMConst.JOINED )
			{
				console.log('RTM JOINED');
				let membersArray = [];
				
				let addObject = null;
				let userId = null;
				let userDetails = null;
				if (senderId.includes("RM-") === false) 
					{
						userDetails = collection.getDetailsByEmail(senderId);
						userId = userDetails.id;
					} 
				else 
					{
						userId = senderId;
					}
					
				let msg = generateSettingString();
				sendMessage(senderId, msg);
				
				addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "receive", "userId": currentUserData.id, "toFromId": userId, "message": RTMConst.JOINED, "details": JSON.stringify({"action": "Joined"}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);
				
				let text = '';
				if ( hostStartedFitnessScript && streamPublished === true) 
					{
						text = RTMConst.WELCOME + sep + 1;
					} 
				else 
					{
						text = RTMConst.WELCOME + sep + 0;
					}
					
				
				if( senderId.includes("RM-") )
					{
						sendMessage(senderId, text);
					}
				else 
					{
						let msg = generateSettingString();
						sendMessage(senderId, msg);
						
						let becomeBroadcasterCount = collection.getBroadcasterCount();
						let userDetails = collection.getDetailsByEmail(senderId);
						
						
						if (userDetails.isVisible === null) 
							{
								animateEmojisAtHost('joined', userDetails, 'joined');
								if ( currentUserData.sessionData.disableNotificationSound == 0 && (!currentUserData.isMarketplaceChannel || (currentUserData.isMarketplaceChannel && currentUserData.isMarketplaceChannel == 0))) 
									{ 
										window.play_notification_sound(); 
									}
							}
						
						
						if (becomeBroadcasterCount < currentUserData.default.maxUserLimit) // || userDetails.isVisible === true
							{
								let updateObject = {"loggedIn": true}; //"isVisible": true
								collection.updateModel(userDetails.id, JSON.stringify(updateObject));
							}
						else
							{
								let updateObject = {"loggedIn": true}; //"isVisible": false
								collection.updateModel(userDetails.id, JSON.stringify(updateObject));
							}
							
						sendMessage(senderId, text);	
					}

				addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": userId, "message": RTMConst.WELCOME, "details": JSON.stringify({"action": "Welcome"}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);		
			}
			
		if ( res1[0] == RTMConst.SEND_EMOJI )
			{
				let userDetails = collection.getDetailsByEmail(senderId);
				var emojiesSend = res1[1];
				var emojiesImage = '';
				
				if ( res1[1] == 'like' ) { emojiesImage = './images/like_emoji.svg'; }
				if ( res1[1] == 'dislike' ) { emojiesImage = './images/dislike_emoji.svg'; }
				if ( res1[1] == 'easy' ) { emojiesImage = './images/easy_emoji.svg'; }
				if ( res1[1] == 'too-hard' ) { emojiesImage = './images/ouch_emoji.svg'; }
				if ( res1[1] == 'perfect' ) { emojiesImage = './images/beast_emoji.svg'; }
				if ( res1[1] == 'awesome' ) { emojiesImage = './images/cool_emoji.svg'; }
				
				let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "receive", "userId": currentUserData.id, "toFromId": userDetails.id, "message": RTMConst.SEND_EMOJI, "details": JSON.stringify({"action": "emoji", "value": res1[1], "name": userDetails.firstName}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);
				
				$Any('#participant_emojie'+userDetails.id).css('background-image', 'url(' + emojiesImage + ')');
				$Any('#participant_emojie'+userDetails.id).removeClass('d-none');
				
				setTimeout(function(){ $Any('#participant_emojie'+userDetails.id).addClass('d-none'); }, 10000);
				
				animateEmojisAtHost(res1[1], userDetails, 'fitness');
				play_emoji_notification_sound();
			}
	}
	
	window.play_notification_sound = function () {
		notification.play();
	}
	
	function play_emoji_notification_sound(){
		emojiNotification.play();
	}
	
	function animateEmojisAtHost(emoji, userDetails, category) {
		
      let userName    = userDetails.firstName.toLowerCase();
      userName        = userName.charAt(0).toUpperCase() + userName.slice(1).toLowerCase();

      if (category == '') {
          $Any('.particlecontainer-host').append('<span class="particle-host"><span class="toptext">'+emoji+'</span><span class="bottomtext">'+userName+'</span></span>');
		} else {
          $Any('.particlecontainer-host').append('<span class="particle-host"><img src="images/'+Const.APPEREANCE[emoji]+'" /><span class="bottomtext">'+userName+'</span></span>');
	  }

		$Any('.particle-host').toArray().forEach(function(particle) {
			$Any(particle).animate({
               right: generateRandomNumber(0, $Any('.particlecontainer-host'))
			}, generateRandomNumber(0, $Any('.particlecontainer-host')), function() {       

				$Any(particle).animate({
                  left: -30 + "%",
                  top: 20 + "%"
				}, generateRandomNumber(15000, 15000), function() {
                  $Any(particle).remove();
				});
			});
		});
	}
	
	var generateRandomNumber = function(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
	}
	
	function addAudienceInList(id) {
      let updateObject = {"raisedHand": true, "raisedHandTime": Util.getCurrentTimestamp()};
      collection.updateModel(id, JSON.stringify(updateObject));
      showHandAtHost();
	}
	
	function showHandAtHost() 
	{
		let audienceList = collection.getHandraisedList();
		if(audienceList.length > 0)
			{
				$Any('.audienceRaiseHand').removeClass('d-none');
				let audienceWithHandsRaised = [];
				for ( var i = 0; i<audienceList.length; i++ )
					{
						if ( usersOnScreenCurrent.indexOf(audienceList[i]['id']) == -1 )	
							{
								audienceWithHandsRaised.push(audienceList[i]);
							} 
					}
				window['updateRaisedHandList'](audienceWithHandsRaised);
			}
		else 
			{
				$Any('.audienceRaiseHand').addClass('d-none');
			}			
	}
	
	window.onChannelMessage = (message, senderId) => {
		console.log('Channel Message - ', message);
		channelMsgHandler(message.text, senderId, currentUserData.userType);
  }
	
	window.checkAvailableAtRTM = checkAvailableAtRTM;
	function checkAvailableAtRTM(peerId, text) {

	  
	  if ( !newclient ) { console.log('not found', text); return false; }
      newclient.sendMessageToPeer({text}, peerId).then(sendResult => {

        if (sendResult.hasPeerReceived) {
            rtmRetryCounter = 0;
            
            let userDetails = collection.getDetailsByEmail(peerId);
            let updateObject = {"isAvailableAtRTM": true};
            collection.updateModel(userDetails.id, JSON.stringify(updateObject));
        } else {            

            if (rtmRetryCounter < 2) {
                rtmRetryCounter++;

                checkAvailableAtRTM(peerId, text);
            } else {

                rtmRetryCounter = 0;

                let userDetails = collection.getDetailsByEmail(peerId);
                let updateObject = {"isAvailableAtRTM": false};
                collection.updateModel(userDetails.id, JSON.stringify(updateObject));

                removeParticipant(userDetails);
            }
        }
      }).catch(error => {
          rtmRetryCounter = 0;

          let userDetails = collection.getDetailsByEmail(peerId);
          let updateObject = {"isAvailableAtRTM": false};
		  if ( userDetails && userDetails.id )
			{
				collection.updateModel(userDetails.id, JSON.stringify(updateObject));
			}
          

          removeParticipant(userDetails);
      });
	}
	
	function enableDualStream(setLowStreamParameter = true) {
      client.enableDualStream(function() {
          console.log("Enable dual stream success!");
      }, function(err) {
          console.log('Dual stream error====', err);
      });
	}
	
	function publish() {
      streamPublished = true;

      client.publish(localStream, function (err) {

          if( !window['electron'] )
          {
            let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"action": "Publish Stream", "msg": err}), "timestamp": Util.getCurrentTimestamp()};
            sessionDataStore.addSessionData(addObject);
          }

          console.log('publish err --- ', err);
          publishErrorHandling(err);
      });

      client.on('stream-published', function (evt) {});
	}
	
	function getTempUsers(){
		return localStorage.getItem(hostlanguage.tempUsers) != undefined ? JSON.parse(localStorage.getItem(hostlanguage.tempUsers)) : [];
	}
	
	function removeParticipant(userDetails) {
		
      if ( userDetails && (userDetails.isAvailableAtRTC === null || userDetails.isAvailableAtRTC === false) && userDetails.isAvailableAtRTM === false && (userDetails.isVisible === true || userDetails.isVisible === false)) {
		
          resetParticipantAttributes(userDetails.id);
          removeStreamFromArray(userDetails.id);
          Util.removeValueFromArray(streamSelectedArray, userDetails.id);
          //Util.switchVideoSize();
          //Util.onPageResize();
		  
		  //need to check this
          //updateHandraiseDD();
          

          //$Any('#palette'+userDetails.id).addClass("d-none");
          //$Any('#repCount'+userDetails.id).addClass('d-none');
		  if ( window['canvasOn'+userDetails.id] ) 
			{ 
				window['canvasWasOn'+userDetails.id] = true; 
			}
          //window['closeDrawing']('', userDetails.id);
          if ( currentUserData.sessionData.disableNotificationSound == 0 && (!currentUserData.isMarketplaceChannel || (currentUserData.isMarketplaceChannel && currentUserData.isMarketplaceChannel == 0))) 
			{ 
				window.play_notification_sound(); 
			}

          let addObject = {"sessionId": currentUserData.sessionData.id, "event": "status", "eventType": "left", "userId": currentUserData.id, "toFromId": userDetails.id, "details": JSON.stringify({"status":"success", "msg": "User not available in RTM & RTC"}), "timestamp": Util.getCurrentTimestamp()};
          sessionDataStore.addSessionData(addObject);

		  //need to check this
          if ( !$Any('.participant_list_popup').hasClass('d-none') ) 
			{ 
				window.displayParticipants(); 
			}
			
          window.onMemberLeft(userDetails.email);
          console.log('###Function - removeParticipant - not available in both RTM & RTC: ' + userDetails.id + ' ' + userDetails.email);
	  }
	  if ( userDetails && userDetails.id )
		{
			$Any('#participant_agora' + userDetails.id).remove();
			removeUserAttribute(userDetails.id, 'cameraAccess');
			removeUserAttribute(userDetails.id, 'micAccess');
			removeUserAttribute(userDetails.id, 'broadcastVideo');
			addUserAttribute(userDetails.id, 'isOnline', false);
			removeStreamFromArray(userDetails.id);
			createDropdown(streamArray.length);
			animateEmojisAtHost('left', userDetails, 'left');
			
			let addObject = {"sessionId": currentUserData.sessionData.id, "event": "status", "eventType": "left", "userId": currentUserData.id, "toFromId": userDetails.id, "details": JSON.stringify({"status":"success", "msg": "User not available in RTM & RTC"}), "timestamp": Util.getCurrentTimestamp()};
			sessionDataStore.addSessionData(addObject);
		}
	 
      
	  
	}
	
	function publishErrorHandling(err) {
      switch(err) {
          case 'PUBLISH_STREAM_FAILED':
                publish();
                break;
          case 'REQUEST_ABORT':
                publishStreamError = true;
                break;
          case 'INVALID_OPERATION':
                initJoinChannel();
                break;
          case 'INVALID_LOCAL_STREAM':
                initLocalStream();
                break;
          case 'PEERCONNECTION_FAILED':
                rtcJoin();
                break;
      }
	}
	
	function resetParticipantAttributes(userId) {
		let updateObject = {"currentStatus": null, 
                            "isVisible": null, 
                            "subscribeTime": null, 
                            "audioMuted": null, 
                            "videoMuted": null, 
                            "raisedHand": null, 
                            "raisedHandTime": null, 
                            "forcedSwapIn": null,
                            "isAvailableAtRTC": null,
                            "isAvailableAtRTM": null,
                            "loggedIn": null,
                            "cameraAccess": null,
                            "micAccess": null,
                            "isPin": null,
                            "hasPoorNetwork": null,
                            "broadcastVideo": null,
                            "debounceValue": null
                        };
      collection.updateModel(userId, JSON.stringify(updateObject));
  }
	
	function initJoinChannel(){
      var channel_key = currentUserData.sessionData.streamToken != undefined ? currentUserData.sessionData.streamToken : null;
      var channelName = currentUserData.sessionData.channelId;
	
      client.join(channel_key, channelName.toString(), currentUserData.id, function(uid) { 
		  window['myuid'] = uid;

          publish();
      }, function(err) {
          console.log("Join channel failed", err);
          let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "type": "rtcJoin", "msg": err}), "timestamp": Util.getCurrentTimestamp()};
          sessionDataStore.addSessionData(addObject);

          if (err == 'SOCKET_ERROR') { initJoinChannel(); }
      });
	}
	
	function initLocalStream() {
		console.log('INIT LOCAL STREAM!!!');
	}
	
	function continueJoin(){
		iterateParticipants();
		rtcJoin();
	}
	
	continueJoin();
	
	var cameraStreams = [];
	function getDevices() {
		$Any('#camera_options').html('');
		$Any('#microphone_options').html('');
		$Any('#speaker_options').html('');
		
		var indexCam = 0;
		let cameraId = null;
		let micId = null;
		let speakId = null;
		let mediaIds = localStorage.getItem(hostlanguage.mediaSetting);
		if ( mediaIds !== undefined )
			{
				mediaIds = JSON.parse(mediaIds);
				if ( mediaIds.camera && mediaIds.camera != null && mediaIds.microphone != null )
					{
						cameraId = mediaIds.camera;
						micId = mediaIds.microphone;
						window['main_mic_id'] = mediaIds.microphone;
						speakId = mediaIds.speaker; 
					}
			}
			
		AgoraRTC.getDevices(function (devices) {
			let device = '';
			let deviceId = '';
			let deviceArray = [];
			let camerasArray = [];
			let micArray = [];
			let spArray = [];
					
			for ( var i = 0; i < devices.length; i++ )
				{
					var checked = '';
					device = devices[i];
					deviceId = device.deviceId;
					deviceArray.push(deviceId+'-'+device.kind);
					
					if ( devices[i].kind === 'videoinput' )
						{
							var cameraDetails = {};
							var choosenCamera = false;
							if ( cameraId == devices[i].deviceId || cameraId == '' )
								{
									cameraIndex = indexCam;
									cameraId = devices[i].deviceId;
									checked = '<div class="drop_checked"></div>';
									choosenCamera = true;
								}
							
							//var videoOptionHtml = '<div class="drop_option" id="chose_camera" data-keyid='+indexCam+' data-value='+deviceId+' >'+devices[i].label+' '+checked+'</div>';
							//var cameraOptions = $Any('#camera_options')[0];
							//cameraOptions.innerHTML += videoOptionHtml;
							
							cameraDetails = {'choosenStatus': choosenCamera, 'indexCam': indexCam, 'deviceId': deviceId, 'label': devices[i].label};
							if ( cameraDetails )
								{
									camerasArray.push(cameraDetails);
								}
							cameraStreams[indexCam] = AgoraRTC.createStream({
							  streamID: Math.floor(Math.random()*1000000),
							  video: true,
							  audio: false,
							  cameraId: devices[i].deviceId,
							});
							
							indexCam++;
						}
						
					if ( devices[i].kind === 'audioinput' )
						{
							var micDetails = {};
							var choosenMic = false;
							if ( micId == devices[i].deviceId || micId == '' )
								{
									micId = devices[i].deviceId;
									window['main_mic_id'] = devices[i].deviceId;
									checked = '<div class="drop_checked"></div>';
									choosenMic = true;
								}
							
							//var micOptionHtml = '<div class="drop_option" id="chose_mic" data-keyid='+devices[i].deviceId+' >'+devices[i].label+' '+checked+'</div>';
							//var micOptions = $Any('#microphone_options');
							//micOptions.innerHTML += micOptionHtml;
							
							micDetails = {'choosenStatus': choosenMic, 'indexCam': devices[i].deviceId, 'deviceId': deviceId, 'label': devices[i].label};
							if ( micDetails )
								{
									micArray.push(micDetails);
								}
						}
						
					if ( devices[i].kind === 'speaker' )
						{
							var spDetails = {};
							var choosenSp = false;
							if ( speakId == devices[i].deviceId )
								{
									speakId = devices[i].deviceId;
									checked = '<div class="drop_checked"></div>';
									choosenSp = true;
								}
								
							//var speakOptionHtml = '<div class="drop_option" id="chose_speak" data-keyid='+devices[i].deviceId+'>'+devices[i].label+' '+checked+'</div>';
							//var speakOptions = $Any('#speaker_options');
							//speakOptions.innerHTML += speakOptionHtml;
							
							spDetails = {'choosenStatus': choosenSp, 'indexCam': devices[i].deviceId, 'deviceId': deviceId, 'label': devices[i].label};
							if ( spDetails )
								{
									spArray.push(spDetails);
								}
						}
				}
			
			if ( window['updateDeviceArray'] )
				{
					window['updateDeviceArray'](camerasArray, micArray, spArray);
				}
			
			
		});
	}
	
	getDevices();
	
	function disableDualStream() {
      client.disableDualStream(function() {
        console.log("Disable dual stream success!");
      }, function(err) {
        console.log("Disable dual stream error - ", err);
      });
	}
	
	function removeUserAttribute(id, key){
		let tempUsers = getTempUsers();

		if(tempUsers != null){
			for(let i in tempUsers){
			  if(tempUsers[i].hasOwnProperty(key) && tempUsers[i].id == id){
				delete tempUsers[i][key];
			  }
			}
      }
        
      localStorage.setItem("tempUsers", JSON.stringify(tempUsers));
  }
	
	function swithMicAndSpeaker(isautoswitch, backupDevice){
		
		if (window['ipad'] == undefined && dualStreamEnabled === true) {
			disableDualStream();
		}
		
		let mediaSetting = localStorage.getItem(hostlanguage.mediaSetting);
		mediaSetting = JSON.parse(mediaSetting);

		let adId = mediaSetting['microphone'];
		let sdId = mediaSetting['speaker'];
		
		
		// check if any selected is available
		if ( adId )
			{
				mediaSetting['microphone'] = adId;
				if ( sdId ) { mediaSetting['speaker'] = sdId; }
				localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaSetting));
				
				if( is_ffox )
				  {
					  var localStream3 = AgoraRTC.createStream({audio: true, microphoneId: mediaSetting.microphone.toString(), video: false});
						localStream3.init(function(){
							var newAudioTrack = localStream3.getAudioTrack();
							localStream.replaceTrack(newAudioTrack);
							if (window['ipad'] == undefined && dualStreamEnabled === true) {
								  enableDualStream(false);
							}						  
						  },function(e){
							if (window['ipad'] == undefined && dualStreamEnabled === true) {
								   enableDualStream(false);
							}
						});
				  }
				else 
				  {
					localStream.switchDevice("audio", adId.toString(), function(){
							
							if( sdId ){ localStream.switchDevice("speaker", sdId.toString(), function() {}); }
							if (window['ipad'] == undefined && dualStreamEnabled === true) {
								   enableDualStream(false);
							}
							
							recordSession.clipRecording();
					},function(e){
						if (window['ipad'] == undefined && dualStreamEnabled === true) {
							  enableDualStream(false);
							}						  
					  });					
				  }
			}
		
		recordSession.doUpdateStreams();
		recordSession.clipRecording();
	}
	
	function muteParticipant(id) {
      streamArray.forEach((stream) => {
        if ( stream.getId() != undefined && ( stream.getId() == id || id == undefined ) ) 
        {
          stream.muteAudio();
        }
      });
	}

	function unmuteParticipant(id) {
      streamArray.forEach((stream) => {
        if ( stream.getId() != undefined && ( stream.getId() == id || id == undefined ) )
        {
          stream.unmuteAudio();
        }
      });
	}
	
	function sendMessageToChannel(text){
      //console.log('###Send message to Channel: ' + currentUserData.email + ' | text: ' + text);

		if ( !channel || !window['rtmChannelJoined'] )
			{
				return false;
			}
		
		if ( recordSession && recordSession.isRecordingNow )
			{
				if ( !rtmStoreMessages[window['currentTimeClass']] )
					{
						rtmStoreMessages[window['currentTimeClass']] = [];
					}
					
				rtmStoreMessages[window['currentTimeClass']].push(text);
				window['rtmStoreMessages'] = rtmStoreMessages;
			}
      
	  channel.sendMessage({text}).then(() => {
          retryCounter = 0;
      }).catch(error => {
        console.log('channel message failed----', error);

        if (retryCounter <= 3) {
            retryCounter++;
            sendMessageToChannel(text);
        } else {
            retryCounter = 0;
        }
      });
	}
	
	var memberZoomed;
	let backDiv = 'host_video';
	function zoomHost(par, userId){
		
		if ( par == 1 && streamZoomedOpen == true )
			{	
				return false;
			}
		
		let currentStream;
		if ( userId )
			{
				streamArray.forEach((stream)=>{
					if ( stream.getId() == userId )
						{
							currentStream = stream;
							memberZoomed = stream.getId();
							backDiv = 'agora_remote_vdo'+userId;
						}
				});
			}
		else 
			{
				currentStream = cameraStreams[cameraIndex];
			}
			
		if ( !currentStream )
			{
				return false;
			}
			
		if ( par == 1 )
			{
				streamZoomedOpen = true;
				$Any('#zoomed_host').removeClass('d-none');
				if ( !userId )
					{
						localStream.stop();
						if ( !window['isMutedByMe'] )
							{
								localStream.unmuteAudio();
							}
						currentStreamingDiv = 'zoom_content';	
						
						/* if ( currentUserData.default.hostVirtual == 1 )
							{
								if ( window['hasConeScript'] && !window['userWhiteboard'][currentUserData.id] )
									{
										console.log('LOADED SCRIPT',currentUserData.id);
										//loadWhiteboard();
										
										window['userWhiteboard'][currentUserData.id] = new whiteboard({'user_id': currentUserData.id, 'host_virtual': true});
										setTimeout(function() { $('#canvasWrap').removeClass('d-none'); }, 2000);
									}
								else if ( window['userWhiteboard'][currentUserData.id] )
									{
										setTimeout(function() { $('#canvasWrap').removeClass('d-none'); }, 2000);
									}
							} */
					}
				currentStream.stop();
				currentStream.init(function(){
					currentStream.play('zoom_content');
				}, function (err) {
					if (err.msg == 'STREAM_ALREADY_INITIALIZED') {
						currentStream.play('zoom_content', function(errState){
						  currentStream.resume();
						});
					}
				});
			}
		else
			{
				streamZoomedOpen = false;
				$Any('#zoomed_host').addClass('d-none');
				$Any('#canvasWrap').addClass('d-none');
				
				if ( !userId )
					{
						localStream.stop();
						if ( !window['isMutedByMe'] )
							{
								localStream.unmuteAudio();
							}
						currentStreamingDiv = 'host_video';	
					}
					
				currentStream.stop();
				currentStream.init(function(){
					currentStream.play(backDiv);
				}, function (err) {
					if (err.msg == 'STREAM_ALREADY_INITIALIZED') {
						currentStream.play(backDiv, function(errState){
						  currentStream.resume();
						});
					}
				});
				memberZoomed = undefined;
				backDiv = 'host_video';
			}
	}
	
	function updateSessionJoinedStatus() {
		$.ajax({
			headers: { 
				"Content-Type": "application/json; charset=utf-8",
				"Authorization": currentUserData.token
			},
			url: Const.BASE_API_PATH +'/api/v1/session/'+currentUserData.sessionData.id+'/joinstatus',
			dataType: 'json',
			type: 'PUT',
			success: function( data, textStatus, jQxhr ){
				console.log(data);
			},
			error: function( jqXhr, textStatus, errorThrown ){
				console.log( errorThrown );
			}
		});

		  return false;
	}
	
	function startSession(){
		var text = RTMConst.SESSION_STARTED+sep;
		sendMessageToChannel(text);

		let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": "all", "message": RTMConst.SESSION_STARTED, "details": JSON.stringify({"action":"startSession", "msg":"Session is started"}), "timestamp": Util.getCurrentTimestamp()};
		sessionDataStore.addSessionData(addObject);
	  
		window['sessionStarted'] = true;
	  
		if ( !window['countTimeSession'] ) { window['countTimeSession'] = 1; }
		setInterval(function()
			{
				if ( alreadyLeftAll ) { return false; }
				if ( window['countTimeSession'] ) { window['countTimeSession']++; }
				if ( window['countTimeSession'] == 30 )
					{
						$.ajax({
								  headers: { 
									  "Content-Type": "application/json; charset=utf-8",
									  "Authorization": currentUserData.token
								  },
								  url: process.env.REACT_APP_API_URL +'/api/v1/session/'+currentUserData.sessionData.id+'/sessionattendtime',
								  type: 'POST',
								  data: JSON.stringify({'duration_session': window['countTimeSession']}),
								  success: function( data, textStatus, jQxhr ){ },
								  error: function( jqXhr, textStatus, errorThrown ){
									  console.log( errorThrown );
								  }
							  });
						
						window['countTimeSession'] = 1;
					}
			
			}, 1000);	
	}
  
	
	window['sendMessageToChannel'] = sendMessageToChannel;
	
	function sendMessage(peerId, text){
		
	console.log('###RTM P2P message======peer id: ' + peerId + ' | text: ' + text);
	
	  if ( !newclient ) { console.log('not found', text); return false; }
      newclient.sendMessageToPeer({text}, peerId).then(sendResult => {

        if (sendResult.hasPeerReceived) {
            retryCounter = 0;
        } else {
            
            if (retryCounter <= 3) {
                retryCounter++;

                sendMessage(peerId, text);
            } else {
                retryCounter = 0;
            }
        }
		
		if ( window['sendSyncToRemote'] && text == '216~@$1' )
			{
				window['sendSyncToRemote']();
			}
		
      }).catch(error => {
          retryCounter = 0;
      });
	}
	
	function generateSettingString()
		{
			/* let str = RTMConst.SETTINGS + sep;
			str = str + currentUserData.sessionData.showOtherParticipants; // show participants video - 0->hide, 1->show
			/*this need to change
			str = str + sep + ($Any("#btn-start-recording").hasClass("d-none") ? 1 : 0); // session recording - 0->recoding not started, 1-> recoding started
			str = str + sep + (unmuteAllEnabled ? 1 : 0); // unmuteall or not - 0-> muteall, 1->unmuteall
			str = str + sep + currentUserData.sessionData.switchHostParticipant; // switch host & particpant enabled or not
			str = str + sep + ( ( currentUserData.sessionData.scriptDetail == undefined || currentUserData.sessionData.scriptDetail.length <= 0 ) ? ( showEmojis === false ? 1 : 1 ) : 0 );

			if( localStorage.getItem("hostSettings") !== null )
				{
					let settings = JSON.parse(localStorage.getItem("hostSettings"));
          
					if( settings.sessionId == currentUserData.sessionData.id && settings.turnoffRoomSetup != undefined )
						{
							str = str + sep + settings.turnoffRoomSetup;
						}
					else
						{
							str = str + sep + 1;
						}
				}
			else
				{
					str = str + sep + 1;
				}

			return str; */
		}

	function rtcCallbacks() {
	
		client.on("peer-online", function (evt) {
			if(evt.uid != Const.STREAM_INJECT_UID) 
				{           
					let updateObject = {"isAvailableAtRTC": true};
					collection.updateModel(evt.uid, JSON.stringify(updateObject));
					newParticipantJoined(evt.uid);            
				}
				console.log('##rtc peer-onlineeeeeeeeeeee     ', evt.uid);
								
		});
		
		client.on('stream-added', function (evt) {
			let stream = evt.stream;

			console.log('##rtc stream-added ', stream.getId());
			let userDetails = collection.getDetailsById(stream.getId());
			if (currentUserData.isMarketplaceChannel===1 && 1==2) { // disable second window
				dispatch({
					type: 'ADD_USER', payload: userDetails
				})
			}else{
			console.log('##rtc stream-added userDetails', userDetails);
			if(stream.getId() != Const.STREAM_INJECT_UID) 
				{		
					if (userDetails.broadcastVideo != false) //userDetails.isVisible === true && 
						{
							client.subscribe(stream, function (err) {
								console.log("Subscribe stream failed", err);
							});
						}
					
					else
						{
							client.subscribe(stream, {video: false, audio: true});
						}
					
				} 
			else 
				{
					if (streamPublished === true) 
						{
							client.subscribe(stream, function (err) {
								console.log("Subscribe stream failed", err);
							});
						} 
				}
			}
      });
	  
		client.on('stream-subscribed', function (evt) {
			let stream = evt.stream;
			console.log('##rtc stream-subscribed ', stream.getId());
			newParticipantStreamSubscribed(stream);
		  });
		  
		client.on("volume-indicator", function(evt){
			  whoIsSpeaking(evt);
		  });
		  
		client.on('mute-audio', function (evt) {
			let updateObject = {"audioMuted": true};
			collection.updateModel(evt.uid, JSON.stringify(updateObject));		
			console.log('##rtc mute-audio ', evt.uid);
			let selectedUsersArray = window['currentSelected'];
			let userId = evt.uid;
			if ( unmuteAllEnabled || selectedUsersArray.indexOf(evt.uid) > -1 )
				{
					//this part will change when participant mute his mic, while unmute all
					$Any('#partActiveMic'+evt.uid).addClass('d-none');
					$Any('#partInActiveMic'+evt.uid).removeClass('d-none');
				}
		});
		
		client.on('unmute-audio', function (evt) {
			let updateObject = {"audioMuted": false};
			collection.updateModel(evt.uid, JSON.stringify(updateObject));
			$Any('#listMic-'+evt.uid).text('On');
			let selectedUsersArray = window['currentSelected'];
			if ( unmuteAllEnabled || selectedUsersArray.indexOf(evt.uid) > -1 )
				{
					$Any('#partActiveMic'+evt.uid).removeClass('d-none');	
					$Any('#raiseHandPart'+evt.uid).addClass('d-none');	
					if ( mutedParticipantsByHost.length > 0 )
						{
							if ( mutedParticipantsByHost.indexOf(evt.uid) > -1 )
								{
									$Any('#partInActiveMic'+evt.uid).addClass('d-none');
									let indexNum = mutedParticipantsByHost.indexOf(evt.uid);
									mutedParticipantsByHost.splice(indexNum, 1);
								}
						}
					let userId = evt.uid;
					let indexSelfMuted = participantsSelfMuted.indexOf(userId);
					if ( ( selectedUsersArray && selectedUsersArray.indexOf(evt.uid) > -1 ) || parseInt(indexSelfMuted) > -1 )  
						{
							$Any('#partInActiveMic'+evt.uid).addClass('d-none');
						}
				}				
			
			console.log('##rtc unmute-audio ', evt.uid);
		});
		
		client.on('mute-video', function (evt) {
			  let updateObject = {"videoMuted": true};
			  collection.updateModel(evt.uid, JSON.stringify(updateObject));
			  
			  let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "video", "userId": currentUserData.id, "toFromId": evt.uid, "details": JSON.stringify({"status":"success", "msg":"Stops sending video"}), "timestamp": Util.getCurrentTimestamp()};
			  sessionDataStore.addSessionData(addObject);

			  console.log('##rtc mute-video ', evt.uid);
		});
		
		client.on('unmute-video', function (evt) {
				/* need to work on this */
			  let str = $Any('#networkmsg-'+evt.uid).text();

			  if (str.includes("Waiting for video…")) {
				  $Any('#networkmsg-'+evt.uid).text('').addClass('d-none');
			  }

			  let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "video", "userId": currentUserData.id, "toFromId": evt.uid, "details": JSON.stringify({"status":"success", "msg":"Video received"}), "timestamp": Util.getCurrentTimestamp()};
			  sessionDataStore.addSessionData(addObject);

			  let updateObject = {"videoMuted": false};
			  collection.updateModel(evt.uid, JSON.stringify(updateObject));

			  console.log('##rtc unmute-video ', evt.uid);
		  });
		  
		client.on('peer-leave', function (evt) {
			  console.log('##rtc peer-leave ', evt.uid, evt.reason);
			  window.removeFmsPalette(evt.uid);
			  var stream = evt.stream;
			  if (stream) 
				  {
					  stream.stop();
				  }
			
			let userDetails = collection.getDetailsById(evt.uid);
			if (userDetails)
				{
					removeUserAttribute(userDetails.id, 'cameraAccess');
					removeUserAttribute(userDetails.id, 'micAccess');
					removeUserAttribute(userDetails.id, 'broadcastVideo');
					addUserAttribute(userDetails.id, 'isOnline', false);
					removeStreamFromArray(userDetails.id);
					$Any('#participant_agora'+userDetails.id).remove();
					createDropdown(streamArray.length);
					updateIsSelected(userDetails.id, false);
					
					makeNewDisplayD2CStreams();
				}
			checkForInterval(evt.uid);	
			
			$Any('#listCam-'+evt.uid).text('Off');
			$Any('#listMic-'+evt.uid).text('Off');
			$Any('#listStatus-'+evt.uid).text('Offscreen');
			
			  if (evt.uid != Const.STREAM_INJECT_UID) {
				  let updateObject = {"isAvailableAtRTC": false};
				  collection.updateModel(evt.uid, JSON.stringify(updateObject));
				  
				  if ( userDetails.broadcastVideo != false )
					{
						$Any('#networkmsg-'+evt.uid).text('Waiting for video…').removeClass('d-none');
					}
				  
				  let text = "1100" + sep;
				  checkAvailableAtRTM(userDetails.email, text);
			  }
			
			window.removeWhiteboard(userDetails.id);
			
			console.log('streamArray', streamArray);
		});
		
		client.on('stream-removed', function (evt) {
			  var stream = evt.stream;
			  stream.stop();

			  console.log('##rtc stream-removed ', stream.getId());
				
			  let userDetails = collection.getDetailsById(stream.getId());
			  if ( userDetails.broadcastVideo != false )
				{
					var str = $Any('#networkmsg-'+stream.getId()).text();
					  if (str === '') {
						  $Any('#networkmsg-'+stream.getId()).text('Waiting for video…').removeClass('d-none');
					  }
				}
			  if ( stream.getId() !== undefined )
				{
					$Any('#participant_agora'+stream.getId()).remove();
					checkForInterval(stream.getId());
				}
		});
		
		
		client.on('first-audio-frame-decode', (evt) => {
				  console.log("first-audio-frame-decode - " + evt.stream.streamId, evt.reason);

			if ( window['electron'] && unmuteAllEnabled )
				{
					/* need to work on this */
					if( evt.reason == 5 ) 
						{
							$Any('#mute-audio'+evt.stream.streamId).removeClass('d-none'); 
							$Any('#unmute-audio'+evt.stream.streamId).addClass('d-none'); 
						}
					else if( evt.reason == 6 ) 
						{
							$Any('#mute-audio'+evt.stream.streamId).addClass('d-none');
							$Any('#unmute-audio'+evt.stream.streamId).removeClass('d-none');
						}
				}
		});
	  
		client.on('first-video-frame-decode',function(evt){
			  console.log("first-video-frame-decode "+evt.stream.streamId);
			  $Any('#networkmsg-'+evt.stream.getId()).text('').addClass('d-none');
		  });
	}

	function newParticipantJoined(publisherId) {
		console.log('newParticipantJoined');
		let userDetails = collection.getDetailsById(publisherId);
		if( !userDetails ) { return false; }


		if ($Any('#hostParticipantStreamsList #participant_agora'+publisherId).length === 0) 
			{
				console.log('-------------------------------#hostParticipantStreamsList #participant_agora length === 0');
				let onscreenCount = usersOnScreenCurrent.length;
				let updateObject = null;
				
				if (onscreenCount < currentUserData.default.maxUserLimit) //userDetails.isVisible === true && 
					{
						updateObject  = {"currentStatus": 1, "subscribeTime": Util.getCurrentTimestamp()};
					} 
				else 
					{  
						updateObject  = {"currentStatus": 1, "isVisible": false, "subscribeTime": Util.getCurrentTimestamp()};
					}
				collection.updateModel(publisherId, JSON.stringify(updateObject));
			}
	}
	
	function whoIsSpeaking(speakers) 
	{
		if (unmuteAllEnabled) 
			{
				let speakerName = [];

				speakers.attr.forEach(function(volume, index){
				  if ( ( volume.level && volume.level >= 5 ) || ( volume.volume && volume.volume >= 5 ) ) {
					  speakerName.push(userArray[volume.uid]);
				  }
				});
				
				$Any('.currentSpeakerName').text(speakerName.join(" | "));
			}
	}
	var nowArray = 0;
	function newParticipantStreamSubscribed(stream, dontImport)
		{
			console.log('subscribed participant---', stream);
			if(stream.getId() == Const.STREAM_INJECT_UID) 
				{
					stream.play('agora_local_inject', function(errState){           
						if (errState && errState.status !== "aborted"){
							stream.resume();
						}
					});
				} 
			else 
				{
					var userDetails = collection.getDetailsById(stream.getId());
					
					console.log('userDetails***************');
					console.log('userDetails');
				
					if( !userDetails ) { return false; }
					
					if ( !dontImport )
						{
							removeStreamFromArray(userDetails.id);
						}
					let subscribeToAudio = false;
					
					var firstLetter = userDetails.firstName.substring(0, 1).toUpperCase();
					var lastLetter = userDetails.lastName.substring(0, 1).toUpperCase();
					var initials = firstLetter+lastLetter;
				
					var classHidden = '';
					var maxOnScreen = currentUserData.default.maxUserLimit;
					var currentOnScreen = 0;
					if ( $Any('#hostParticipantStreamsList .participantStreamPart').length ) { currentOnScreen = $Any('#hostParticipantStreamsList .participantStreamPart').length; }
					
					if ( currentOnScreen >= maxOnScreen ) { classHidden = 'd-none'; }
					
					var biggerFont = '';
					if ( currentUserData.isMarketplaceChannel && currentUserData.isMarketplaceChannel == 1 )
						{
							biggerFont = 'bfd2c';
						}
						
					if ( window['currentFmStation'] && window['currentFmStation'] != "" )
						{
							var msgFM = "feedFm"+sep+"play"+sep+window['currentFmStation']+sep+window['currentFmName'];
							setTimeout(() => { sendMessage(userDetails.email, msgFM); }, 3000);
						}
				
					if ( window['isMutedFm'] )
						{
							setTimeout(() => { window['sendMessageToChannel']("feedFm"+sep+"mute"+sep+true); }, 3000);
						}
					
					var elementExists = $Any("#participant_agora"+userDetails.id);
					console.log(elementExists.length, 'elementExists');
					if ( elementExists.length == 0 )
						{
							let showMicAtJoin = 'd-none';
							if ( unmuteAllEnabled )
								{
									showMicAtJoin = '';
								}
								
							var attendedClasses = ``;
							var zoomIcon = `<div class="zoomMemberIcon" id="zoomMember${userDetails.id}" userDetails-id=${userDetails.id} ></div>`;
							if ( currentUserData.isMarketplaceChannel && currentUserData.isMarketplaceChannel == 1 )
								{
									var classesAttendedNum = parseInt(userDetails.attendedClasses) + 1;
									attendedClasses = `(${classesAttendedNum})`;
									zoomIcon = ``;
								}
							
								
							var template =  `<div class="participantStreamPart ${classHidden}" data-id="${userDetails.id}" id="participant_agora${userDetails.id}" >
											<div class="network_msg_audience bg-grayy text-white d-none" id="networkmsg-${userDetails.id}"></div>
											<div id="canvasWrap${userDetails.id}" class="canvasHold d-none">
											<div id="progressBarHost${userDetails.id}" class="hostProgressBar d-none">
												<div id="progressHost${userDetails.id}" class="hostProgress"></div>
											</div>
											<div id="bagToolTip${userDetails.id}" class="screen_popup room_capturing_popup bg-grayy rounded hostToolTip2 d-none"></div>
											<div class="tooltipSuccess screen_popup p-4 bg-grayy rounded d-none" id="successMark${userDetails.id}">
												<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
												<div class="white_hdng">Member is in position</div>
											</div>
											<div class="tooltipSuccess screen_popup p-4 bg-grayy rounded d-none" id="successMarkPar${userDetails.id}">
												<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
											</div>
											<div class="equipment_stats_hold stats_hold_host d-none">
												<span class="inner_status_hold no_padd">
													<div>
														<div class="stats_image" id="repCountImage${userDetails.id}"></div>
														<div class="stats_value d-none" id="repCount${userDetails.id}">0</div>
													</div>
													<div id="secondStats">
														<div class="stats_image reverse_second_image" id="perCountImage${userDetails.id}"></div>
														<div class="stats_value ppm_count d-none" id="ppmCount${userDetails.id}">
															<div class="counter-number ppm_value">0</div><div class="act-text ppm_text" style="font-size: 12px;" id="pmName${userDetails.id}"></div>
														</div>
													</div>
													<div>
														<div class="stats_image heart_stats"></div>
														<div class="stats_value ppm_count" id="heartStats${userDetails.id}">
															<div class="counter-number ppm_value">0</div><div class="act-text ppm_text" style="font-size: 12px;">hr</div>
														</div>
													</div>
													<div>
														<div class="stats_image calories_image"></div>
														<div class="stats_value ppm_count" id="caloriesCount${userDetails.id}">
															<div class="counter-number ppm_value">0</div><div class="act-text ppm_text" style="font-size: 12px;">kcal</div>
														</div>
													</div>
												</span>
											</div>
											<div class="canvas-close-icon position-absolute d-none" close-id="${userDetails.id}" id="closeBtn${userDetails.id}"></div>
											<canvas class="canvasDraw" id="sessionCanvas${userDetails.id}" width="1280" height="720" oncontextmenu="return false"></canvas><canvas class="canvasGrid canvasImage" id="imageCanvas${userDetails.id}" width = "1280" height="720"></canvas><canvas class="canvasImage" id="bufferCanvas${userDetails.id}" width = "640" height="360"></canvas>
											<div class="canvasDot" id="editDot${userDetails.id}"></div>
										</div>
										
										<span id="newToolTip${userDetails.id}" class="hostToolTip screen_popup room_capturing_popup bg-grayy rounded d-none">
											<span class="separate_stats tool_tip_inner tool_tip_inner_host">
												<span class="tooltipSuccess d-none">
													<svg class="checkmark checkmark_inline checkmark_host" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
														<circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
														<path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
													</svg>
												</span>
												<div class="tooltipImage tooltipImageHost d-none"></div>
												<span class="upNext d-none">UP NEXT:</span>
												<div class="tooltipText actNameHost rounded"></div>
												<div id="innerPartText${userDetails.id}" class="part_inner"></div>
												<div id="walkToolImage${userDetails.id}" class="walk_tool_hold walk_tool_hold_host pointer d-none">
													<div class="walk_tool_text walk_tool_text_host"></div>
												</div>
												<div class="tooltipNumber d-none"></div>
											</span>
											<span id="progressHostRoom${userDetails.id}" class="progressHostRoom separate_stats d-none"></span>
										</span>
									
										<div id="setupEquipmentHold${userDetails.id}" class="movedEqButtonHold d-none">
											<div id="movedEquipmentText${userDetails.id}" class="equipmentSetupText d-none">Equipment is ready</div>
											<div id="movedEquipment${userDetails.id}" class="equipmentTagsHolder d-none">Set up equipment</div>
										</div>
										
										<div id="audioPlaying${userDetails.id}" class="audioPlayingHold d-none">
											<div class="audioPlayingIcon" data-toggle="tooltip" title="Virtual Instructions Playing"></div>
										</div>
										
										<div id="agora_remote_vdo${userDetails.id}" class="video-streams h-100 stream-bg"></div>
										<div class="emojies_stream d-none" id="participant_emojie${userDetails.id}"></div>
										<div class="raiseHandPartHolder d-none" userDetails-id=${userDetails.id} id="raiseHandPart${userDetails.id}"></div>
										<div class="participantStreamName">
											<div class="nameHoldMax ${biggerFont}">
												${userDetails.firstName} ${attendedClasses}
											</div>
											${zoomIcon}
										</div>
										<div class="cameraMicHolder" >	
											<div class="noVideoPartHolder d-none" id="partNoVideo${userDetails.id}">
												<div class="muteVideo" ></div>
											</div>
											<div class="micMutePartHolder mutedMicPartHolder d-none" userDetails-id=${userDetails.id} id="partInActiveMic${userDetails.id}"></div>
											<div class="micMutePartHolder micUnMutePartHolder ${showMicAtJoin}" userDetails-id=${userDetails.id} id="partActiveMic${userDetails.id}" ></div>
										</div>
										<div class="noVideoInitialsHolder d-none" id="noVideoInitials${userDetails.id}">
											<div class="noVideoInitials">${initials}</div>
										</div>
										<div id="setupInstructions${userDetails.id}" class="equipmentSetup d-none">
											<div class="setupText">Set up equipment for virtual activity</div>
											<div class="setupInnerText">Click and drag the equipment to the desired location. <br> Step 2</div>
											<div id="setupButton${userDetails.id}" class="setupButtonHold equipmentReady pointer">
												<div class="setupButtonText setupButtonTextHost">Equipment is ready</div>
											</div>
											<div class="applyToAll">
												<div class="setupButtonText setupButtonTextHost">Apply to all</div>
												<input id="applyToAll${userDetails.id}" type="checkbox" class="form-radio applyCheck" />
											</div>
										</div>
								</div>`;
							
							if ( window['sendSyncWhenPartJoin'] )
								{
									window['sendSyncWhenPartJoin']();	
								}
								
							//dispatch({type: 'LOAD_TEMPLATE', payload: templateMulti})
							
							console.log('multiScreenMemberView', $Any('#multiScreenMemberView'));
							
							if ( currentUserData.isMarketplaceChannel && currentUserData.isMarketplaceChannel == 1 && (!window['multiWindow1'] || !window['multiWindow2'] || (window['multiWindow1'] && window['multiWindow1'].closed) || (window['multiWindow2'] && window['multiWindow2'].closed)))
								{
									console.log('run secondary window');
									secondaryWindowCall.openNewWindows();
									if ( window['resubscribeAll'] )
										{
											window['resubscribeAll']();
										}
									if ( window['showD2CmembersOnline'] )
										{
											window['showD2CmembersOnline']();
										}
								}
							
							if ( window['multiWindow1'] && window['multiWindow1'].document && nowArray == 0 )
								{
									nowArray = 1;
									var multiParent = window['multiWindow1'].document.querySelector("#participantListView");
									$(multiParent).append(template);
								}
							else if ( window['multiWindow2'] && window['multiWindow2'].document && nowArray == 1 )
								{
									nowArray = 0;
									var multiParent2 = window['multiWindow2'].document.querySelector("#participantListView");
									$(multiParent2).append(template);
								}
							else
								{
									$('#hostParticipantStreamsList').append(template);
								}
							console.log('userDetails****************');
							console.log(userDetails);
							
							if ( userDetails.broadcastVideo == false )
								{
									console.log('userDetails.broadcastVideo == false');
									$Any('#partNoVideo'+userDetails.id).removeClass('d-none');
									$Any('#noVideoInitials'+userDetails.id).removeClass('d-none');
									if ( userDetails.cameraAccess !== null && userDetails.cameraAccess == 'Denied' )
										{
											$Any('#networkmsg-'+userDetails.id).text('Camera Access Declined').removeClass('d-none');
										}
								}
							else
								{
									console.log('userDetails.broadcastVideo != false');
									changeNetworkmsg(userDetails);
								}
							
							if ( classHidden != '' )
								{
									subscribeToAudio = true;
								}
							else
								{
									usersOnScreen.push(userDetails.id);
									usersOnScreenCurrent.push(userDetails.id);
									updateIsVisible(userDetails.id, true);
									if ( window['electron'] ) 
										{
											if ( userDetails.broadcastVideo != false )
												{
													stream.unmuteVideo();
												}
										}
								}
						}
					else
						{
							if ( userDetails.broadcastVideo == false )
								{
									$Any('#partNoVideo'+userDetails.id).removeClass('d-none');
									$Any('#noVideoInitials'+userDetails.id).removeClass('d-none');
								}
							else
								{
									changeNetworkmsg(userDetails);
									$Any('#partNoVideo'+userDetails.id).addClass('d-none');
									$Any('#noVideoInitials'+userDetails.id).addClass('d-none');
								}
						}
				
				if (!currentUserData.isMarketplaceChannel || currentUserData.isMarketplaceChannel===0 || 1==1) { // disable second window
					console.log('**********MATCH***********');
					stream.play('agora_remote_vdo' + userDetails.id, function(errState){
						console.log('------errState', errState);
						if (errState && errState.status !== "aborted"){
							stream.resume();
						}
					});
				}
					
					if ( !dontImport ) 
						{ 
							console.log('push to streamArray***************');
							streamArray.push(stream); 
						}
					
					console.log('streamArray after push**********');
					console.log(streamArray);
					
					recordSession.doUpdateStreams(streamArray); // Add for recording if needed
					checkOnScreenNum();
					
					
					if ( subscribeToAudio ) 
						{
							subscribeToAudioOnlyStream(userDetails.id);
						}
					
					if( safari )
						{
							$Any('#networkmsg-'+userDetails.id).text('').addClass('d-none');
						}

					if (previousNetworkQuality < 3) 
						{
							setParticipantResolutionToLow(stream);
						} 
					else 
						{
							setParticipantResolutionToHigh(stream);
						}

					console.log('###stream-subscribed=======user id: ' + userDetails.id + ' ' + userDetails.email);
					console.log('loadPreWhiteboard 111');
					if ( window['hasConeScript'] )
						{
							console.log('loadPreWhiteboard 222');
							window['globalRTM'](window['allPartDetails'][userDetails.id]['email'], 'checkDeviceForVirtual'+sep);
							console.log('loadPreWhiteboard 333');
							
							completeRoomSetup(userDetails.id);
								
							if ( window['userWhiteboard'][currentUserData.id] && window['userWhiteboard'][currentUserData.id].roomSetup.workoutAreaSetupDone )
								{
									var message = 'preStreamingRoomSetup'+sep+JSON.stringify(window['userWhiteboard'][currentUserData.id].roomSetup.workoutConeLocation);
									window['userWhiteboard'][currentUserData.id].splitRTMSend(userDetails.email, message);
								}
						}

					if (unmuteAllEnabled) {
						
						var massages = RTMConst.OPEN_MIC+sep; 
						sendMessage(userDetails.email, massages);
						$Any('#unmute-audio'+userDetails.id).removeClass('d-none');
					}
					
					hideControls(userDetails.id);
					createDropdown(streamArray.length);
					runStreamsInterval();
				}
			window.displayParticipants();
		}
		
	function makeNewDisplayD2CStreams(){
		var inScreen1 = 0;
		var inScreen2 = 0;
		if ( window['multiWindow1'] && window['multiWindow1'].document )
			{
				var multiParent = window['multiWindow1'].document.querySelectorAll("#participantListView .participantStreamPart");
				console.log('multiParent******');
				console.log(multiParent);
				inScreen1 = multiParent.length;
			}
		if ( window['multiWindow2'] && window['multiWindow2'].document)
			{
				var multiParent2 = window['multiWindow2'].document.querySelectorAll("#participantListView .participantStreamPart");
				console.log('multiParent2******');
				console.log(multiParent2);
				inScreen2 = multiParent2.length;
			}
		var diff = inScreen1 - inScreen2;
		
		
		if ( diff > 0 )
			{
				nowArray = 1;
			}
		else
			{
				nowArray = 0;
			}
			
		if ( diff > 1 && multiParent )
			{
				var diff1 = Math.floor(diff/2);
				var diff2 = inScreen1-diff1;
				
				var nowI = 1;
				multiParent.forEach((elm)=>{
					console.log(nowI);
					console.log(diff2);
					console.log(elm);
					if ( nowI > diff2 )
						{
							var eId = elm.getAttribute('data-id');
							console.log('atribute****', eId);
							$(elm).remove();
							nowArray = 1;
							streamArray.forEach((stream) => {
							if ( stream.getId() == eId )
								{
									console.log('*****resubscribeAll******');
									console.log(stream);
									nowArray = 1;
									subscribeToAudioOnlyStream(stream.getId());
								  newParticipantStreamSubscribed(stream, true);
								}
						  });
						}
					nowI++;
				});
			}
		else if ( diff < -1 )
			{
				var diff1 = Math.floor((diff*-1)/2);
				var diff2 = inScreen2-diff1;
				
				var nowI = 1;
				multiParent2.forEach((elm)=>{
					console.log(nowI);
					console.log(diff2);
					console.log(elm);
					if ( nowI > diff2 )
						{
							var eId = elm.getAttribute('data-id');
							console.log('atribute****', eId);
							$(elm).remove();
							nowArray = 0;
							streamArray.forEach((stream) => {
							if ( stream.getId() == eId )
								{
									console.log('*****resubscribeAll******');
									console.log(stream);
									nowArray = 0;
									subscribeToAudioOnlyStream(stream.getId());
								  newParticipantStreamSubscribed(stream, true);
								}
						  });
						}
					nowI++;
				});
			}
	}
	
	function resubscribeAll(clickedManually){
		console.log('streamArray*********************');
		console.log(streamArray);
		
		streamArray.forEach((stream) => {
				if ( stream.getId() != undefined )
					{
						subscribeToAudioOnlyStream(stream.getId());
					}
		 });
		
		streamArray.forEach((stream) => {
			if ( stream.getId() != undefined )
				{
					console.log('*****resubscribeAll******');
					console.log(stream);
				  newParticipantStreamSubscribed(stream, true);
				}
		  });
		  
		if ( clickedManually )
			{
				streamArray.forEach((stream) => {
					if ( stream.getId() != undefined )
						{
							var userId = stream.getId();
							if ( window['userWhiteboard'][userId] )
								{	
									window['userWhiteboard'][userId].loadElements();
									if ( window.currentActivity && window.currentActivity.attribute && window.currentActivity.attribute[0]['attrValue'] == 'Virtual Equipment' ) { $Any('.canvasHold').removeClass('d-none'); }
								}
						}
				  });
			}
	}
	
	window['resubscribeAll'] = (clickedManually)=>{ resubscribeAll(clickedManually) };
		
	function changeNetworkmsg (userDetails) {
		console.log('changeNetworkmsg*******************');
		console.log(userDetails);
		if (userDetails.cameraAccess !== null && userDetails.cameraAccess == 'Denied') 
			{
				console.log('match remove -Camera Access Declined-');
				$Any('#networkmsg-'+userDetails.id).text('Camera Access Declined').removeClass('d-none');
			}
		else 
			{
				console.log('match remove -Waiting for video…-');
				$Any('#networkmsg-'+userDetails.id).text('Waiting for video…').removeClass('d-none');
			}
	}
	
	function setParticipantResolutionToLow(stream) {
		client.setRemoteVideoStreamType(stream, Const.STREAM_TYPE.LOW);
	}
	
	function setParticipantResolutionToHigh(stream) {
		client.setRemoteVideoStreamType(stream, Const.STREAM_TYPE.HIGH);
	}
	

	function inactivityTime() {
		var time;
        var defTimer = 20;
		
		if ( currentUserData.default.hideMenuTimer )
			{
				defTimer = parseInt(currentUserData.default.hideMenuTimer);
			}
        // events
        window.onload = resetTime;
        window.onclick = resetTime;
        window.onkeypress = resetTime;
        window.ontouchstart = resetTime;
        window.onmousemove = resetTime;
        window.onmousedown = resetTime;
        window.addEventListener('scroll', resetTime, true);

        function alertUser() {
            // do your task here
            hideAllElements();
        }

        function resetTime() {
			clearTimeout(time);
            time = setTimeout(alertUser, 1000 * defTimer); // 10 seconds
			showAllElements();
        }

    };
	
	// run the function
    inactivityTime();	
	

	function hideAllElements()
		{
			$Any('#hostControlsD2C').addClass('opacityHide');
		}
		
	function showAllElements()
		{
			
		}	
	
	function showFromAudiance(userId){
		var idToDelete = 0;
		var isFound = false;
		
		for ( var p = 0; p < usersOnScreenCurrent.length; p++ )
			{
				let userDetails = collection.getDetailsById(usersOnScreenCurrent[p]);
				
				if ( !userDetails.isSelected && !isFound )
					{
						isFound = true;
						idToDelete = JSON.parse(JSON.stringify(usersOnScreenCurrent[p]));
					}
			}
		if ( isFound === false )
			{
				return false;
			}			
		var removeStreamDetails = collection.getDetailsById(idToDelete);
		console.log('HIDE USER FROM LIST---', idToDelete);
		checkIfCurrentUserRaisedHand(removeStreamDetails);
		subscribeToAudioOnlyStream(idToDelete);
		
		$Any('#participant_agora'+idToDelete).addClass('d-none');
		let indexNum = usersOnScreenCurrent.indexOf(idToDelete);
		usersOnScreenCurrent.splice(indexNum, 1);
		updateIsVisible(idToDelete, false);
		
		let id = parseInt(userId);
		
		var userDetailsStream = collection.getDetailsById(id);
		if ( userDetailsStream && userDetailsStream.broadcastVideo != false )
			{
				changeNetworkmsg(userDetailsStream);
				subscribeToVideoStream(id);
			}
		
		console.log('SHOW USER ON LIST---', userDetailsStream);
		usersOnScreen.push(id);
		usersOnScreenCurrent.push(id);
		$Any('#participant_agora'+id).removeClass('d-none');
		updateIsVisible(id, true);	
		updateIsSelected(id, true);
		$Any('#participant_agora'+id).addClass('participant_fms_selected');		
		checkIfUserRaisedHand(userDetailsStream)	


		if ( usersOnScreen.length >= (streamArray.length-1) ) 
			{
				usersOnScreen = JSON.parse(JSON.stringify(usersOnScreenCurrent));
			} 		
			
	}		
		
	function runStreamsInterval(){
		
		var maxOnScreen = currentUserData.default.maxUserLimit;
		var currentOnScreen = 0;
		if ( $Any('#hostParticipantStreamsList .participantStreamPart').length ) 
			{ 
				currentOnScreen = $Any('#hostParticipantStreamsList .participantStreamPart').length; 
			}
			
		if ( currentOnScreen >= maxOnScreen )
			{
				if ( window['switchMembersInterval'] ) 
					{ 
						return false; 
					}
				
				console.log('currentOnScreen > maxOnScreen');
				var intervalSeconds = 1000 * parseInt(currentUserData.default.participantSwitchDuration);
				window['switchMembersInterval'] = setInterval(function(){
					var idToDelete = 0;
					var isFound = false;
					
					for ( var p = 0; p < usersOnScreenCurrent.length; p++ )
						{
							let userDetails = collection.getDetailsById(usersOnScreenCurrent[p]);
							
							if ( !userDetails.isSelected && !isFound )
								{
									isFound = true;
									idToDelete = JSON.parse(JSON.stringify(usersOnScreenCurrent[p]));
								}
						}
					var foundToShow = false;
					let usersOnScreenNum = usersOnScreen.length;
					for ( let y = 0; y < streamArray.length; y++ )
						{
							if ( streamArray[y] )
								{
									let streamId = streamArray[y].getId();
									if ( streamId != undefined && usersOnScreen.indexOf(streamId) == -1 && !foundToShow && streamId != currentUserData.sessionData.hostId && streamId != idToDelete && idToDelete != 0 )
										{
											var removeStreamDetails = collection.getDetailsById(idToDelete);
											console.log('HIDE USER FROM LIST---', idToDelete);
											checkIfCurrentUserRaisedHand(removeStreamDetails);
											subscribeToAudioOnlyStream(idToDelete);
											
											$Any('#participant_agora'+idToDelete).addClass('d-none');
											let indexNum = usersOnScreenCurrent.indexOf(idToDelete);
											usersOnScreenCurrent.splice(indexNum, 1);
											updateIsVisible(idToDelete, false);
											
											var userDetailsStream = collection.getDetailsById(streamId);
											if ( userDetailsStream && userDetailsStream.broadcastVideo != false )
												{
													changeNetworkmsg(userDetailsStream);
													subscribeToVideoStream(streamId);
												}
											
											//console.log('SHOW USER ON LIST---', userDetailsStream);
											
											usersOnScreen.push(streamId);
											usersOnScreenCurrent.push(streamId);
											$Any('#participant_agora'+streamId).removeClass('d-none');
											updateIsVisible(streamId, true);	
											checkIfUserRaisedHand(userDetailsStream);
																					
											if ( usersOnScreenNum >= (streamArray.length-1) )  
												{
													usersOnScreen = JSON.parse(JSON.stringify(usersOnScreenCurrent));
												} 	
												
											var visibleLength = usersOnScreenCurrent.length;
											if ( visibleLength => maxOnScreen ) { foundToShow = true; }
										}
								}
						}
				}, intervalSeconds); 
			}
		else
			{
				if ( window['switchMembersInterval'] ) { clearInterval(window['switchMembersInterval']); window['switchMembersInterval'] = null; }
			}
		
		 
	}			
	
	function checkIfUserRaisedHand(mod){
		if ( mod.raisedHand )
			{
				if ( window['removeUserFromAudienceList'] )
					{
						window['removeUserFromAudienceList'](mod.id);
					}
			}
	}
	
	function checkIfCurrentUserRaisedHand(mod){
		if ( mod.raisedHand && mod.audioMuted )
			{
				if ( window['addUserToAudienceList'] )
					{
						window['addUserToAudienceList'](mod);
					}
			}
		else 
			{
				return false;
			}			
	}
	
	function hideControls(id)  
		{
			var video = $Any("#video"+id)[0];
			if ( video ) { video.removeAttribute("controls"); }
		}
		
	function removeStreamFromArray(streamId) {
		console.log('removeStreamFromArray**********');
		let streamsLength = streamArray.length;
		if (streamsLength > 0)
			{
				for (let i = 0; i < streamsLength; i++)
					{
						if (streamArray[i] != undefined && streamArray[i].getId() != undefined && streamId == streamArray[i].getId())
							{
								streamArray.splice(i, 1);
								checkOnScreenNum();
							}
					}
			}
  }		


	window['globalRTM'] = sendMessage;
	
	function leave() {
		if ( window['electron'] && client && client['agora'] && client['agora'].muteAllRemoteVideoStreams )
			{ 
				client.muteAllRemoteVideoStreams();
				client.muteAllRemoteAudioStreams();
			}

		if ( !localStream ) { setTimeout(function(){ $Any('#session-started-alert').modal('hide'); }, 2000); return false; }
			
		 client.leave(function () {
			if(localStream.isPlaying()) {
			  localStream.stop();
			} 

			// close stream
			localStream.close();

			streamArray.forEach((stream)=>{
			  if (stream.getId() != undefined) {
				if ( window['electron'] ) 
				{
					//stream.destroyRender(stream.getId(), currentUserData.sessionData.channelId.toString());
				}
				else
				{
					if(stream.isPlaying()) {
					  stream.stop();
					}
				}

				$Any('#participant_agora' + stream.getId()).remove();
			  }
			});
		  }, function (err) {
			console.log("Leave channel failed");
		  });
	}
	
	function leave_channel() {
		if ( newclient )
			{
				newclient.logout();
			}
		
		if ( channel )
			{	
				channel.leave();
			}
		
		stopAllStreams();
	}
	
	function removeSession(){
		localStorage.removeItem(hostlanguage.userData);
		localStorage.removeItem(hostlanguage.tempUsers);
		localStorage.removeItem(hostlanguage.videoResolution);
	}
	
	function stopAllStreams(){
		for( let i in cameraStreams )
			{
				cameraStreams[i].stop();
				cameraStreams[i].close();
			}
		if ( localStream )
			{
				localStream.muteAudio();
				localStream.stop();
				localStream.close();
			}
	}
	
	function checkOnScreenNum(){
		let currentInSession = streamArray.length;			
		$Any('#currentOnScreenNum').html(currentInSession);
		
	}
	
	function refreshTokenUpdate()
		{
			  let data_op = JSON.parse(localStorage.getItem("userData"));

        if ( data_op != null )
        {
    			  $.ajax({headers: {"Content-Type": "application/json; charset=utf-8", "Authorization": data_op.token},
    				  url: Const.BASE_API_PATH +'/api/v1/user/refreshToken',
    				  type: 'GET',
    				  dataType: 'json',
    				  success: function( data, textStatus, jQxhr )
    				  {
    					if ( data.responseData.tokenData )
    						{
    							var userData = JSON.parse(localStorage.getItem('userData'));
    							userData['token'] = data.responseData.tokenData[0];
    							userData['tokenExpire'] = data.responseData.tokenData[1];
    							localStorage.setItem('userData', JSON.stringify(userData));
    							
    							console.log('Update token ----', data.responseData.tokenData);
    						}
  				  }});
        }
		}
	
	setInterval(function () { refreshTokenUpdate(); }, 3600000); // Refresh every hour
	setTimeout(function () { refreshTokenUpdate(); }, 30000); // Initial refresh after 30 seconds
	
	window.showOtherParticipantsStateChanged = (state) => {
		var text = RTMConst.SETTINGS+sep+state;
		sendMessageToChannel(text);
		
		let updatedUserData = JSON.parse(localStorage.getItem('userData'));
		
		updatedUserData.sessionData.showOtherParticipants = state;
		localStorage.setItem('userData', JSON.stringify(updatedUserData));
		currentUserData = updatedUserData;
	}
	
	window.disableSoundStateChanged = () => {
		currentUserData = JSON.parse(localStorage.getItem("userData"));
	}
	
	window.roomSetupStateChanged = (state) => {
		state = state ? 1 : 0;
		var text = RTMConst.ROOM_SETUP_TURN_OFF+sep+state;
		sendMessageToChannel(text);
	}
	
	window.dimensionsChanged = (state) => {
		state = state ? 1 : 0;
		var text = RTMConst.CALCULATE_DIMENSIONS+sep+state;
		sendMessageToChannel(text);
	}
	
	window.switchHostParticipantStateChanged = (state) => {
		var text = RTMConst.SWITCH_HOST_PARTICIPANT+sep+state;
		sendMessageToChannel(text);
		currentUserData = JSON.parse(localStorage.getItem("userData"));
	}
	
	window.muteAllHandler = () => {
		console.log('muteAllHandler ****************************************');
		instructorMuteAll = true;
		unmuteAllEnabled = false;
		collection.changeAudioMutedState(true);
     
		muteParticipant();

		var text = RTMConst.MUTE_ALL + sep;
		sendMessageToChannel(text);
	
		let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": "all", "message": RTMConst.MUTE_ALL, "details": JSON.stringify({"action": "muteAll"}), "timestamp": Util.getCurrentTimestamp()};
		sessionDataStore.addSessionData(addObject);

		streamArray.forEach((stream) => { 
			$Any('#partInActiveMic'+stream.getId()).addClass('d-none');
			$Any('#partActiveMic'+stream.getId()).addClass('d-none');
		 });
  }
  
	window.unmuteAllHandler = () => {
		unmuteAllEnabled = true;

		var text = RTMConst.UNMUTE_ALL + sep;
		sendMessageToChannel(text);

		let updateObject = {"audioMuted": false, "raisedHand": null, "raisedHandTime": null, "forcedSwapIn": null};
		collection.updateModel(null, JSON.stringify(updateObject));

		let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": "all", "message": RTMConst.UNMUTE_ALL, "details": JSON.stringify({"action": "unMuteAll"}), "timestamp": Util.getCurrentTimestamp()};
		sessionDataStore.addSessionData(addObject);

		unmuteParticipant();
	}
	
	window.changeUserToBroadcaster = function(uId){

        calcOnscreenTime = false;

        let updateObject = {"subscribeTime": Util.getCurrentTimestamp() - 60000, "forcedSwapIn": true};
        collection.updateModel(uId, JSON.stringify(updateObject));
    }
	
	window.logout = () => {
		window['clickedOnLeave'] = true;
		window['preClassFeedfmId'] = '';
		if ( $Any('#session_time').text() == 'Session Ended' ) 
			{
				let text = RTMConst.SESSION_COMPLETED+sep;
				sendMessageToChannel(text);
			}
	  window.soundPlay = false;
	  if ( window['multiWindow1'] && window['multiWindow1'].document && !window['multiWindow1'].closed) { window['multiWindow1'].close(); }
	  if ( window['multiWindow2'] && window['multiWindow2'].document && !window['multiWindow2'].closed) { window['multiWindow2'].close(); }
	  
		if ( !window.saveRecordingNow() )
			{
				userLogout = true;
				if ( !alreadyLeftAll )
					{
						leave();
						leave_channel();
					}
				$('.main_loader').attr({'style':'display:none'});	
				console.log('LOGOUT!!!!');
				
				removeSession();
				
				rtm.invoke({'code': RTMConst.HOST_LOGOUT});
				
				setTimeout(function(){
					
					if ( completedBtnPressed == true && window['forceCloseWindow'] )
						{
							window.forceCloseWindow();
						}
					
				}, 1000);
			}
	}
	
	var alreadyInSaving = false;
	window['saveRecordingNow'] = function ()
		{
			if ( recordSession.hasRecordingFiles == false && recordSession.isRecordingNow == false ) 
				{ 
					$('.main_loader').attr({'style':'display:none'}); 
					console.log('No Recording'); 
					return false; 
				}
			if ( alreadyInSaving ) { return true; }
			
			let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": currentUserData.id, "message": RTMConst.START_SESSION_RECORDING, "details": JSON.stringify({"action": "recordingProcessing", "msg": hostlanguage.recordingExist}), "timestamp": Util.getCurrentTimestamp()};
			sessionDataStore.addSessionData(addObject);
			sessionDataStore.dumpData();
			
			alreadyInSaving = true;
			recordSession.stopRecording(function ()
				{
					recordSession.uploadFileToS3(currentUserData.sessionData.id, function (passData)
						{
							if ( !passData )
								{
									recordSession.hasRecordingFiles = false;
									recordSession.isRecordingNow = false;
									recordSession.callBackOnStop = false;
									
									console.log('all done');
									$('#session-saving-recording').modal('hide');
									$('#finished-upload-failed').modal('show');
									
									$('.main_loader').attr({'style':'display:none'});	
									
									setTimeout(function () { $('.modal').modal('hide'); }, 2000);
									setTimeout(function () { alreadyInSaving = false; window.logout(); }, 3000);
								}
							else
								{
									recordSession.saveFileForEC2(passData, function ()
										{
											console.log('all done');
											$('#session-saving-recording').modal('hide');
											$('#finished-upload').modal('show');
									
											$('.main_loader').attr({'style':'display:none'});
											
											setTimeout(function () { $('.modal').modal('hide'); }, 2000);
											setTimeout(function () { alreadyInSaving = false; window.logout(); }, 3000);
										});
								}
						});
				});
			
			return true;
		}

	window.hostStartSession = function (){
		hostStartedFitnessScript = true;
		startSession();
		let publishInterval = setInterval(() => {
			if ( alreadyLeftAll ) { return false; }
			if( streamInitialized ) 
				{
					clearInterval(publishInterval);
					publish(); 
			  }
		}, 1000);
		updateSessionJoinedStatus();
		client.enableAudioVolumeIndicator();
		
		if(currentUserData.sessionData.scriptDetail !== undefined && currentUserData.sessionData.scriptDetail.length > 0) 
			{
				//We don't need to send RTM here anymore
				//let text = RTMConst.SYNC_SCRIPT+sep;
				// sendMessageToChannel(text);
				let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": "all", "message": RTMConst.SYNC_SCRIPT, "details": JSON.stringify({"action":"sync", "type":"script"}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);
			}

		if ( ( currentUserData.sessionData.StartMusicSession == 1 && currentUserData.sessionData.playlist && currentUserData.sessionData.playlist.length > 0 ) && ( currentUserData.sessionData.scriptDetail === undefined || currentUserData.sessionData.scriptDetail.length === 0 ) )
			{
				rtm.invoke({'code': 310});
			}		
		
		if ( currentUserData && currentUserData.sessionData && currentUserData.sessionData.id )
			{
				//check session charging and charge users
				axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/chargeSessionUsers", {sessionId: currentUserData.sessionData.id}).then(res => { }).catch(err =>{ }); 
			}
			
		startSession();
		if ( $Any('#microphone_control').text() == 'Unmute Microphone' )
			{
				$Any('#mic_control').trigger('click');
			}
		
		if ( window['electron'] )
			{
				localStream.unmuteVideo();
			}
		
		if ( window['hostRejoin'] )
			{	
				if ( usersOnScreen.length > 0 )
					{
						for ( var i = 0; i < usersOnScreen.length; i++ )
							{
								if ( window['load'+usersOnScreen[i]] )
									{
										//window['resetWhiteDraw'+usersOnScreen[i]](usersOnScreen[i]);
									}
							}
					}
			}
		
	}
	
	
	window.startHostFitnessScript = function (notifyRemoteOnly=false){
		let ftnsStartCode = currentUserData.rtm.ftnsStart.code;
		let messages = ftnsStartCode+sep;
		if (!notifyRemoteOnly) {
			sendMessageToChannel(messages);
		} else {
			sendMessage(`RM-${currentUserData.sessionData.hostEmail}`, messages)
		}
	}
	
	window.hostPauseFitnessScript = function(notifyRemoteOnly=false){
		let endMessage = 'stop';
		let ftnsPauseCode = currentUserData.rtm.ftnsPause.code; 
		let messages = ftnsPauseCode+sep+endMessage;
		if (!notifyRemoteOnly) {
			sendMessageToChannel(messages);
		} else {
			sendMessage(`RM-${currentUserData.sessionData.hostEmail}`, messages)
		}
	}
	
	window.hostStopFitnessScript = function(mod){
		localStorage.removeItem("scriptDetailsObject");
		let ftnsStopCode = currentUserData.rtm.ftnsStop.code;                        
		let messages = ftnsStopCode+sep+mod;          
		sendMessageToChannel(messages);
	}

	window.hostRtmForNextScript = function (indexNum, pauseStatus, sendToD2cRemoteOnly = false) {
		let nextButtonCode = currentUserData.rtm.WinsNext.code;
		
		var timeCode = (new Date()).getTime();
		
		/*--Message for old code--*/
		let message = nextButtonCode + sep + (indexNum-1) + sep + timeCode;	
		
		window.nextScriptMessage = message;
		
		/*--Message for new app without index num--*/
		//let message = nextButtonCode + sep;

		if ( !sendToD2cRemoteOnly )
			{
				sendMessageToChannel(message);
				setTimeout(()=>{ sendMessageToChannel(message); }, 2000);
			}
		else
			{
				sendMessage(`RM-${currentUserData.sessionData.hostEmail}`, message)
			}
	}
	
	window.hostSyncScriptFunction = function(state,actNum, totalTime, time, endedStatus){
		let utcTimestamp = 0;
		if(state == 1) 
			{
				utcTimestamp = Util.getUTCTimestamp();
			}
		let message = '';
		let timeElapsed = totalTime - time;
		
		if ( endedStatus )
			{
				state = 0;
			}
			
		if ( state == 1 )
			{
				message = RTMConst.SYNC_SCRIPT+sep+state+sep+actNum+sep+time+sep+utcTimestamp;
			}
		else 
			{
				message = RTMConst.SYNC_SCRIPT+sep+state+sep+actNum+sep+time+sep+utcTimestamp;
			}
		sendMessageToChannel(message);
	}
	
	window.sendSyncWhenPartJoinOnPause = function(mod){
		let nextNum = mod + 1;
		let message = RTMConst.SYNC_WHEN_PAUSE_ACTIVITY+sep+nextNum;
		sendMessageToChannel(message);
	}
	
	window.setUserLimit = (value) => {
			currentUserData.default.maxUserLimit = value;
			selectedLimit = value;
			console.log(selectedLimit, 'selectedLimit');
			//localStorage.setItem('userData', JSON.stringify(currentUserData));

			let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.INTERACTION, "eventType": "maxOnScreen", "userId": currentUserData.id, "details": JSON.stringify({"action": "maxOnScreen", "value": selectedLimit}), "timestamp": Util.getCurrentTimestamp()};
			sessionDataStore.addSessionData(addObject);
		}

	window.checkIfSetLimitCanChange=(value)=>{
		let currentMembers = collection.getModelData();
			var selectedNum = 0;
			if ( currentMembers.length > 0 )
				{
					for ( var i = 0; i<currentMembers.length; i++ )
						{
							if ( currentMembers[i].isSelected && currentMembers[i].isSelected === true )
								{
									selectedNum = selectedNum + 1;
								}
						}
				}
			
			if ( selectedNum > value )
				{
					$Any('#selectedMemberPop').removeClass('d-none');
					return false;
				}
			else 
				{
					return true;
				}
	}
	
	window.networkQualityStats = (uid, downlinkQuality) => {

      if ( uid == 0)
      {
          let statValue = Util.networkQualityMapping(downlinkQuality);
          localStats.push(statValue);

          if (localStats.length == 5) {

              var statsMean = Util.calculateAccessDelayMean(localStats);
              //console.log(`Electron Mean: ${localStats} ${statsMean}`);

              localStats = [];

              if (previousNetworkQuality != statsMean) {
                
                  setVideoConfiguration(statsMean);

                  networkQualityArray.push(statsMean);

                  if (networkQualityArray.length == 10) {
                      let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "network", "userId": currentUserData.id, "details": JSON.stringify({"action":"networkQuality", "value": networkQualityArray}), "timestamp": Util.getCurrentTimestamp()};
                      sessionDataStore.addSessionData(addObject);

                      networkQualityArray = [];
                  }
              }

              previousNetworkQuality = statsMean;
          }
      }
	}
	
	function sort_li(a, b) {
		return parseInt($Any(b).attr('data-position')) < parseInt($Any(a).attr('data-position')) ? 1 : -1;
	}
	
	function changeCameraStream(camName){
		if (window['ipad'] == undefined && dualStreamEnabled === true) {
            disableDualStream();
        }
		
		let mediaSetting = localStorage.getItem(hostlanguage.mediaSetting);
        mediaSetting = JSON.parse(mediaSetting);
		
		let vdId = camName.trim();
		mediaSetting['camera'] = vdId;
		if ( window['mainLocalStream'] && window['continueRestartSong'] )
			{
				window['manualSongChange'] = true;
				window['currentMixPosition'] = window['mainLocalStream'].getAudioMixingCurrentPosition();
				window['mainLocalStream'].stopAudioMixing();
			}
			
		if ( is_ffox )
			{
				var localStream3 = AgoraRTC.createStream({audio: false, video: true, cameraId: vdId.toString()});
				localStream3.setVideoProfile(Const.HOST_RESOLUTION[localStorage.getItem("video-resolution")]);
				localStream3.init(function(){
    				var newVideoTrack = localStream3.getVideoTrack();
    				localStream.replaceTrack(newVideoTrack);

    				if ( window['electron'] ) { localStream.play('host_video'); }

					if (window['ipad'] == undefined && dualStreamEnabled === true) {
    					enableDualStream(false);
    				}
				},function(e){
    						  
    				if ( window['electron'] ) { localStream.play('host_video'); }
    				if (window['ipad'] == undefined && dualStreamEnabled === true) {
    					enableDualStream(false);
    				}
    			});
			}
		else
			{
				localStream.switchDevice("video", vdId.toString(), function(){
					
					if ( window['electron'] ) { localStream.play('host_video'); }
								  
					if (window['ipad'] == undefined && dualStreamEnabled === true) {
						enableDualStream(false);
					}
					
					recordSession.clipRecording();
				},function(e){
					if ( window['electron'] ) { localStream.play('host_video'); }
    						  
    				if (window['ipad'] == undefined && dualStreamEnabled === true) {
    					enableDualStream(false);
  					}
				});		
			}
			
		let deviceName = camName;
        let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.INTERACTION, "eventType": "switchCamera", "userId": currentUserData.id, "details": JSON.stringify({"status": "success", "deviceName": deviceName.trim()}), "timestamp": Util.getCurrentTimestamp()};
        sessionDataStore.addSessionData(addObject);
			
		recordSession.clipRecording();
	}
	
	function onclickAudioOn(userObj, mod) {
		console.log('func - onclickAudioOn===', userObj);
		 
		let updateObject = {"audioMuted": false};
		collection.updateModel(userObj.id, JSON.stringify(updateObject));
		
		var massages = RTMConst.OPEN_MIC+sep; 
		sendMessage(userObj.email, massages);
		let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": userObj.id, "message":RTMConst.OPEN_MIC, "details": JSON.stringify({"action": "micOnParticipant", "msg": "Allow to talk"}), "timestamp": Util.getCurrentTimestamp()};
		sessionDataStore.addSessionData(addObject);
		
		streamSelectedArray.push(userObj.id);
		
		userArray.forEach(function(item, index){
			if ( index != currentUserData['id'] && index != userObj.id )
				{
					let userDetails = collection.getDetailsById(index);
					/*---mute other participants when host allow 1 participant to speak---*/
					//onclickAudioOff(userDetails);
				}
		});
		
		unmuteBroadcasterAtParticipants(userObj.id);
		unmuteParticipant(userObj.id);
		
		if ( participantsSelfMuted.indexOf(userObj.id) == -1 )
			{
				$Any('#raiseHandPart'+userObj.id).addClass('d-none');
				$Any('#partActiveMic'+userObj.id).removeClass('d-none');
				if ( mod )
					{
						$Any('#partInActiveMic'+userObj.id).addClass('d-none');
					}
			}
		else 
			{
				$Any('#raiseHandPart'+userObj.id).addClass('d-none');
				$Any('#partActiveMic'+userObj.id).addClass('d-none');
				$Any('#partInActiveMic'+userObj.id).removeClass('d-none');	
			}			
		
	}
	
	function onclickAudioOff(userObj) {
		if ( !userObj )
			{
				return false;
			}
		console.log('Func - onclickAudioOff');
		let updateObject = {"audioMuted": true};
		collection.updateModel(userObj.id, JSON.stringify(updateObject));
	  
		let massages = RTMConst.TURN_MIC_OFF+sep
		sendMessage(userObj.email, massages);
		
		let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": userObj.id, "message": RTMConst.TURN_MIC_OFF, "details": JSON.stringify({"action": "micOffParticipant", "msg": "Mute the Audio"}), "timestamp": Util.getCurrentTimestamp()};
		sessionDataStore.addSessionData(addObject);
		
		muteBroadcasterAtParticipants(userObj.id);
		Util.removeValueFromArray(streamSelectedArray, userObj.id);
		
		muteParticipant(userObj.id);
		$Any('#partActiveMic'+userObj.id).addClass('d-none');
		$Any('#partInActiveMic'+userObj.id).removeClass('d-none');
	}
	
	function unmuteBroadcasterAtParticipants(broadcasterId) {
		let text = RTMConst.UNMUTE_BROADCASTER_OTHER_PARTICIPANT+sep+broadcasterId;
		sendMessageToChannel(text);
	}
	
	function muteBroadcasterAtParticipants(broadcasterId) {
		let text = RTMConst.MUTE_BROADCASTER_OTHER_PARTICIPANT+sep+broadcasterId;
		sendMessageToChannel(text);
	}
	
	function unmuteParticipant(id) {
		streamArray.forEach((stream) => {
			if ( stream.getId() != undefined && ( stream.getId() == id || id == undefined ) )
				{
					stream.unmuteAudio();
					let userId = stream.getId();
					$Any('#raiseHandPart'+userId).addClass('d-none');
					if ( participantsSelfMuted.indexOf(userId) == -1 )
						{
							$Any('#partActiveMic'+userId).removeClass('d-none');
							$Any('#partInActiveMic'+userId).addClass('d-none');
						}
					else 
						{
							$Any('#partActiveMic'+userId).addClass('d-none');
							$Any('#partInActiveMic'+userId).removeClass('d-none');
						}						
				}
		});
	}
  
	function selectUnmute(mod, state){
		if ( !unmuteAllEnabled ) 
			{
				if ( state == 'unmute' )
					{
						unmuteParticipant(mod);
					}
				else 
					{
						$Any('#partActiveMic'+mod).addClass('d-none');
						$Any('#partInActiveMic'+mod).addClass('d-none');
						muteParticipant(mod);
					}					
			}
	}
  
	window.displayParticipants = function(mod?) {
		let participantList = collection.getModelData();

		let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.INTERACTION, "eventType": "participantList", "userId": currentUserData.id, "details": JSON.stringify({"action":"participantList"}), "timestamp": Util.getCurrentTimestamp()};
		sessionDataStore.addSessionData(addObject);
		let membersArray = JSON.parse(localStorage.getItem('tempUsers'));
		let indexOfHost = undefined;
		if ( membersArray )
			{
				for ( var a = 0; a < membersArray.length; a++ )
					{
						if ( membersArray[a]['userType'] == 1 )
							{
								indexOfHost = membersArray.indexOf(membersArray[a]);
							}
					}
				membersArray.splice(indexOfHost, 1);
			}
		
		for ( var i = 0; i < participantList.length; i++ )
			{
				let userData = participantList[i];
				
				let status = '';
				let statusl = '';
				let camStatus = 'Off';
				let micStatus = 'Off';
				if (userData.isVisible === true && userData.currentStatus === 1 && window['sessionStarted']) 
					{
						status = 'Onscreen';
						statusl = 'a';
					}
				else if (userData.isVisible === true && userData.currentStatus === 1 && !window['sessionStarted']) 
					{
						status = 'Waiting';
						statusl = 'b';
					}				
				else if (userData.isVisible === false && userData.currentStatus === 1) 
					{
						status = 'Offscreen';
						statusl = 'a';
					} 
					
				else if (userData.loggedIn === true) 
					{
						status = 'Waiting';
						statusl = 'b';
					} 
				else if ( userData.sessionStatus == 3 ) 
					{
						status = 'Ejected';
						statusl = 'd';
					} 
				else if ( userData.sessionStatus == 4 ) 
					{
						status = 'Cancelled';
						statusl = 'd';
					} 
				else 
					{
						status = 'Signed Up';
						statusl = 'c';
					}

				if ( usersOnScreenCurrent.indexOf(userData.id) > - 1 )
					{
						if ( userData.micAccess && userData.micAccess == "Granted" )
							{
								micStatus = 'On';
							}
							
						if ( userData.broadcastVideo === true || userData.broadcastVideo == 'null' )
							{
								camStatus = 'On';
							}
						if (userData.isVisible === true && userData.currentStatus === 1 && !window['sessionStarted'])
							{
								camStatus = 'On';
							}							
					}
					
			  for ( var m = 0; m < membersArray.length; m++ )
				{
					if ( membersArray[m]['id'] == userData.id )
						{
							membersArray[m]['mainStatus'] = status;
							membersArray[m]['listStatus'] = statusl;
							
							membersArray[m]['cameraStatus'] = camStatus;							
							membersArray[m]['micStatus'] = micStatus;							
						}
											
				}
			}
			
	  window['updatedUserList'] = membersArray;
	   window['setStatusOnList']();
	  if ( mod )
		{
			$Any('#memebrsList').removeClass('d-none');
		}
	 
  }
  
	window.removeCurrentParticipant = (userId, removeUserInfoEmail) =>{
		 streamArray.forEach((stream) => {
				if ( stream.getId() != undefined && stream.getId() == userId )
					{
						if ( window['electron'] )
							{
								stream.stop();
							}
						else 
							{
								client.unsubscribe(stream, function(err) {
									console.log('unsubscribe error - ', err);
								});

								stream.stop();
							}
						removeStreamFromArray(userId);	
					}
		 });
		 
		$Any('#participant_agora' + userId).remove();
		var message = RTMConst.EJECT_PARTICIPANT + sep; 
		sendMessage(removeUserInfoEmail, message);
		sendMessage('RM-'+removeUserInfoEmail, message);
		
		resetParticipantAttributes(userId);
		Util.removeValueFromArray(streamSelectedArray, userId);
	}

	$Any(document).off('click', '#mic_control');
	$Any(document).on('click', '#mic_control', function(){
		let addObject = {};
	
		if ( $Any('#microphone_control').text() == 'Mute Microphone' ) 
			{
				$Any('#microphone_control').text('Unmute Microphone');
				localStream.muteAudio();
				addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.INTERACTION, "eventType": "unmute", "userId": currentUserData.id, "details": JSON.stringify({"action": "micOn", "msg": "Local mic turned on"}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);
				$Any('.audio_icon .muted_audio').removeClass('d-none');
				$Any('#mic_control .muted_audio').removeClass('d-none');
				window['isMutedByMe'] = true;
				$Any('#host-muted-icon').removeClass('d-none');
			}
		else
			{
				$Any('#microphone_control').text('Mute Microphone');
				localStream.unmuteAudio();
				addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.INTERACTION, "eventType": "mute", "userId": currentUserData.id, "details": JSON.stringify({"action": "micOff", "msg": "Local mic turned off"}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);
				$Any('.audio_icon .muted_audio').addClass('d-none');
				$Any('#mic_control .muted_audio').addClass('d-none');
				window['isMutedByMe'] = false;
				$Any('#host-muted-icon').addClass('d-none');
			}
	});
	
	$Any(document).off('click', '#chose_mic');
	$Any(document).on('click', '#chose_mic',switchMicStream);
	function switchMicStream(){
		var keyId = this.getAttribute("data-keyid");
	
		if ( window['updateChoosenStatus'] )
			{
				var numId = this.getAttribute("data-numId");
				window['updateChoosenStatus'](numId, 'mic');
			}
		
		if ( window['sendSyncToRemote'] )
			{
				window['sendSyncToRemote']();
			}
		
		let mediaSetting = JSON.parse(localStorage.getItem(hostlanguage.mediaSetting));
		mediaSetting['microphone'] = keyId;
		window['main_mic_id'] = keyId;
		localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaSetting));
		
		swithMicAndSpeaker();
	}
	window.switchMicStream = switchMicStream;
	$Any(document).off('click', '#chose_speak');
	$Any(document).on('click', '#chose_speak', function(){
		var keyId = this.getAttribute("data-keyid");
		
		//$Any('#chose_speak .drop_checked').remove();
		//$Any(this).append('<div class="drop_checked"></div>');
		
		if ( window['updateChoosenStatus'] )
			{
				var numId = this.getAttribute("data-numId");
				window['updateChoosenStatus'](numId, 'sp');
			}
		
		AgoraRTC.switchSpeaker(keyId);
		
		let mediaSetting = JSON.parse(localStorage.getItem(hostlanguage.mediaSetting));
		mediaSetting['speaker'] = keyId;
		localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaSetting));
	});
	
	$Any(document).off('click', '#chose_camera');
	$Any(document).on('click', '#chose_camera',switchCameraStream); 
	function switchCameraStream(){
		var keyId = this.getAttribute("data-keyid");
		var numId = this.getAttribute("data-numId");
		cameraIndex = keyId;
		localStream.stop();
		if ( !window['isMutedByMe'] )
			{
				localStream.unmuteAudio();
			}
		
		if ( window['updateChoosenStatus'] )
			{
				window['updateChoosenStatus'](numId, 'camera');
			}
		
		if ( window['sendSyncToRemote'] )
			{
				window['sendSyncToRemote']();
			}
		
		for( let i in cameraStreams ){
		  cameraStreams[i].stop();
		}
		
		cameraStreams[keyId].init(function(){
			cameraStreams[keyId].play('host_video');
		}, function (err) {
		  if (err.msg == 'NotReadableError')
			{
				$Any('#mediaPop').removeClass('d-none');
			}
		  if (err.msg == 'STREAM_ALREADY_INITIALIZED') 
			{
				cameraStreams[keyId].play('host_video', function(errState){
					cameraStreams[keyId].resume();
					});
			}
		});

		let mediaSetting = JSON.parse(localStorage.getItem(hostlanguage.mediaSetting));	
		mediaSetting['camera'] = cameraStreams[keyId].cameraId;
		localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaSetting));
		
		var camName = $Any(this).text();
		var camValue = this.getAttribute("data-value");
		changeCameraStream(camValue);
	};
	window.switchCameraStream = switchCameraStream;
	
	$Any(document).off('click', '#record_session');
	$Any(document).on('click', '#record_session', function(){
		let recordingAvailable = 0;
		
		if ( localStorage.getItem('recordingStatus') )
			{
				recordingAvailable = parseInt(localStorage.getItem('recordingStatus'));
			}
			
		if ( recordingAvailable == 0 && !currentUserData.isMarketplaceChannel )
			{
				$Any('#noPlanPop').removeClass('d-none');
				return false;
			}
		var recordText = $Any('#record_text').text();
		if ( recordText == 'Record' ) 
			{
				$Any('#record_text').text('Stop Recording');
				$Any('#recordingon').removeClass('d-none');
				
				let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": currentUserData.id, "message": RTMConst.START_SESSION_RECORDING, "details": JSON.stringify({"action": "recordingButtonStart", "msg": hostlanguage.recordingBtnPressed}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);
				recordingStartedTime = null;
				
				recordSession.defaultLogData(sessionDataStore, {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": currentUserData.id, "message": RTMConst.START_SESSION_RECORDING, "details": JSON.stringify({"action": "recordingData", "msg": hostlanguage.recordingExist}), "timestamp": Util.getCurrentTimestamp()});
				recordSession.startRecording();
				
				currentUserData.sessionData.recordingInSessionStarted = true;
				localStorage.setItem('userData', JSON.stringify(currentUserData));
				let text = RTMConst.SHOW_SESSION_RECORDING_ICON + sep + 1;
				sendMessageToChannel(text);
				
				if ( window['currentFmStation'] && window['currentFmStation'] != "" )
					{
						if ( !rtmStoreMessages[window['currentTimeClass']] )
							{
								rtmStoreMessages[window['currentTimeClass']] = [];
							}
							
						var msgFM = "feedFm"+sep+"play"+sep+window['currentFmStation'];
						rtmStoreMessages[window['currentTimeClass']].push(msgFM);
						
						window['rtmStoreMessages'] = rtmStoreMessages;
					}
			}
		else
			{
				$Any('#record_text').text('Record');
				$Any('#recordingon').addClass('d-none');
				
				let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": currentUserData.id, "message": RTMConst.START_SESSION_RECORDING, "details": JSON.stringify({"action": "recordingButtonStop", "msg": hostlanguage.stopRecordBtnPressed}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);

				recordSession.stopRecording();
				currentUserData.sessionData.recordingInSessionStarted = false;
				localStorage.setItem('userData', JSON.stringify(currentUserData));
				let text = RTMConst.SHOW_SESSION_RECORDING_ICON + sep + 0;
				sendMessageToChannel(text);
				//storeRTM("306~@$", window['currentTimeClass']);
				if ( !rtmStoreMessages[window['currentTimeClass']] )
					{
						rtmStoreMessages[window['currentTimeClass']] = [];
					}
					
				rtmStoreMessages[window['currentTimeClass']].push('306~@$');
				window['rtmStoreMessages'] = rtmStoreMessages;
				insertStoredRTM();
			}
	});
	
	
	// Buffer Canvas needed for recording and whiteboard
	var recCanvas = $Any('#video_precanvas')[0];
	var recContext = recCanvas.getContext('2d');
	window['recContext'] = recContext;
	
	recCanvas.width = 1280;
	recCanvas.height = 720;
	
	var intervalInCase = 0;
	function linkRecObjects ()
		{
			if ( recordSession && recordSession.isRecordingNow )
				{
					if ( window['InjectedVideoStarted'] && $('#host_inj_video')[0].src !== '' && !$('#host_inj_video')[0].paused && !$('#host_inj_video')[0].ended )
						{
							recContext.drawImage($('#host_inj_video')[0],0,0,recCanvas.width,recCanvas.height);
						}
					else if ( $('#'+currentStreamingDiv+' video').length > 0 && !$('#'+currentStreamingDiv+' video')[0].paused && !$('#'+currentStreamingDiv+' video')[0].ended )
						{
							recContext.drawImage($('#'+currentStreamingDiv+' video')[0],0,0,recCanvas.width,recCanvas.height);
						}
					else if ( $('#'+currentStreamingDiv+' canvas').length > 0 )
						{
							recContext.drawImage($('#'+currentStreamingDiv+' canvas')[0],0,0,recCanvas.width,recCanvas.height);
						}
				}
			
			if ( !alreadyLeftAll )
				{
					requestAnimationFrame(linkRecObjects);
					if ( intervalInCase ) { clearTimeout(intervalInCase); }
					intervalInCase = setTimeout(function () { linkRecObjects(); }, 500);
				}
		}
	
	requestAnimationFrame(linkRecObjects);
	// Buffer Canvas needed for recording and whiteboard
	
	$Any(document).off('click', '#mute_control');
	$Any(document).on('click', '#mute_control', function(){
		var muteText = $Any('#mute_text').text();
		if ( muteText == 'Mute all' ) 
			{
				$Any('#mute_text').text('Unmute all');
				window.muteAllHandler();
				$Any('.whoIsSpeaking_containter').addClass('d-none');
				$Any('#speakerIcon').removeClass('unmuteall_icon');
				$Any('#speakerIcon').addClass('allowedSpeaker');
			}
		else
			{
				$Any('#mute_text').text('Mute all');
				 window.unmuteAllHandler();
				 $Any('.whoIsSpeaking_containter').removeClass('d-none');
				 if ( window['clearAudienceRaisedList'] )
					{
						window['clearAudienceRaisedList']();
					}
				$Any('#speakerIcon').addClass('unmuteall_icon');
				$Any('#speakerIcon').removeClass('allowedSpeaker');
			}
	});

	window['lastFmsId'] = 0;
	$Any(document).off('click', '.video-streams');
	$Any(document).on('click', '.video-streams', function(){
		console.log('MATCH click .video-streams *********************');
		let currentStreamClicked = $Any(this).attr('id').split('agora_remote_vdo');
		let currentStreamId = parseInt(currentStreamClicked[1]);
		console.log(window['lastFmsId'], currentStreamId, window['canvasOn'], 'fmsIds');
		
		let currentArray = [];
		if ( window['currentSelected'] )
			{
				currentArray = window['currentSelected'];
			}
			
		if ( currentArray.indexOf(currentStreamId) == -1 )
			{
				window['participantDetails'] = window.collection.getDetailsById(currentStreamId);
				window.showFMSPalette(currentStreamId);
				$Any('#raiseHandPart'+currentStreamId).trigger('click');
			}
		else 
			{
				updateIsSelected(currentStreamId, false);
				if ( !unmuteAllEnabled )
					{
						$Any('#partActiveMic'+currentStreamId).trigger('click');
						let massages = RTMConst.HOST_UNPINNED_PARTICIPANT+sep
						sendMessage(window['participantDetails']['email'], massages);						
					}
					
				if ( !window['canvasOn'] ) 
					{ 
						window.removeFmsPalette(currentStreamId); 
					}
			}	
	});
	
	$Any(document).off('click', '.noVideoInitialsHolder');
	$Any(document).on('click', '.noVideoInitialsHolder', function(){
		let currentStreamClicked = $Any(this).attr('id').split('noVideoInitials');
		let currentStreamId = parseInt(currentStreamClicked[1]);
		let currentArray = [];
		
		if ( window['currentSelected'] )
			{
				currentArray = window['currentSelected'];
			}
			
		if ( currentArray.indexOf(currentStreamId) == -1 )
			{
				$Any('#raiseHandPart'+currentStreamId).trigger('click');
				$Any('#zoomMember'+currentStreamId).addClass('d-none');
			}
		else
			{
				updateIsSelected(currentStreamId, false);
				if ( !unmuteAllEnabled )
					{
						$Any('#partActiveMic'+currentStreamId).trigger('click');
					}
					
				if ( !window['canvasOn'] ) 
					{ 
						window.removeFmsPalette(currentStreamId); 
					}
			}	
	});
	
	
	$Any(document).off('click', '#my_view');
	$Any(document).on('click', '#my_view', function(){
		zoomHost(1);
	});
	
	$Any(document).off('click', '#zoom_out');
	$Any(document).on('click', '#zoom_out', function(){
		if ( !memberZoomed )
			{
				zoomHost(0);
			}
		else 
			{
				zoomHost(0, memberZoomed);
			}			
		
	});
	
	$Any(document).off('click', '#rejoin');
	$Any(document).on('click', '#rejoin', function(){
		
		if ( rejoinBtnPressed === true )
			{
				return false;
			}
		window['mediaPipeFirstTime'] = false;
		rejoinBtnPressed = true;
		window.leaveBtnPressed = true;
		$('.main_loader').attr({'style':'display:flex'});
		stopAllStreams();
			
		let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "logout", "userId": currentUserData.id, "message": 305, "details": JSON.stringify({"status":"success", "action":"Rejoin"}), "timestamp": Util.getCurrentTimestamp()};
		sessionDataStore.addSessionData(addObject);
		sessionDataStore.dumpData();
		window['hostRejoin'] = true;
		window['script_is_started'] = false;
		window['guestUser'] = false;
		window['updateFlutterCanvas'] = false;
		
		if ( window['currentFmStation'] && window['currentFmStation'] != "" )
			{
				window['sendMessageToChannel']("feedFm"+sep+"stop");
			}
		
		setTimeout(function () {
			window.logout();
		}, 2000);
		window['currentSelected'] = [];
		window['sessionStarted'] = false;
		
		if ( window['eventCurrent'] && window['eventCurrent']['adminReportsOngoingSessions'] )
			{
				window['eventCurrent']['adminReportsOngoingSessions'].close();
				window['eventCurrent']['adminReportsOngoingSessions'] = false;
			}
		
		if ( window.soundPlay ) { window.soundPlay.stopAudio(); }
		if ( window['userWhiteboard'][currentUserData.id] ) 
			{
				window.removeWhiteboard(); 
			}
	
		window['currentFmStation'] = undefined;
		window['currentFmName'] = undefined;
		window['isMutedFm'] = undefined;
	});
	
	$Any(document).off('click', '#complete_session');
	$Any(document).on('click', '#complete_session', function(){
		window['sessionStarted'] = false;
		if ( completedBtnPressed === true )
			{
				return false;
			}
		
		completedBtnPressed = true;
		window.leaveBtnPressed = true;
		$('.main_loader').attr({'style':'display:flex'});
			
		let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "logout", "userId": currentUserData.id, "message": 306, "details": JSON.stringify({"status":"success", "action":"Completed"}), "timestamp": Util.getCurrentTimestamp()};
    	sessionDataStore.addSessionData(addObject);
		sessionDataStore.dumpData();
		
		stopAllStreams();
		
		setTimeout(function () {
			let text = RTMConst.SESSION_COMPLETED+sep;
            sendMessageToChannel(text);
			
			$.ajax({
                  headers: { 
                      "Content-Type": "application/json; charset=utf-8",
                      "Authorization": currentUserData.token
                  },
                  url: Const.BASE_API_PATH +'/api/v1/session/'+currentUserData.sessionData.id+'/completed',
                  type: 'POST',
				   data: JSON.stringify({'duration_session': window['countTimeSession'] ? window['countTimeSession'] : 0}),
                  success: function( data, textStatus, jQxhr ){                  
                      window.logout();
                  },
                  error: function( jqXhr, textStatus, errorThrown ){
        						console.log( errorThrown );
        						window.logout();
        					}
    				});

    				window['countTimeSession'] = 0;  
					
    	}, 2000);
		
		if ( window.soundPlay ) { window.soundPlay.stopAudio(); }
		if ( window['userWhiteboard'][currentUserData.id] ) 
			{ 
				window.removeWhiteboard(); 
			}
		
		window['currentFmStation'] = undefined;
		window['currentFmName'] = undefined;
		window['isMutedFm'] = undefined;
		window['script_is_started'] = false;
	});
	
	$Any(document).off('click', '.raiseHandPartHolder');
	$Any(document).on('click', '.raiseHandPartHolder', function(){
		var userId = $Any(this).attr('userDetails-id');
		if ( !userId )
			{
				return false;
			}
		
		let userDetails = collection.getDetailsById(parseInt(userId));
		onclickAudioOn(userDetails, true);
		updateIsSelected(userId, true);
		let updateObject = {"raisedHand": false};
		collection.updateModel(userId, JSON.stringify(updateObject));
		$Any('#participant_agora'+userId).addClass('participant_fms_selected');
	});
	
	$Any(document).off('click', '.micUnMutePartHolder');
	$Any(document).on('click', '.micUnMutePartHolder', function(){
		var userId = $Any(this).attr('userDetails-id');
		if ( mutedParticipantsByHost.indexOf(userId) == -1 )
			{
				mutedParticipantsByHost.push(parseInt(userId));
			}
		let userDetails = collection.getDetailsById(parseInt(userId));
		onclickAudioOff(userDetails);
	});
	
	$Any(document).off('click', '.mutedMicPartHolder');
	$Any(document).on('click', '.mutedMicPartHolder', function(){
		var userId = parseInt($Any(this).attr('userDetails-id'));
		if ( participantsSelfMuted.indexOf(userId) > -1 )
			{
				return false;
			}
		
		if ( mutedParticipantsByHost.indexOf(userId) > -1 )
			{
				let indexNum = mutedParticipantsByHost.indexOf(userId);
				mutedParticipantsByHost.splice(indexNum, 1);
			}
		let userDetails = collection.getDetailsById(userId);
		onclickAudioOn(userDetails, true);
	});
	
	$Any(document).off('click', '.singleHolder');
	$Any(document).on('click', '.singleHolder', function(){
		var userId = $Any(this).attr('userDetails-id');
		userId = parseInt(userId);
		let userDetails = collection.getDetailsById(parseInt(userId));
		onclickAudioOn(userDetails, true);
		if ( window['removeUserFromAudienceList'] )
			{
				window['removeUserFromAudienceList'](userDetails.id, true);
			}
		showFromAudiance(userId);
		let updateObject = {"raisedHand": false};
		collection.updateModel(userId, JSON.stringify(updateObject));		
	});
	
	$Any(document).off('click', '.zoomMemberIcon');
	$Any(document).on('click', '.zoomMemberIcon', function(){
		var userId = $Any(this).attr('userDetails-id');
		 let userDetails = collection.getDetailsById(parseInt(userId));
		 if ( userDetails.broadcastVideo === false)
			{
				return false;
			}
		else 
			{
				zoomHost(1, userId);
			}			
		
	});

	$Any(document).on('click', '.equipmentTagsHolder', function(e){
		  let userIdSpl = $Any(this).attr('id').split('movedEquipment');
		  let currUserId = userIdSpl[1];
		  window['openedEditEquipment'+currUserId] = true;
		  $Any('#actStart').addClass('d-none');
		  if ( $Any('#participant_agora'+currUserId).length > 0 )
			{
				$Any('#participant_agora'+currUserId).addClass('equipmentInstructions');
				$Any('#participant_agora'+currUserId).addClass('disable_width_video');
				$Any('#participant_agora'+currUserId).attr({'style':'max-width: none !important; max-height: none !important'});
				$Any('#agora_remote_vdo'+currUserId).addClass('smallerVideo');
				$Any('#canvasWrap'+currUserId).addClass('smallerVideo');
				//$Any('#setupInstructions'+currUserId).removeClass('d-none');
				$Any('#agora_remote_vdo'+currUserId).addClass('edit_equipment_video');
				$Any('.canvas-close-icon').addClass('d-none');
				$Any(this).addClass('d-none');
				$Any('#setupEquipmentHold'+currUserId).addClass('d-none');
				window['showInstructions'+currUserId] = true;
				window['soundPlay'].stopAudio();
				var playAudioDirection = window['scriptType'] == 'cones' ? 'coneDirections' : window['scriptType'] == 'boxing' ? 'bagDirections' : '';
				soundPlay.playAudio(playAudioDirection);
			}
      });
	
	 $Any(document).on('click', '.actStartHost', function(e){
		  //window['soundPlay'].stopAudio();
		  window['playCountdown'] = true;
		  window['startVirtualClass']();
		  $Any('#actStart').addClass('d-none');
		  
		  userArray.forEach(function(item, index){
				if ( index != currentUserData['id'] )
					{
						$Any('#setupEquipmentHold'+index).addClass('d-none');
					}
			});
		  
		  let removeDirections = 'removeEquipmentDirections';
	      sendMessageToChannel(removeDirections);
      });
	window.remoteVideoStates = (uid, state, reason, elapsed) => {
      console.log(`remoteVideoStateChanged UID: ${uid} State: ${state} Reason: ${reason}`);
      let userDetails = collection.getDetailsById(uid);
      if ( uid != 0 && state == 2 && (reason == 0 || reason == 2 || reason == 4 || reason == 6) )
      {
         $Any('#networkmsg-'+uid).text('').addClass('d-none');
          if ( userDetails.debounceValue !== null )
          {
              clearTimeout(userDetails.debounceValue);
              
              console.log('remote userDetails debounce value - ', userDetails.debounceValue);

              let updateObject = {"debounceValue": null};
              collection.updateModel(uid, JSON.stringify(updateObject));
          }
      }
      else if ( uid != 0 && ( state == 3 || state == 4 ) )
      {
          if ( userDetails.broadcastVideo != false )
			{
              var returnedFunction = debounce(function() {
				  console.log('remoteVideoStates else if 1');
                  $Any('#networkmsg-'+uid).text('Waiting for video…').removeClass('d-none');
              });

              let updateObject = {"debounceValue": returnedFunction()};
              collection.updateModel(uid, JSON.stringify(updateObject));
          }
      }
      else if ( uid != 0 && state == 0 && ( reason == 3 || reason == 5 || reason == 7 ) )
      {
          if ( userDetails.broadcastVideo != false )
			{
              var returnedFunction = debounce(function() {
				  console.log('remoteVideoStates else if 2');
                  $Any('#networkmsg-'+uid).text('Waiting for video…').removeClass('d-none');
              });

              let updateObject = {"debounceValue": returnedFunction()};
              collection.updateModel(uid, JSON.stringify(updateObject));
          }
      }
  }
  
  const debounce = (func) => {
    let timeout;

    return function() { 
        const context = this;
        const args = arguments;

        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), parseInt(currentUserData.default.videoFrozenTimeoutInterval));
        return timeout;
    }
  };
  
  function createDropdown(mod){
    if ( maxOnscreenLimit >= mod )
		{
			$('#maxuserlimit').html('');
			for(let i = mod; i > 0; i--) 
				{
					$('#maxuserlimit')
					.append($("<option></option>")
					.attr("value", i)
					.text(i));
				}
			
			for ( var i = 0; i <= 20; i++ )
				{
					$Any('#participantListView').removeClass("multiscreen"+i);
				}
			
			if ( window['multiWindow1'] && window['multiWindow1'].document )
				{
					var multiParent = window['multiWindow1'].document.querySelectorAll("#participantListView .participantStreamPart");
					var inScreen1 = multiParent.length;
					
					var multiParentc = window['multiWindow1'].document.querySelector("#participantListView");
					$(multiParentc).addClass("multiscreen"+inScreen1);
					
				}
			if ( window['multiWindow2'] && window['multiWindow2'].document)
				{
					var multiParent2 = window['multiWindow2'].document.querySelectorAll("#participantListView .participantStreamPart");
					var inScreen2 = multiParent2.length;
					
					var multiParentc = window['multiWindow2'].document.querySelector("#participantListView");
					$(multiParentc).addClass("multiscreen"+inScreen2);
				}
		}
	
	if (currentUserData.default.maxUserLimit >= mod )
		{
			if (mod != 0)
				{
					
					$('#maxuserlimit option[value="'+mod+'"]').attr("selected", "selected");
				}

			window['updateStateHostScreen']();
		}
	else
		{
			
			$('#maxuserlimit option[value="'+usersOnScreenCurrent.length+'"]').attr("selected", "selected");
			window['updateStateHostScreen']();
		}
  }
  
  function setNewDropdown(){
	  createDropdown(streamArray.length);
  }
  window['setNewDropdown'] = setNewDropdown;
  
  function checkForInterval(streamId){
	    console.log('checkForInterval');
		if ( !streamId ) { return false; }
		
		var maxOnScreen = currentUserData.default.maxUserLimit;
		var indexOfScreenCurrent = usersOnScreenCurrent.indexOf(streamId);
		if ( indexOfScreenCurrent > -1 ) { usersOnScreenCurrent.splice(indexOfScreenCurrent, 1); }

		var indexOfScreen = usersOnScreen.indexOf(streamId);
		if ( indexOfScreen > -1 ) { usersOnScreen.splice(indexOfScreen, 1); }
		updateIsVisible(streamId, false);

		var visibleLength = usersOnScreenCurrent.length;
		
		if ( visibleLength < maxOnScreen )
			{
				fillUpUsersOnScreenCurrent();
			}
		
		visibleLength = usersOnScreenCurrent.length;
		
		if ( visibleLength <= maxOnScreen && window['switchMembersInterval'] )
			{
				var currentOnScreen = 0;
				if ( $Any('#hostParticipantStreamsList .participantStreamPart').length ) { currentOnScreen = $Any('#hostParticipantStreamsList .participantStreamPart').length; }
				if ( currentOnScreen <= visibleLength )
					{
						clearInterval(window['switchMembersInterval']);
						window['switchMembersInterval'] = null;
					}
			} 
	}

	function fillUpUsersOnScreenCurrent()
		{
			console.log('fillUpUsersOnScreenCurrent');
			var maxOnScreen = currentUserData.default.maxUserLimit;
			streamArray.forEach((stream) => {
				if ( usersOnScreenCurrent.length < maxOnScreen )
					{
							
						if ( stream.getId() != undefined && stream.getId() != currentUserData.sessionData.hostId && usersOnScreen.indexOf(stream.getId()) == -1)
							{
								console.log('------stream.getId()', stream.getId());
								var userDetails = collection.getDetailsById(stream.getId());
								if ( usersOnScreenCurrent.indexOf(userDetails.id) == -1 )
									{
										console.log('-----------userDetails.broadcastVideo', userDetails.broadcastVideo);
										if ( userDetails && userDetails.broadcastVideo != false )
											{
												changeNetworkmsg(userDetails);
												subscribeToVideoStream(userDetails.id);
											}
										else
											{
												$Any('#partNoVideo'+userDetails.id).removeClass('d-none');
												$Any('#noVideoInitials'+userDetails.id).removeClass('d-none');
											}
										updateIsVisible(userDetails.id, true);
										usersOnScreen.push(userDetails.id);
										usersOnScreenCurrent.push(userDetails.id);
										$Any('#participant_agora'+userDetails.id).removeClass('d-none');
									}
							}
					}
			});
			
			streamArray.forEach((stream) => {
				if ( usersOnScreenCurrent.length < maxOnScreen )
					{
						if ( stream.getId() != undefined && stream.getId() != currentUserData.sessionData.hostId )
							{
								var userDetails = collection.getDetailsById(stream.getId());
								if ( usersOnScreenCurrent.indexOf(userDetails.id) == -1 )
									{
										if ( userDetails && userDetails.broadcastVideo != false )
											{
												changeNetworkmsg(userDetails);
												subscribeToVideoStream(userDetails.id);
											}
										updateIsVisible(userDetails.id, true);
										usersOnScreenCurrent.push(userDetails.id);
										$Any('#participant_agora'+userDetails.id).removeClass('d-none');
									}
							}
					}
			});
		}
		
	window.makeNewDisplayStreams = (mod) =>{
		
		let usersForSplice = [];
		let hideUsersNum = usersOnScreenCurrent.length - mod;
		if ( usersOnScreenCurrent.length > mod )
			{
				let idsToAudioSubscribe = [];
				for ( let i=0; i < usersOnScreenCurrent.length; i++ )
					{
						streamArray.forEach((stream) => {
							if ( stream.getId() != undefined && stream.getId() != currentUserData.sessionData.hostId )
								{
									if ( stream.getId() == usersOnScreenCurrent[i] && usersForSplice.length < hideUsersNum && ( !window['currentSelected'] || window['currentSelected'] && window['currentSelected'].indexOf(stream.getId()) == -1 ) )
										{
											idsToAudioSubscribe.push(usersOnScreenCurrent[i]);
											$Any('#participant_agora'+usersOnScreenCurrent[i]).addClass('d-none');
											updateIsVisible(usersOnScreenCurrent[i], false);
											usersForSplice.push(usersOnScreenCurrent[i]);
										}													
								}
						});
					}
					
				if ( usersForSplice && usersForSplice.length >0 )
					{
						for ( let j=0; j < usersForSplice.length; j++ )
							{	
								let ind = usersOnScreenCurrent.indexOf(usersForSplice[j]);
								if ( ind > -1 )
									{
										usersOnScreenCurrent.splice(ind, 1);
									}
								let ind2 = usersOnScreen.indexOf(usersForSplice[j]);
								if ( ind2 > -1 )
									{
										usersOnScreen.splice(ind2, 1);
									}
								
							}
					}
					
				if ( idsToAudioSubscribe.length > 0 )
					{
						for (let i=0; i<idsToAudioSubscribe.length; i++)
							{
								var removeStreamDetails = collection.getDetailsById(idsToAudioSubscribe[i]);
								checkIfCurrentUserRaisedHand(removeStreamDetails);
								subscribeToAudioOnlyStream(idsToAudioSubscribe[i]);
							}
					}
				if ( window['electron'] ) 
					{
						runStreamsInterval();
					}
			}
		else
			{
				fillUpUsersOnScreenCurrent();
			}
	}
	
	function updateIsVisible(userId, status){
		let updateObject = {"isVisible": status, "subscribeTime": Util.getCurrentTimestamp()};
		collection.updateModel(userId, JSON.stringify(updateObject));
		let addObject = null;
		if ( status )
			{
				addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "onscreen", "userId": currentUserData.id, "toFromId": userId, "details": JSON.stringify({"status":"success"}), "timestamp": Util.getCurrentTimestamp()};	
			}
		else
			{
				addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "offscreen", "userId": currentUserData.id, "toFromId": userId, "details": JSON.stringify({"status":"success"}), "timestamp": Util.getCurrentTimestamp()};
			}
		sessionDataStore.addSessionData(addObject);
		if ( status === true )
			{
				var userDetails = collection.getDetailsById(userId);
				checkIfUserRaisedHand(userDetails);
			}
	}
	
	function updateIsSelected(userId, status){
		let updateObject = {"isSelected": status, "subscribeTime": Util.getCurrentTimestamp()};
		collection.updateModel(userId, JSON.stringify(updateObject));
		
		let currentArray = [];
		if ( window['currentSelected'] )
			{
				currentArray = window['currentSelected'];
			}
		if ( status === true && currentArray.indexOf(userId) == -1)
			{
				currentArray.push(parseInt(userId));
			}
		else if ( status === false )
			{
				let indexNum = currentArray.indexOf(parseInt(userId));
				currentArray.splice(indexNum, 1);
			}
			
		window['currentSelected'] = currentArray;
	}
	
	window.joinSDKAgain = () => {
		
	  $Any('#poorNetwork').text('Reconnecting...');
	  $Any('#poorNetwork').removeClass('d-none');

      let addObject = {"sessionId": currentUserData.sessionData.id, "event": 'connectionState', "eventType": "connectionLost", "userId": currentUserData.id, "details": JSON.stringify({"status":"RTC SDK connection Lost"}), "timestamp": Util.getCurrentTimestamp()};
      sessionDataStore.addSessionData(addObject);
  }

	$Any(document).ready(function(){
	$Any(document).on("click", ".paletteHolder span", function () {
		console.log($Any(this), 'PALETTE HOLDER THIS');
		//console.log($Any(this).parent(), 'PALETTE HOLDER PARENT');
		//console.log($Any(this).parent().parent(), 'PALETTE HOLDER SECOND PARENT');
		
		if ($Any(this).hasClass('canvas-gallery-icon') )
			{
				return false;
			}
			
		var parentElement = $Any(this).parent().parent();
		var splitId = parentElement.attr('id').split('palette');
		var userId = splitId[splitId.length - 1];
		
		startDrawing(this, userId);
		
		if ( $Any(this).hasClass('canvas-color-icon') )
			{
				$Any(this).find('.color-picker-inside')[0].click();
			}

		if ( window['load'+userId] )
			{
				window.showFMSPalette(userId);
				
				if ( !$Any('.screenshot-dropdown').hasClass('d-none') && !$Any(this).hasClass('canvas-gallery-icon') )
					{
						$Any('.screenshot-dropdown').addClass('d-none');
					}
					
				if ( $Any('#canvasNotePopup').css('display') == 'block' && !$Any(this).hasClass('canvas-screenshot-icon') )
					{
						$Any('#closeNotePop').trigger('click');
					}
			}
	});
	
	$Any(document).on("mouseover", ".paletteHolder span", function () {
		if ( $Any(this).attr('data-tooltiptext') )
			{
				var widthDiff = $Any('#paletteTooltip').width()-$Any(this).width();
				
				var posLeft = $Any(this).offset().left - widthDiff/2;
				var posTop = $Any(this).offset().top + $Any(this).height();
				
				$Any('#paletteTooltip').addClass('tooltip_active');
				$Any('#paletteTooltip').offset({ top: posTop, left: posLeft });
				$Any('#paletteTooltip').find('.tooltip_text').html($Any(this).attr('data-tooltiptext'));
			}
		
		if ( $Any(this).hasClass('canvas-line-icon') || $Any(this).hasClass('canvas-joined-icon') || $Any(this).hasClass('canvas-draw-icon') || $Any(this).hasClass('canvas-angle-icon') || $Any(this).hasClass('canvas-square-icon') || $Any(this).hasClass('canvas-circle-icon') )
			{
				$Any('.line-width-hold').removeClass('d-none');
				$Any('.line-width-hold').offset({ left: $Any(this).offset().left });
			}
	});
	
	$Any(document).on("mouseleave", ".paletteHolder span", function (e) {
		$Any('#paletteTooltip').removeClass('tooltip_active');
		
		if ( !$Any(e.toElement).hasClass('tooltip_hold') && !$Any(e.toElement).hasClass('tooltip_text') && !$Any(e.toElement).hasClass('line-width-hold') )
			{
				$Any('.line-width-hold').addClass('d-none');
			}
	});
	
	$Any(document).on("mouseover", ".line-width-hold", function (e) {
		e.preventDefault();
		e.stopPropagation();
	});
	
	$Any(document).on("mouseleave", ".line-width-hold", function (e) {
		$Any('.line-width-hold').addClass('d-none');
	});
	
	$Any(document).on("click", ".canvas-help-icon", function () {
		$Any('#help_menu_popup').show();
	});
	
	$Any(document).off('click', '.canvas-gallery-icon');
	$Any(document).on("click", '.canvas-gallery-icon', function(e) {
		
		e.stopPropagation();
		e.preventDefault();
		
		var elId = this.id;
		var splId = elId.split('Gallery');
		var userId = splId[splId.length - 1];
	
		if ( $Any('#canvasScreenshotDrop'+userId).hasClass('d-none') ) {
				$Any('#canvasScreenshotDrop'+userId).removeClass('d-none');
			}
		else {
			$Any('#canvasScreenshotDrop'+userId).addClass('d-none');
		}
		
		console.log(userId);
	});
	
	window['showNotePopup'] = function(id) {
		var notePopup = $Any('#canvasNotePopup');
		
		$Any('#canvasScreenshotDrop'+id).addClass("d-none");
		notePopup.css({'display': 'block', 'opacity': '1'});
		
		$Any('#bagToolTip'+id).addClass('d-none');
	}
	
	function startDrawing(el, id) {
		console.log('startDrawing 111', el, id);
		let userDetails = collection.getDetailsById(id);
		if ( userDetails.broadcastVideo != true || window['InjectedVideoStarted'] )
			{
				return false;
			}
		
		console.log(id, 'getMainId');
		$Any("#canvasWrap"+id).removeClass("d-none");
		var canvas = $Any("#sessionCanvas"+id);

		if ( !window['userWhiteboard'][id] )
			{
				console.log('LOADED SCRIPT',id);
				//loadWhiteboard();
				
				window['userWhiteboard'][id] = new whiteboard({'user_id': id});
			}
			
		var videoElement = $Any('#video'+ id )[0];
			
		
		var imageCanvas = $Any("#imageCanvas"+id);
		
		if ( window['electron'] && !window['load'+id] )
			{
				var canvasVideo = $Any('#agora_remote_vdo'+id).find('canvas');
				canvasVideo.addClass('zoom1');
				
				$Any('#canvasWrap'+id).addClass('centerCanvasHold');
				$Any('#imageCanvas'+id).css({'top': '50%', 'transform': 'translate(-50%, -50%)'});
				$Any('#gridCanvas'+id).css({'top': '50%', 'transform': 'translate(-50%, -50%)'});
				canvasVideo.removeClass('zoom1');
			}
			
		window['canvasOn'] = true;
		window['canvasOn'+id] = true;
		
		$Any("#maxSelect").addClass('opacityText');
		$Any("#maxuserlimitDisable").removeClass('d-none');
		
		window['turnOffSwitch']();
				
		if ( window['electron'] )
			{
				$Any('#agora_remote_vdo'+id).find('canvas').css({'object-position': 'center top'}).addClass('video-selected');
			}
		else
			{
				$Any('#video'+id).addClass('video-selected');
			}

		let _el = $Any('#agora_remote'+ id);
        _el.find('.microphone-icon').addClass("d-none");
		_el.find('.click-zoom').removeClass('d-block').addClass('d-none');
		
		$Any("#canvasWrap"+id).find('.canvas-close-icon').removeClass('d-none');
		
		if ( el && el.id )
			{
				if ( !window['load'+id] && el.id != 'canvasGallery'+id && el.id != 'canvasShare'+id )
					{
						setTimeout(function() {
							$Any('#'+el.id).trigger('click');
							console.log(el.id);
						}, 500);
					}
				else if ( !window['load'+id] && el.id == 'canvasShare'+id )
					{
						$Any('#canvasLine'+id).trigger('click');
					}
			}
		
		/* if ( el.id == 'canvasShare'+id && window['highlightedElement'+id] && !window['highlightActive'] )
			{
				window['highlightedElement'+id].setAttribute('style', 'background-color:#9b51e0!important;');
			} */
		
		if ( window['resetMouseDown'+id] )
			{
				window['resetMouseDown'+id]();
			}
			
		window['load'+id] = true;
	}
	
	window['startDrawing'] = startDrawing;
	
	$Any(document).on("click", ".canvas-close-icon", function () {
		closeDrawing('', $Any(this).attr('close-id'));
		let userId = $Any(this).attr('close-id');
		updateIsSelected(userId, false);
		if ( !unmuteAllEnabled )
			{
				$Any('#partActiveMic'+userId).trigger('click');
			}
		
	});

	function closeDrawing(mod, userId) {
		if ( $Any('#bagToolTip'+userId).html() == 'Converting video to picture...' && !$Any('#bagToolTip'+userId).hasClass('d-none') && $Any('#noVideoInitials'+userId).hasClass('d-none') )
			{
				return false; 
			}
		
		$Any('.hostToolTip, .walk_tool_hold, .upNext, .actStartHost').addClass('d-none');
		console.log('closeDrawing - ', userId, userArray);
		//window['coneScriptActive'] = false;
		window['canvasOn'] = false;
		$Any("#maxSelect").removeClass('opacityText');
		 $Any('.volume_indicator').removeClass("mic_left_side");
		$Any("#maxuserlimitDisable").addClass('d-none');
		$Any("#maxuserlimit").removeClass('d-none');
		if ( mod != 'auto' )
			{
				mod = 'manual';
			}
		
		if ( window['highlightActive'] ) { $Any('#canvasShare'+window['highlightUserId']).trigger('click'); }
		
		let userCounter = 0;
		userArray.forEach(function(item, index) {
			let id = index;
			let userDetails = collection.getDetailsById(index);
			
			console.log('closeDrawing 111', index);
			
			if ( index != currentUserData['id'] && index != userId && window['highlightActive'] && window['userWhiteboard'][userDetails.id] )
				{
					if (!window['userWhiteboard'][userDetails.id].roomSetup.roomSetupInProgress)
						{
							sendMessage(userDetails['email'], 'closeDraw'+sep+mod);
						}
				}
			console.log('closeDrawing 222', index);
			
			if ( index != currentUserData['id'] && index == userId )
				{
					$Any('#movedEquipmentText'+id).addClass('d-none');
					$Any('#movedEquipment'+id).addClass('d-none');
					$Any('#setupEquipmentHold'+id).addClass('d-none');
				
					let _el = $Any('#agora_remote'+ id);

					$Any('#canvasScreenshotDrop'+id).addClass("d-none");
					//$Any('#palette'+id).addClass("d-none");
					$Any('#repCount'+id).addClass('d-none');
					//window['lastFmsId'] = 0; 
					window['canvasOn'+id] = false;
					window['canvasOn'] = false;
					window.removeFmsPalette(id);
					
					if ( window['load'+id] )
						{
							if (window['userWhiteboard'][id] && !window['userWhiteboard'][id].roomSetup.roomSetupInProgress)
								{
									$Any("#canvasWrap"+id).addClass("d-none");	
									$Any("#canvasWrap"+id).find('.canvas-close-icon').addClass('d-none');
									$Any("#sessionCanvas"+id).css('pointer-events', 'auto');
									window['userWhiteboard'][id].resetCanvas();
									sendMessage(userDetails['email'], 'closeDraw'+sep+mod);
								}
						}
					
					
				}
			else if ( $Any('#agora_remote'+ id).find('.click-zoom').hasClass('d-none') && streamSelectedArray.indexOf(id) > -1 && userCounter == 0 )
				{
					/* window['lastFmsId'] = 0; 
					window.removeFmsPalette(); */
					
					userCounter = 1;
				}
		});
	}
	
	window['closeDrawing'] = closeDrawing;
	
	$Any(document).on("input", ".color-picker-inside", function () {
		console.log(this.value);
		let userId = window['participantDetails']['id'];
		window['userWhiteboard'][userId].mouseActions.strokeColor = this.value;
		window['strokeColor'+userId] = this.value; 
	});
	
	$Any(document).on("input", ".line-width-input", function (e) {
		e.preventDefault();
		e.stopPropagation();
		
		let idStr = ($Any(this).attr('id')).toString();
		let idSpl = idStr.split('canvasLineWidth');
		let id = idSpl[1];
		
		window['linesWidth'+id] = this.value;
		
		if ( window['load'+id] )
			{
				window['updateLineWidth'+id](this.value);
			}
			
		$Any(this).siblings().html(this.value+'px');
	});
	
	$Any(document).on("change", ".line-width-input", function (e) {
		e.preventDefault();
		e.stopPropagation();
		
		let text = 'lineWidth'+sep+this.value;
		sendMessageToChannel(text);
	});
	
	$Any(document).on("click", ".canvas-squat-icon", function () {
		//$Any(this).find('select').trigger('click');
	});
	
	$Any(document).on("change", ".canvas-squat-line", function () {
		console.log(this.value);
		window['changeLineSize'+window['participantDetails']['id']](this.value);
		sendMessage(window['participantDetails']['email'], 'squatLine'+sep+this.value);
	});
	
	$Any(document).on("change", ".palette-dropdown", function () {
		changeDropWidth(this);
		
		if ( window['load'+window['participantDetails']['id']] )
			{
				if ( !$Any('.screenshot-dropdown').hasClass('d-none') )
					{
						$Any('.screenshot-dropdown').addClass('d-none');
					}
					
				if ( $Any('#canvasNotePopup').css('display') == 'block' )
					{
						$Any('#closeNotePop').trigger('click');
					}
			}
		
		/* if ( this.value == 1 )
			{
				$Any('.palette-equipment').addClass('d-none');
				$Any('.palette-drawing').removeClass('d-none');
			}
		else
			{
				$Any('.palette-drawing').addClass('d-none');
				$Any('.palette-equipment').removeClass('d-none');
			} */
	});
	
	function changeDropWidth(el) {
		var text = $Any(el).find('option:selected').text();
		var $aux = $Any('<select/>').append($Any('<option/>').text(text));
		$Any(el).after($aux);
		$Any(el).width($aux.width());
		$aux.remove();
	}
	
	window.changeDropWidth = changeDropWidth;
	
	function checkIfCanvasOn(){
		for ( var i = 0; i<usersOnScreen.length; i++ )
			{
				let userId = usersOnScreen[i];
				
				if ( window['canvasOn'+userId] )
					{
						$Any('#closeBtn'+userId).trigger('click');
					}
			}
	}
	
	window['checkIfCanvasOn'] = checkIfCanvasOn;
	
	$Any('.canvas-note-textarea').on("input", function() {
		$Any(this).css('border', '2px solid #b002ed');
	});
	
	$Any(document).on("click", "#saveCanvasNote", function () {
		var img = window['canvasScreenshot'];
		var note = $Any('#canvasNotePopup').find('textarea').val().trim();
		var partId = 0;
		if ( window['userIdForImage'] && window['userIdForImage'] != 0 )
			{
				partId = window['userIdForImage'];
			}
		var activityId = 0;
		
		if ( $Any('.swiper-slide-next').length && $Any('.swiper-slide-next').length > 0 && !$Any('.swiper-slide-next').hasClass('end') )
			{
				var currentActIndex = $Any('.swiper-slide-next .data-slide').attr('data-index');  
		
				activityId = currentUserData.sessionData.scriptDetail[currentActIndex-1]['id'];
				console.log('ACTIVITY ID', activityId);
			}
		
		if ( note.length == 0 ) { $Any('#canvasNotePopup').find('textarea').css('border', '2px solid #ff0000'); return false; }
		
		$Any('.main_loader').attr({'style':'display:flex'});
		
		var sessionImageData = {
				image : img,
				partId : partId,
				note : note,
				activityId: activityId,
				userData: localStorage.getItem("userData")
		  };
		 
		console.log(sessionImageData);
		
		  $.ajax({
			  headers: { 
				  "Content-Type": "application/json; charset=utf-8"
			  },
			  url: Const.BASE_API_PATH+'/api/v1/session/'+currentUserData['sessionData']['id']+'/saveSessionNote',       
			  dataType: 'json',
			  type: 'post',
			  data: JSON.stringify(sessionImageData),
			  success: function( data, textStatus, jQxhr ){                         
				  console.log(data);
				  getSessionNotes(partId);
				  $Any('.main_loader').hide();
				  window['globalRTM'](window['allPartDetails'][partId]['email'], 'getParticipantNotes'+sep);
				  window['userIdForImage'] = 0;
			  },
			  error: function( jqXhr, textStatus, errorThrown ){
				  console.log( errorThrown );
				  $Any('.main_loader').hide();
				  window['userIdForImage'] = 0;
			  }
		  });
		
		$Any('#canvasNotePopup').css({'opacity': '0', 'display': 'none'});
		$Any('#canvasNotePopup').find('textarea').val('');
		if ( window['resetImageCanvas'+partId] )
			{
				window['resetImageCanvas'+partId]();
			}
	});
	
	$Any(document).on("click", "#closeNotePop", function () {
		$Any('#canvasNotePopup').css({'opacity': '0', 'display': 'none'});
		$Any('#canvasNotePopup').find('textarea').val('');
		window['resetImageCanvas'+window['participantDetails']['id']]();
		window['userIdForImage'] = 0;
	});
	
	$Any(document).on("click", ".canvas-note-hold", function () {
		if ( !$Any(this).hasClass('no-img') )
			{
				var noteId = $Any(this).attr('data-id');
				console.log('Note id:', noteId);
				
				var noteImg = $Any(this).find('.note-img').css('background-image');
				var noteDate = $Any(this).find('.note-img').attr('data-date');
				
				var date = new Date(noteDate);
				
				noteImg = noteImg.replace('url(','').replace(')','').replace(/\"/gi, "");
				var noteText = $Any(this).find('.note-text').html();
		
				var hours = date.getHours();
				var minutes = date.getMinutes();
				var ampm = hours >= 12 ? 'PM' : 'AM';
				hours = hours % 12;
				hours = hours ? hours : 12; // the hour '0' should be '12'
				minutes = minutes < 10 ? '0'+minutes : minutes;
				var strTime = hours + ':' + minutes + ' ' + ampm;
				var fullDate = (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
		
				$Any('#viewNoteImg').attr('src', noteImg);	
				$Any('#viewNoteText').html(noteText);
				$Any('#viewNoteDate').html('Time added: ' + fullDate);
				$Any('#viewNotePopup').css({'display': 'block', 'opacity': '1'});
				$Any('#deleteNote').attr('data-id', noteId);
				$Any('.screenshot-dropdown').addClass('d-none');
			}
	});
	
	$Any(document).on("click", "#statistic_participants", function () {
		window.displayParticipants(true);
	});
	
	
	$Any(document).on("click", "#closeNoteView", function () {
		$Any('#viewNotePopup').css({'opacity': '0', 'display': 'none'});
	});
	
	$Any(document).on("click", ".close-note-view", function () {
		$Any('#closeNoteView').trigger('click');
	});
	
	$Any(document).on("click", "#deleteNote", function () {
		var noteId = $Any(this).attr('data-id');
		var sessionId = currentUserData['sessionData']['id'];
		var partId = window['participantDetails']['id'];
		console.log('Note id:', noteId);
		
		$Any('#viewNotePopup').css({'opacity': '0', 'display': 'none'});
		
		$Any('.main_loader').attr({'style':'display:flex'});
		
		var noteData = {
				noteId : noteId,
				sessionId: sessionId
		  };
		 
		console.log(noteData);
		
		  $.ajax({
			  headers: { 
				  "Content-Type": "application/json; charset=utf-8"
			  },
			  url: Const.BASE_API_PATH+'/api/v1/session/'+sessionId+'/deleteSessionNote',       
			  dataType: 'json',
			  type: 'post',
			  data: JSON.stringify(noteData),
			  success: function( data, textStatus, jQxhr ){                         
				  console.log(data);
				  getSessionNotes(partId);
				  window['globalRTM'](window['allPartDetails'][partId]['email'], 'getParticipantNotes'+sep);
				  $Any('.main_loader').hide();
			  },
			  error: function( jqXhr, textStatus, errorThrown ){
				  console.log( errorThrown );
				  $Any('.main_loader').hide();
			  }
		  });
	});
	$Any(document).off('click', '.canvas-share');
	var highInterval;
	$Any(document).on("click", ".canvas-share", function () {
		let userId = $Any(this).attr('id').split('canvasShare')[1];
		
		console.log('highlight participantId', userId, window['allowParticipantHighlight']);
		
		if ( window['allowParticipantHighlight'] )
			{
				userId = window['highlightUserId'];
				
				window['allowParticipantHighlight'] = false;
				window['highlightActive'] = false;
				clearInterval(highInterval);
				//$Any('.canvas-share').html('Share to all');
				$Any('.canvas-share').removeClass('remove-share-all-icon');
				let text = 'removeHighlight'+sep+currentUserData['id']+sep+userId;
				sendMessageToChannel(text);
				
				$Any('.participantStreamPart').each(function(item, index){
					let parIdMain = $Any(this).attr('id').split('participant_agora');
					let parId = parseInt(parIdMain[1]);
					  if ( parId != currentUserData.id && window['canvasOn'+parId] )
						{
							var canvasSize = {};
							canvasSize['w'] = 1280;
							canvasSize['h'] = 720;
							if ( window['userWhiteboard'][parId] )
								{
									window['userWhiteboard'][parId].splitRTMSend([parId]['email'], text);
								}
							//window['SRTM'](window['allPartDetails'][parId]['email'], 'draw'+sep+JSON.stringify(window['canvasLines'+parId])+'cSize'+JSON.stringify(canvasSize));
							window['globalRTM'](window['allPartDetails'][parId]['email'], 'grid'+sep+(window['gridOn'+parId] ? 1 : 0 )+sep+window['gridColor'+parId]);
						}
				 });
			}
		else
			{
				window['highlightUserId'] = userId;
				
				window['allowParticipantHighlight'] = true;
				window['highlightActive'] = true;
				saveParId = userId;
				let text = 'highlightParticipant'+sep+userId;
				sendMessageToChannel(text);
				window['highlightChanges']();
				//$Any('.canvas-share').html('Remove Share');
				$Any('.canvas-share').addClass('remove-share-all-icon');
			}
		console.log(window['allowParticipantHighlight'], 'allowParticipantHighlight');
		
		console.log(window['participantDetails']['id'], 'GETID');
	});
	
	$Any(document).on("click", ".walk_tool_hold", function () {
		if ( currentUserData.sessionData.manualAutomaticScript != 1 )
			{
				window.playNextScript();
			}
		else
			{
				window.playSlider();
			}
		
		$Any('.hostToolTip, .walk_tool_hold, .upNext, .tooltipText').addClass('d-none');
	});
		
	window['highlightChanges'] = function() {
		console.log('work');
		window['userArray'] = userArray;
		window['currentUserData'] = currentUserData;
		let gridMsgSent = false;
		userArray.forEach(function(item, index) {
			if ( index != currentUserData['id'] && index != window['highlightUserId'] )
				{
					let userDetails = collection.getDetailsById(index);
					
					let id = window['highlightUserId'];
					
					//let equipment = window['shareEquipment'+id]();
					var canvas = $Any("#sessionCanvas"+id);
					var canvasSize = {};
					canvasSize['w'] = canvas.width;
					canvasSize['h'] = canvas.height;
					
					//let text = 'draw'+sep+JSON.stringify(window['canvasLines'+id])+'cSize'+JSON.stringify(canvasSize);
					let text = 'highlightDraw'+sep+JSON.stringify(window['canvasLines'+id])+'cSize'+JSON.stringify(canvasSize)+sep+window['highlightUserId'];
					
					if ( window['userWhiteboard'][userDetails.id] )
						{
							window['userWhiteboard'][userDetails.id].splitRTMSend(userDetails.email, text);
						}
									
					if ( window['gridOn'+id] )
						{
							window['globalRTM'](window['allPartDetails'][userDetails.id]['email'], 'grid'+sep+(window['gridOn'+id] ? 1 : 0 )+sep+window['gridColor'+id]);
							if ( !gridMsgSent )
								{
									gridMsgSent = true;
									window['globalRTM'](window['allPartDetails'][id]['email'], 'grid'+sep+(window['gridOn'+id] ? 1 : 0 )+sep+window['gridColor'+id]);
								}
						}
				}
		});
	}
	
	function resizedw() {
		console.log('window resized');
		
		if ( window['participantDetails'] )
			{
				let id = window['participantDetails']['id'];
		
				var canvas = $Any("#sessionCanvas"+id);
				var imageCanvas = $Any("#imageCanvas"+id);
				
				if ( canvas )
					{
						var videoElement = $Any('#video'+ id )[0];
						if ( window['load'+id] ) { window['userWhiteboard'][id].drawLines(); }
					}
			}
	}

	var doit;
	$Any(window).resize(function() {
		clearTimeout(doit);
		doit = setTimeout(resizedw, 100);
	});
	
	var activity = currentUserData.sessionData.scriptDetail;
	for ( var i = 0; i < activity.length; i++ )
		{
			for ( var a = 0; a < activity[i].attribute.length; a++ )
				{
					if ( activity[i].attribute[a].attrLabel === 'Activity Type' )
						{
							if ( activity[i].attribute[a].attrValue === 'Virtual Assistant' || activity[i].attribute[a].attrValue === 'Virtual Equipment' )
								{
									window['hasConeScript'] = true;
								}
						}
				}
		}
	
	if ( window['userWhiteboard'][currentUserData.id] && window['scriptLoaded'] && window['preStreamingWhite'] )
		{
			window['preStreamingWhite'] = false;
			window['userWhiteboard'][currentUserData.id].loadElements();
		}
	
  });

  function getSessionNotes(id) {
		var hostId = currentUserData['id'];
		var partId = id;
		var sessionId = currentUserData['sessionData']['id'];
		
		var sessionData = {
				hostId : hostId,
				partId : partId,
				sessionId: sessionId
		};
		
		var data_op = JSON.parse(localStorage.getItem("userData"));
		$.ajax({headers: {"Content-Type": "application/json; charset=utf-8", "Authorization": data_op.token},
		  url: Const.BASE_API_PATH +'/api/v1/session/'+sessionId+'/getSessionNotes',
		  type: 'post',
		  dataType: 'json',
		  data: JSON.stringify(sessionData),
		  success: function( data, textStatus, jQxhr )
		  {
			if ( data.responseData )
				{
					var notesArr = data.responseData;
					
					$Any('#canvasScreenshotDrop'+id).html('');
					
					if ( notesArr.length == 0 )
						{
							$Any('#canvasScreenshotDrop'+id).append('<div class="canvas-note-hold no-img">'+
																	'<div class="note-text">No saved images yet</div>'+
																 '</div>');
						}
					else
						{
							for ( var i = 0; i < notesArr.length; i++ )
								{
									$Any('#canvasScreenshotDrop'+id).append('<div class="canvas-note-hold" data-id="'+notesArr[i]['id']+'">'+
																			'<div class="note-img" data-date="'+notesArr[i]['time']+'" style="background-image: url('+notesArr[i]['file']+')"></div>'+
																			'<div class="note-text-holder">'+
																				'<div class="note-text">'+notesArr[i]['note']+'</div>'+
																			'</div>'+	
																		 '</div>');
									
									if ( i < notesArr.length - 1 )
										{
											$Any('#canvasScreenshotDrop'+id).append('<div class="bottom-line"></div>');
										}
								}
						}
				}
		  }});
  }

  function getWhiteboardValues() {
	  var data_op = JSON.parse(localStorage.getItem("userData"));
	  $.ajax({headers: {"Content-Type": "application/json; charset=utf-8", "Authorization": data_op.token},
		  url: Const.BASE_API_PATH +'/api/v1/session/whiteboardValues',
		  type: 'post',
		  dataType: 'json',
		  success: function( data, textStatus, jQxhr ) {
			  if ( data.responseData )
				{
					currentUserData.whiteboardValues = data.responseData;
					localStorage.setItem('userData', JSON.stringify(currentUserData));
					window['strokeColor'] = currentUserData.whiteboardValues.defaultColor;
					$Any('.color-picker-inside').val(window['strokeColor']);
					window['linesWidth'] = parseInt(currentUserData.whiteboardValues.lineW);
					window.currentUserData = currentUserData;
					$Any('.line-width-text').html(window['linesWidth']+'px');
					$Any('.line-width-input').val(window['linesWidth']);
				}
	  }});
  }
  
  getWhiteboardValues();

  function getRoomPhotos() {
		var sessionId = currentUserData['sessionData']['id'];
		
		var sessionData = {
			sessionId: sessionId
		};
		
		var data_op = JSON.parse(localStorage.getItem("userData"));
		$.ajax({headers: {"Content-Type": "application/json; charset=utf-8", "Authorization": data_op.token},
		  url: Const.BASE_API_PATH +'/api/v1/session/'+sessionId+'/getRoomPhotos',
		  type: 'post',
		  dataType: 'json',
		  data: JSON.stringify(sessionData),
		  success: function( data, textStatus, jQxhr )
		  {
			if ( data.responseData )
				{
					console.log(data.responseData, 'room photos');
					window['roomPhotos'] = data.responseData;
				}
		  }});
  }

  getRoomPhotos();

  function pauseActivity(showMessage, playSound, stopAct, drawingOn?) {
	  
	   if ( $Any('.video-holder').length == 1 && window['deviceNotSupported'+$Any('.video-holder').attr('id')] )
		{
			return false;
		}
	  
	  /*---drawingOn added when u need to stop Activity if drawing is on ---*/
		window['activityEnded'] = true;
		let activeEle = $Any('.swiper-slide.swiper-slide-next');
		var countdownNumberEl = activeEle.find('.countdown-number');
		let act_type = window['checkActivityType'](window['currentActNum']-1);
		let act_type_next = window['checkActivityType'](window['currentActNum']);
		var activityLength = currentUserData.sessionData.scriptDetail.length;
		let script_name = window['checkActivityName']($Any('.swiper-slide-next .data-slide').attr('data-index'));
		var playAllDone = false;
		let currentIndex = $Any('.swiper-slide-next .data-slide').attr('data-index')-1;
		let syncMessage = RTMConst.SYNC_MANUAL+sep+currentIndex;
		sendMessageToChannel(syncMessage);
		
		if ( window['highlightActive'] ) { $Any('#canvasShare'+window['highlightUserId']).trigger('click'); }
			
		let onScreenUsersInfo = parseInt($Any('#maxuserlimit').val());
		window['onScreenUsers'](onScreenUsersInfo);
		
		if ( showMessage ) 
			{ 
				let nextMessage = currentUserData.sessionData.manualAutomaticScript == 1 ? 'Start' : 'Next';
				let currentHostSettings = JSON.parse(localStorage.getItem("hostSettings"));
				
				var stopAct = false;
				  $Any('.participantStreamPart').each(function(item, index){
				   let parId = $Any(this).attr('id');
					  if ( parId != currentUserData.id )
						{
							if ( ( window['canvasLines'+parId] && window['canvasLines'+parId].length > 0 ) || window['gridOn'+parId] )
								{
									stopAct = true;
								}
						}
				 });
				 $Any('.participantStreamPart').each(function(item, index){
				    let parIdMain = $Any(this).attr('id').split('participant_agora');
				    let userId = parseInt(parIdMain[1]);
					var cancelAct = false;
					
					if ( window['deviceNotSupported'+userId] ) { return false; }
					
					if ( userId != currentUserData.id )
						{
							if ( window['canvasLines'+userId] && window['canvasLines'+userId].length > 0 )
								{
									cancelAct = true;
								}
						}
					
					if ( currentUserData.sessionData.manualAutomaticScript != 1 || stopAct || cancelAct )
						{
							let _el = $Any('.swiper-slide.swiper-slide-next');
							let scriptLength = $Any('.swiper-slide .data-slide').length;
							let scriptIndex = parseInt(_el.find('.data-slide').attr('data-index'));
				
							if ( scriptIndex < scriptLength )
								{
									$Any('#activityStart').html('Next: '+script_name); 
									//$Any('#activityStart').removeClass('d-none');
								}
							
						}
					
					if ( !window['viewCaptured'+userId] && !window['roomSetupDone'+userId] && ( !drawingOn || act_type_next == 'Virtual Equipment' || act_type_next == 'Virtual Assistant' ) )
						{
							$Any('#newToolTip'+userId).find('.tooltipText').html(act_type_next);
							$Any('#innerPartText'+userId).html('Time to get the room setup!');
							
							if ( currentHostSettings['turnoffRoomSetup'] == 1 ) 
								{
									$Any('#activityStart').html('Start Room Setup'); 
									$Any('#activityStart').removeClass('d-none');
								}
							$Any('#newToolTip'+userId).removeClass('d-none');
							$Any('#newToolTip'+userId).find('.upNext').removeClass('d-none');
							
							soundPlay.playAudio('startRoomSetup');
						}
					
				});
				let showHide = true;
				console.log(act_type_next, currentUserData.firstName, 'TTTTTTTEST');
				if ( !drawingOn )
					{
						let text = 'pauseBeforeEquipment'+sep+showHide+sep+act_type_next+sep+currentUserData.firstName;
						sendMessageToChannel(text);
					}
				
			}
		var virtualType;
		for(var a = 0; a<activityLength; a++)
			{
				virtualType = window['checkActivityType'](a);
				if ( virtualType == 'Virtual Equipment' || virtualType == 'Virtual Assistant' )
					{
						playAllDone = a;
					}
			}
		setTimeout(function(){
			countdownNumberEl.text(0) ;
			$Any('#script_time').text(0) ;
			$Any('#activityCounter .counter-number').text(0) ;
			console.log(playAllDone, 'playAllDone');
			if ( playSound )
				{
					if ( playAllDone == $Any('.swiper-slide-next .data-slide').attr('data-index')-1 ) 
						{
							window['allDoneSound']();
							$Any('#partToolTip').removeClass('d-none');
							$Any('#partToolTip .tooltipText').html('All done!');
							setTimeout(function(){
								$Any('#partToolTip .tooltipText').html('');
								$Any('#partToolTip').addClass('d-none');
							}, 3000);
						}
					else
						{
							//if ( window['updateOverSound'] ) { window['updateOverSound'](); }
						}
				}
				
			activeEle.find('svg circle').css({"animation":"countdown 0s linear infinite forwards", "animation-direction": "reverse"});
			activeEle.find('svg circle').css({"animation-play-state":"paused"});
		}, 1000);
	}

  window['pauseActivity'] = pauseActivity;
  
	window['allPartDetails'] = {};
	function getParticipantInfo(userId) {
		console.log('addUserPallete 111');
		if ( !userId )
			{
				userArray.forEach(function(item, index){
					if ( index != currentUserData['id'] )
						{
							let id = index;
							Util.appendUserPalette(id);
							getSessionNotes(id);
							if ( window['updateWorkoutPosition'] ) { window['updateWorkoutPosition'](id, 'hostInfo'); }
							window['allPartDetails'][id] = collection.getDetailsById(id);
							
							console.log(window['allPartDetails'], 'allPartDetails');
						}
				});
			}
		else
			{
				console.log('addUserPallete 222');
				Util.appendUserPalette(userId);
				getSessionNotes(userId);
				if ( window['updateWorkoutPosition'] )
					{
						window['updateWorkoutPosition'](userId, 'hostInfo');
					}
				window['allPartDetails'][userId] = collection.getDetailsById(userId);
			}
	}
	
	getParticipantInfo();
  
  window.showFMSPalette = (id) => {
	  $Any('.paletteHolder').addClass("d-none");
	  
	  var isVirtualActive = false;
	  let act_type = window['checkActivityType'](window['currentActNum']-1);
	  let next_act_type = window['checkActivityType'](window['currentActNum']);
	  if ( act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant' || (act_type == 'Pause' && (next_act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant')) ) { isVirtualActive = true; }
	  
	  if ( window['enabledFms'] && window['sessionStarted'] && !isVirtualActive && ( !window['userWhiteboard'] || !window['userWhiteboard'][id] || !window['userWhiteboard'][id].roomSetup.roomSetupInProgress ) && !window['injectedVideoInProgress'])
		{
			$Any('#palette'+id).removeClass("d-none");
			$Any('.host_header').addClass("d-none");
			$Any('.participant_view_container').addClass("d-none");
			$Any('.paletteFlex').removeClass("d-none");
			$Any('#participant_agora'+id).addClass('participant_fms_selected');
			window['lastFmsId'] = id;
		}
  }
  
  window.removeFmsPalette = (id) => {
	  let closeAllPalette = false;
	  $Any('#palette'+id).addClass("d-none");
	  if ( $Any('#participant_agora'+id).hasClass('participant_fms_selected') )
		  {
			 $Any('#participant_agora'+id).removeClass('participant_fms_selected');
			 closeAllPalette = true;
		  }
		  
	  if ( closeAllPalette )
		  {
			  window['lastFmsId'] = 0;
			  $Any('.paletteHolder').addClass("d-none");
			  $Any('.host_header').removeClass("d-none");
			  $Any('.participant_view_container').removeClass("d-none");
			  $Any('.paletteFlex').addClass("d-none");
		  }
  }
  
  window['checkActivityType'] = function(ind) {

		if ( !currentUserData.sessionData.scriptDetail || !currentUserData.sessionData.scriptDetail[ind] || !currentUserData.sessionData.scriptDetail[ind]['attribute'] || !currentUserData.sessionData.scriptDetail[ind]['attribute'][0] || !currentUserData.sessionData.scriptDetail[ind]['attribute'][0]['attrValue'] ) { return ''; }
		
		return currentUserData.sessionData.scriptDetail[ind]['attribute'][0]['attrValue'];
  }
  
  function changeBoxingPosition(pos,bag) {
	//window['globalRTM'](currentUserData['sessionData']['hostEmail'], 'changeBoxingPosition'+sep+pos+sep+bag+sep);
	if ( window['userWhiteboard'][currentUserData.id] ) 
		{ 
			window['userWhiteboard'][currentUserData.id].splitRTMSend(currentUserData.id, 'changeBoxingPosition'+sep+pos+sep+bag+sep);
		}
  }
  
  window.changeBoxingPosition = changeBoxingPosition;
  
  function removeWhiteboard(deleteId) {
	  if ( window['userWhiteboard'] )
		{
			for ( var userId of Object.keys(window['userWhiteboard']) ) 
				{
					var doDelete = true;
					if ( deleteId && userId != deleteId ) { doDelete = false; }
				  
					if ( window['userWhiteboard'][userId] && doDelete )
						{
							clearInterval(window['userWhiteboard'][userId].updateInterval);
							if ( window['userWhiteboard'][userId].perMinuteInterval ) { clearInterval(window['userWhiteboard'][userId].perMinuteInterval); }
							
							window['userWhiteboard'][currentUserData.id].soundPlay.stopAudio();
							
							window.removeUserWhiteboard(parseInt(userId));
						}
				}
			
			if ( !deleteId )
				{
					window.pendingVirtualDraw = false;
					window.allUsersList = [];
					window.currentVirtualDraw = 0;
					
					window['userWhiteboard'] = {};
				}
			else if ( window['userWhiteboard'][deleteId] )
				{
					if ( window.currentVirtualDraw == deleteId ) 
						{ 
							var nextUser = window.currentVirtualDraw ? window.allUsersList.indexOf(window.currentVirtualDraw) + 1 : 0;
							if ( nextUser == window.allUsersList.length ) { nextUser = 0; }
							window.currentVirtualDraw = window.allUsersList[nextUser]; 
						}
						
					if ( window.allUsersList.indexOf(deleteId) > -1 ) { window.allUsersList.splice(window.allUsersList.indexOf(deleteId), 1); }
					
					delete window['userWhiteboard'][deleteId];
				}
		}
  }
  
  window.removeWhiteboard = removeWhiteboard;
  
  function insertStoredRTM() {
	  if ( rtmStoreMessages && !$.isEmptyObject(rtmStoreMessages) )
		  {
			  storeRTM(JSON.stringify(rtmStoreMessages), window['currentTimeClass']);
			  rtmStoreMessages = {};
		  }
  }
  
   window.insertStoredRTM = insertStoredRTM;
  
  function completeRoomSetup(userId) {
		streamArray.forEach((stream) => {
			if ( stream.getId() != undefined && stream.getId() == userId && window['preStreamingRoomSetup'+userId] ) 
				{
					 if ( !window['userWhiteboard'][userId] )
						{
							console.log('loadPreWhiteboard 5555');
							console.log('LOADED SCRIPT',userId);
							
							window['userWhiteboard'][userId] = new whiteboard({'user_id': userId});
							console.log('loadPreWhiteboard 666');
							window['load'+userId] = true;
						}
					console.log('loadPreWhiteboard 777');
					window['userWhiteboard'][userId].roomSetup.finishWorkoutSetupHost(window['preStreamingWASLocation'+userId]);
				}
		});
  }
  
  let addObject = {"sessionId": currentUserData.sessionData.id, "event": "status", "eventType": "joinClass", "userId": currentUserData.id, "details": JSON.stringify({"msg": "User entered session"}), "timestamp": Util.getCurrentTimestamp()};
	sessionDataStore.addSessionData(addObject);
}

export default startHostStreaming;